// Arabic translations

export default {
  settings: {
    title: "إعدادات النظام",
    description: "إدارة جميع إعدادات النظام من مكان واحد بكفاءة وسهولة",
    refresh: "تحديث البيانات",
    selectSection: "اختر قسمًا لعرضه",
    selectSectionDescription: "اضغط على أحد الأزرار أعلاه لعرض محتوى القسم المطلوب",
    general: "الإعدادات العامة",
    generalDesc: "إعدادات الشركة وساعات العمل",
    theme: {
      sidebarOrder: {
        title: "تخصيص ترتيب القائمة الجانبية",
        description: "اسحب العناصر لإعادة ترتيبها من الأكثر أهمية إلى الأقل أهمية",
        tutorial: "شرح",
        reset: "إعادة تعيين",
        howToSort: "كيفية ترتيب عناصر القائمة الجانبية:",
        step1: "انقر واضغط على أيقونة السحب (⋮⋮) على أي عنصر",
        step2: "اسحبه لأعلى أو لأسفل إلى الموضع المفضل لديك",
        step3: "اتركه لإسقاطه. يتم حفظ الترتيب تلقائياً!",
        example: "مثال:",
        moveUp: "نقل لأعلى",
        moveDown: "نقل لأسفل",
        orderSavedAuto: "تم حفظ الترتيب تلقائياً",
        savedSuccess: "تم حفظ ترتيب القائمة الجانبية بنجاح!",
        resetSuccess: "تم إعادة تعيين ترتيب القائمة الجانبية إلى الافتراضي!",
        resetConfirmTitle: "إعادة تعيين ترتيب القائمة الجانبية؟",
        resetConfirmMessage: "هل أنت متأكد من إعادة تعيين ترتيب القائمة الجانبية إلى الافتراضي؟ لا يمكن التراجع عن هذا الإجراء.",
        cancel: "إلغاء"
      }
    },
    themeDesc: "تخصيص الألوان والمظهر",
    location: "الموقع",
    locationDesc: "إدارة مواقع الشركة",
    departments: "أقسام الشركة",
    departmentsDesc: "تحديد أقسام الشركة",
    deduction: "إعدادات التأخير",
    deductionDesc: "قواعد خصم التأخير",
    holidays: "الأجازات الرسمية",
    holidaysDesc: "إدارة تقويم الإجازات الرسمية للشركة",
    ai: "إعدادات الذكاء الاصطناعي",
    aiDesc: "إعدادات نماذج الذكاء الاصطناعي",
    language: "إعدادات اللغة",
    languageDesc: "اختر لغة الواجهة",
    company: "معلومات الشركة",
    companyDesc: "عرض وتعديل معلومات الشركة",
    help: {
      timezone: "تُستخدم لتحديد توقيت الحضور والرواتب والإشعارات. اختر المنطقة الزمنية لموقع الشركة الفعلي.",
      workStart: "وقت بداية العمل الافتراضي للمنظمة. إن وُجد شيفت للموظف يُستخدم وقت الشيفت بدلًا من هذا.",
      workEnd: "وقت نهاية العمل الافتراضي للمنظمة. الشيفت المعيَّن للموظف له أولوية إن وُجد.",
      gracePeriod: "دقائق بعد بداية الشيفت لا يُعتبر فيها الموظف متأخرًا. ملاحظة: إن كان للموظف شيفت، تُستخدم فترة السماح الخاصة بالشيفت أولًا.",
      workDays: "أيام الأسبوع التي تُحتسب أيام عمل رسمية (حضور وغياب ورواتب).",
      annualLeaveDays: "عدد أيام الإجازة السنوية الممنوحة لكل موظف خلال السنة.",
      sickLeaveDays: "عدد أيام الإجازة المرضية المسموح بها خلال السنة.",
      leaveSettings: "إعدادات رصيد الإجازات السنوية والمرضية، وهل يُرحَّل الرصيد غير المستخدم للسنة التالية.",
      carryForward: "هل يُسمح بنقل أيام الإجازة السنوية غير المستخدمة إلى السنة التالية؟ إن كان معطّلًا يضيع الرصيد المتبقي مع نهاية السنة.",
      maxCarryForward: "أقصى عدد أيام يمكن ترحيلها للسنة التالية عند تفعيل السماح بالترحيل. أي زيادة عن هذا الحد لا تُرحَّل.",
      overtimeEnabled: "تفعيل احتساب العمل الإضافي بعد ساعات الشيفت الرسمية.",
      overtimeMultiplier: "أجر الساعة الإضافية: ساعة، ساعتين، أو أكثر.",
      overtimeMinimumHours: "أقل ساعات إضافية قبل ما يبدأ الحساب.",
      overtimeCalculationMethod: "كيف تُجمَّع ساعات الإضافي: يوميًا أو أسبوعيًا أو شهريًا قبل الحساب.",
      attendanceExempt: "إعفاء أنواع معينة من مواقع العمل من تسجيل الحضور/الانصراف (مثل المناديب أو العمل عن بُعد).",
      absencePenalty: "عدد أيام الراتب التي تُخصم عند الغياب غير المصرح به.",
      shifts: "الشيفت يحدد مواعيد العمل وفترة السماح للموظفين المعيَّنين عليه، وله أولوية على إعدادات المنظمة.",
      shiftGracePeriod: "فترة السماح لهذا الشيفت فقط. بعد انتهائها تُسجَّل الحالة «متأخر». قواعد الخصم المالية منفصلة في إعدادات التأخير.",
      latePenaltyEnabled: "تفعيل خصم تلقائي عند التأخير حسب القواعد أدناه. الحالة «متأخر» وخصم المبلغ ليسا نفس الشيء.",
      latePenaltyRules: "كل قاعدة تربط مدة التأخير (من بداية الشيفت) بنوع خصم: ربع يوم / نصف يوم / يوم كامل / مبلغ مخصص.",
      delayMinutes: "عدد الدقائق من بداية الشيفت التي عند بلوغها أو تجاوزها تُطبَّق هذه القاعدة.",
      penaltyType: "نوع الخصم: نسبة من الراتب اليومي (ربع/نصف/كامل) أو مبلغ مخصص.",
      autoCheckoutEnabled: "انصراف تلقائي للموظف إذا نسي تسجيل الخروج بعد نهاية الشيفت.",
      autoCheckoutGraceHours: "كم ساعة بعد نهاية الشيفت يُنتظر قبل تنفيذ الانصراف التلقائي.",
      autoCheckoutCountOvertime: "هل تُحتسب الساعات بين نهاية الشيفت والانصراف التلقائي كساعات إضافية؟",
      autoCheckoutDeductionPolicy: "الخصم عند انصراف النظام تلقائياً لو الموظف نسي تسجيل الخروج. الفروع تقدر تتبع الشركة أو تخصص سياسة مختلفة.",
      checkInSelfieMode: "هل صورة الحضور معطّلة أو اختيارية أو إجبارية لأنواع العمل المحددة.",
      checkInSelfieApplyTo: "أنواع مواقع العمل التي تُطبَّق عليها سياسة صورة الحضور (مكتب، عن بُعد، هجين، توصيل).",
      sectionDeduction: "من هنا تضبط قواعد غرامات التأخير (مثل: بعد 30 دقيقة = ربع يوم).",
      sectionHolidays: "أضف الإجازات الرسمية حتى لا يُحتسب اليوم غيابًا على الموظفين.",
      sectionLanguage: "غيّر لغة واجهة النظام (عربي / إنجليزي / ألماني).",
      sectionCompany: "بيانات الشركة، ساعات العمل، الشيفتات، الإجازات، والعمل الإضافي.",
    },
    generalSettings: {
      title: "الإعدادات العامة",
      description: "إدارة إعدادات الشركة وساعات العمل الرسمية والفواصل",
      workDays: "أيام عمل",
      infoTitle: "معلومات حول الإعدادات",
      infoDescription: "يمكنك من خلال هذه الصفحة إدارة جميع الإعدادات العامة للمؤسسة بما في ذلك ساعات العمل، الفواصل، وأيام العمل الأسبوعية.",
      generalInfo: "المعلومات العامة",
      companyName: "اسم الشركة",
      companyNamePlaceholder: "أدخل اسم الشركة",
      timezone: "المنطقة الزمنية",
      timezonePlaceholder: "اختر المنطقة الزمنية",
      gracePeriod: "فترة السماح (دقائق)",
      gracePeriodPlaceholder: "مثال: 30",
      minPresentHours: "الحد الأدنى لساعات الحضور",
      minPresentHoursPlaceholder: "مثال: 4",
      overtimeRate: "معدل الوقت الإضافي",
      overtimeRatePlaceholder: "مثال: 1.5",
      dailyWorkingHours: "ساعات العمل اليومية",
      attendanceAdjustment: "تفعيل خصم التأخير و مكافأه الوقت الاضافي التلقائي",
      remoteDeduction: "تفعيل  خصم التأخير من الموظفين (عن بعد)",
      workHours: "مواعيد العمل",
      startTime: "وقت البدء",
      endTime: "وقت الانتهاء",
      workDaysLabel: "أيام العمل",
      selectAtLeastOneWorkDay: "يرجى اختيار يوم عمل واحد على الأقل",
      breaks: "تحديد وقت الاستراحه اليومي",
      addBreak: "إضافة فاصل",
      breakNumber: "فاصل",
      from: "من",
      to: "إلى",
      startTimePlaceholder: "وقت البدء",
      endTimePlaceholder: "وقت الانتهاء",
      workTimeRangeRequired: "يرجى تحديد وقت بداية ونهاية العمل",
      workTimeRangeInvalidFormat: "صيغة الوقت غير صحيحة (HH:mm)",
      workTimeRangeSame: "وقت البداية والنهاية لا يمكن أن يكونا متطابقين",
      documentManagement: "إدارة المستندات",
      documentDescription: "سوف يتم إرسال تلك المستندات إلى جميع الموظفين",
      uploadNewDocument: "رفع مستند جديد",
      uploadedDocuments: "المستندات المرفوعة",
      noDocuments: "لا توجد مستندات مرفوعة",
      size: "الحجم",
      uploadDate: "تاريخ الرفع",
      delete: "حذف",
      uploading: "جاري الرفع...",
      uploadDocument: "رفع المستند",
      refreshData: "تحديث البيانات",
      saveChanges: "حفظ التغييرات",
      editMode: "وضع التعديل",
      loading: "جاري التحميل...",
      hours: "ساعات",
      minutes: "دقيقة",
      hoursAndMinutes: "ساعات و",
      tokenNotFound: "لم يتم العثور على رمز التوثيق",
      loadFailed: "فشل تحميل إعدادات ساعات العمل",
      settingsNotFound: "لم يتم العثور على إعدادات العمل",
      settingsLoaded: "تم تحميل الإعدادات بنجاح",
      updateFailed: "فشل تحديث إعدادات ساعات العمل",
      settingsSaved: "تم حفظ الإعدادات بنجاح",
      filesLoadFailed: "فشل تحميل قائمة المستندات",
      filesLoaded: "تم تحميل قائمة المستندات بنجاح",
      selectFile: "يرجى اختيار ملف للرفع",
      uploadFailed: "فشل رفع المستند",
      uploadSuccess: "تم رفع المستند بنجاح",
      deleteFailed: "فشل حذف المستند",
      deleteSuccess: "تم حذف المستند بنجاح"
    },

    shifts: {
      title: "الشيفتات",
      description: "عرّف شيفتات متعددة (صباحي / مسائي / ليلي) ثم عيّن كل موظف على شيفت من تفاصيله أو من شاشة الموافقة.",
      orgWide: "على مستوى الشركة",
      branchDescription: "عرّف شيفتات خاصة بهذا الفرع. موظفو الفرع يمكن تعيينهم على شيفتات الفرع أو شيفتات الشركة.",
      branchInheritDescription: "الفرع يرث شيفتات الشركة الرئيسية (عرض فقط). لإضافة شيفتات خاصة بالفرع اختر «تخصيص شيفتات الفرع».",
      add: "إضافة شيفت",
      edit: "تعديل شيفت",
      name: "اسم الشيفت",
      namePlaceholder: "مثال: صباحي",
      nameRequired: "اسم الشيفت مطلوب (حرفين على الأقل)",
      workStart: "بداية الشيفت",
      workEnd: "نهاية الشيفت",
      gracePeriod: "فترة السماح (دقائق)",
      gracePeriodShort: "سماح {minutes} دقيقة",
      active: "نشط",
      inactive: "معطّل",
      loading: "جاري تحميل الشيفتات...",
      empty: "لا توجد شيفتات بعد. أضف شيفتات إن كان لدى الشركة أكثر من مواعيد عمل.",
      loadFailed: "فشل تحميل الشيفتات",
      createSuccess: "تم إضافة الشيفت بنجاح",
      updateSuccess: "تم تحديث الشيفت بنجاح",
      saveFailed: "فشل حفظ الشيفت",
      deleteConfirm: "هل تريد حذف الشيفت \"{name}\"؟",
      deleteSuccess: "تم حذف الشيفت بنجاح",
      deleteFailed: "فشل حذف الشيفت",
      deactivated: "تم تعطيل الشيفت لأنه مرتبط بموظفين",
      employeesCount: "{count} موظف",
    },
    companyInformation: {
      title: "معلومات الشركة",
      description: "عرض وتعديل معلومات الشركة الأساسية",
      noData: "لا توجد بيانات للشركة",
      save: "حفظ",
      cancel: "إلغاء",
      edit: "تعديل",
      basicInfo: "المعلومات الأساسية",
      companyName: "اسم الشركة",
      companyNamePlaceholder: "مثال: تيمين",
      companyCode: "كود الشركة",
      descriptionLabel: "الوصف",
      descriptionPlaceholder: "مثال: شركة لإدارة الحضور والموارد البشرية",
      industry: "الصناعة",
      industryPlaceholder: "مثال: تكنولوجيا المعلومات",
      contactInfo: "معلومات الاتصال",
      email: "البريد الإلكتروني",
      emailPlaceholder: "مثال: info@company.com",
      phone: "الهاتف",
      phonePlaceholder: "مثال: 1012345678",
      website: "الموقع الإلكتروني",
      websitePlaceholder: "مثال: https://example.com",
      address: "العنوان",
      street: "الشارع",
      streetPlaceholder: "مثال: 123 شارع النيل",
      city: "المدينة",
      cityPlaceholder: "مثال: القاهرة",
      state: "الولاية/المحافظة",
      statePlaceholder: "مثال: الجيزة",
      country: "البلد",
      countryPlaceholder: "مثال: مصر",
      postalCode: "الرمز البريدي",
      postalCodePlaceholder: "مثال: 11511",
      gracePeriodPlaceholder: "مثال: 15",
      dateFormatPlaceholder: "مثال: DD-MM-YYYY",
      annualLeaveDaysPlaceholder: "مثال: 21",
      sickLeaveDaysPlaceholder: "مثال: 30",
      maxCarryForwardPlaceholder: "مثال: 7",
      absencePenaltyDaysPlaceholder: "مثال: 1",
      latitudePlaceholder: "مثال: 30.0444",
      longitudePlaceholder: "مثال: 31.2357",
      radiusPlaceholder: "مثال: 150",
      organizationSettings: "إعدادات المنظمة",
      timezone: "المنطقة الزمنية",
      selectTimezone: "اختر المنطقة الزمنية",
      workStart: "بداية العمل",
      workEnd: "نهاية العمل",
      gracePeriod: "فترة السماح",
      inMinutes: "بالدقائق",
      minutes: "دقيقة",
      workDays: "أيام العمل",
      displayFormat: "تنسيق العرض",
      dateFormat: "تنسيق التاريخ",
      leaveSettings: "إعدادات الإجازات",
      annualLeaveDays: "أيام الإجازة السنوية",
      sickLeaveDays: "أيام الإجازة المرضية",
      carryForward: "السماح بالترحيل",
      maxCarryForward: "الحد الأقصى للترحيل",
      overtimeSettings: "إعدادات العمل الإضافي",
      enabled: "مفعل",
      multiplier: "الساعة الإضافية",
      minimumHours: "الحد الأدنى للساعات",
      overtimeHoursNone: "بدون حد",
      overtimeHoursOne: "ساعة",
      overtimeHoursTwo: "ساعتين",
      overtimeHoursFew: "{n} ساعات",
      overtimeHoursMany: "{n} ساعة",
      calculationMethod: "طريقة الحساب",
      daily: "يومي",
      weekly: "أسبوعي",
      monthly: "شهري",
      yes: "نعم",
      no: "لا",
      on: "مفعّل",
      off: "معطّل",
      companyLocations: "مواقع الشركة",
      companyLocationsDescription: "إدارة مواقع الشركة وعرضها على الخريطة",
      clickMapToSelect: "انقر على الخريطة لتحديد الموقع",
      selectedLocation: "موقع محدد",
      companyLocation: "موقع الشركة",
      locationName: "اسم الموقع",
      locationNamePlaceholder: "مثال: المكتب الرئيسي",
      addressPlaceholder: "مثال: 123 شارع النيل، القاهرة",
      latitude: "خط العرض",
      longitude: "خط الطول",
      radiusMeters: "نطاق الموقع (بالمتر)",
      noLocationSet: "لا يوجد موقع محدد",
      getLocationFailed: "فشل الحصول على الموقع",
      getMyCurrentLocation: "الحصول على موقعي الحالي",
      clickMapOrEnterManually: "انقر على الخريطة أو أدخل القيمة يدوياً",
      nameRequired: "اسم الشركة مطلوب",
      phoneInvalid: "رقم الهاتف غير صحيح",
      emailInvalid: "البريد الإلكتروني غير صحيح",
      websiteInvalid: "الموقع الإلكتروني غير صحيح",
      updateSuccess: "تم تحديث معلومات الشركة بنجاح",
      totalDeductionOnAbsence: "إجمالي الخصم عند الغياب: {n} {unit} من الراتب",
      totalSalaryDeductionOnAbsence: "إجمالي الخصم من الراتب عند الغياب",
      sunday: "الأحد",
      monday: "الإثنين",
      tuesday: "الثلاثاء",
      wednesday: "الأربعاء",
      thursday: "الخميس",
      friday: "الجمعة",
      saturday: "السبت",
      attendanceExemptTitle: "إعفاء من تسجيل الحضور",
      attendanceExemptHint: "اختر أنواع موقع العمل التي لا تحتاج تسجيل حضور/انصراف. يطابق قيمة «موقع العمل» على ملف الموظف.",
      attendanceExemptEnabled: "تفعيل الإعفاء",
      attendanceExemptWorkLocations: "أنواع موقع العمل المعفاة",
      attendanceExemptWorkLocationsHint: "الموظف يُعفى فقط إذا كان موقعه يطابق أحد الأنواع المختارة.",
      attendanceExemptSelectAtLeastOne: "فعّل الإعفاء واختر نوعًا واحدًا على الأقل.",
      selectAtLeastOneWorkDay: "يرجى اختيار يوم عمل واحد على الأقل",
      attendanceExemptNoneSelected: "لم يُختر أي نوع",
      workLocationOffice: "مكتب (Office)",
      workLocationRemote: "عن بُعد (Remote)",
      workLocationHybrid: "هجين (Hybrid)",
      workLocationDelivery: "مناديب بعدد الطلبات",
      absencePenaltyTitle: "إعدادات عقوبة الغياب",
      absencePenaltyEnabled: "مفعل",
      absencePenaltyDaysLabel: "إجمالي أيام الخصم من الراتب",
      absencePenaltyDaysHint: "هذا الرقم هو إجمالي أيام الراتب المخصومة عند غياب الموظف بدون إذن، وليس أيامًا إضافية فوق يوم الغياب. مثال: إذا أدخلت 2، يُخصم راتب يومين من الراتب. عند التعطيل يُخصم يوم واحد فقط.",
      absencePenaltyDaysDisabledHint: "عند التعطيل: يُخصم يوم واحد فقط من الراتب (يوم الغياب).",
      absencePenaltyNotifyAdmin: "إشعار المدير",
      absencePenaltyNotifyEmployee: "إشعار الموظف",
      day: "يوم",
      days: "أيام"
    },
    themeSettings: {
      title: "إعدادات الثيم",
      description: "اختر ثيم الألوان والوضع المفضل لديك",
      saveChanges: "حفظ التغييرات",
      colorTheme: "ثيم الألوان",
      unsavedChange: "تغيير غير محفوظ",
      current: "الحالي",
      preview: "معاينة الثيم المحدد",
      primaryButton: "زر أساسي",
      secondaryButton: "زر ثانوي",
      saved: "تم حفظ الإعدادات بنجاح!"
    },
    locationSettings: {
      title: "حدد عنوان الشركه الخاص بك علي الخريطه ثم حدد المحيط الذي يستطيع المستخدم التسجيل بداخله",
      loading: "جارٍ التحميل...",
      searchLocation: "البحث عن موقع",
      searchPlaceholder: "ابحث عن موقع (مثال: القاهرة، مصر)",
      search: "بحث",
      searching: "جارٍ البحث...",
      getMyLocation: "الحصول على موقعي",
      gettingLocation: "جارٍ تحديد الموقع...",
      retry: "إعادة المحاولة",
      latitude: "خط العرض",
      latitudePlaceholder: "خط العرض (مثال: 30.0444)",
      longitude: "خط الطول",
      longitudePlaceholder: "خط الطول (مثال: 31.2357)",
      setLocation: "تحديد الموقع",
      selectedCoordinates: "الإحداثيات المختارة",
      radius: "نصف القطر",
      meters: "متر",
      replaceCurrent: "استبدال الموقع الحالي",
      addNew: "إضافة موقع جديد",
      deleteSelected: "حذف الموقع المختار",
      location: "الموقع",
      updateRadius: "تحديث نصف القطر (بالمتر)",
      radiusPlaceholder: "أدخل نصف القطر الجديد",
      updateZone: "تحديث المنطقة",
      delete: "حذف",
      browserNotSupported: "المتصفح لا يدعم تحديد الموقع الجغرافي.",
      permissionDenied: "تم رفض الوصول إلى الموقع. يرجى تفعيل الوصول إلى الموقع في إعدادات المتصفح.",
      locationUnavailable: "معلومات الموقع غير متوفرة. حاول مرة أخرى لاحقًا.",
      locationTimeout: "انتهت مهلة طلب الموقع. يرجى المحاولة مرة أخرى.",
      locationError: "حدث خطأ أثناء الحصول على موقعك.",
      permissionCheckError: "غير قادر على التحقق من أذونات الموقع. يرجى المحاولة مرة أخرى.",
      searchRequired: "يرجى إدخال اسم الموقع للبحث",
      locationNotFound: "لم يتم العثور على الموقع. يرجى المحاولة باسم آخر.",
      searchError: "خطأ في البحث عن الموقع. يرجى المحاولة مرة أخرى.",
      selectLocationFirst: "يرجى اختيار موقع على الخريطة أولاً",
      selectOrConfirm: "يرجى اختيار موقع على الخريطة أو التأكد من وجود موقع لاستبداله",
      locationUpdated: "تم تحديث الموقع بنجاح",
      updateFailed: "فشل في تحديث الموقع",
      updateError: "خطأ في تحديث الموقع",
      radiusRequired: "يرجى إدخال قيمة صحيحة لنصف القطر",
      radiusUpdated: "تم تحديث نصف القطر بنجاح",
      radiusUpdateFailed: "فشل في تحديث نصف القطر",
      radiusUpdateError: "خطأ في تحديث نصف القطر",
      locationAdded: "تم إضافة الموقع الجديد بنجاح",
      locationAddFailed: "فشل في إضافة الموقع",
      locationAddError: "خطأ في إضافة الموقع",
      deleteConfirm: "هل أنت متأكد من حذف هذا الموقع؟",
      locationDeleted: "تم حذف الموقع بنجاح",
      locationDeleteFailed: "فشل في حذف الموقع",
      locationDeleteError: "خطأ في حذف الموقع",
      invalidCoordinates: "يرجى إدخال قيم صحيحة لخط العرض وخط الطول",
      invalidLatitude: "خط العرض يجب أن يكون بين -90 و 90",
      invalidLongitude: "خط الطول يجب أن يكون بين -180 و 180",
      fetchFailed: "فشل في جلب المواقع",
      selectedLocation: "الموقع المختار:"
    },
    deductionSettings: {
      title: "إعدادات التأخير",
      description: "إدارة قواعد خصم التأخير للموظفين",
      rulesCount: "قواعد محددة",
      howItWorks: "كيف تعمل قواعد التأخير؟",
      howItWorksDesc: "يتم تطبيق قواعد الخصم بناءً على مدة التأخير. على سبيل المثال، إذا كان التأخير بين 30-60 دقائق، سيتم خصم 0.5 من الراتب اليومي.",
      rules: "قواعد التأخير",
      addNewRule: "إضافة قاعدة جديدة",
      minMinutes: "الحد الأدنى (دقيقة)",
      maxMinutes: "الحد الأقصى (دقيقة)",
      deductionRate: "نسبة الخصم",
      actions: "الإجراءات",
      noRules: "لا توجد قواعد مضافة حتى الآن",
      min: "الأدنى",
      max: "الأقصى",
      fractionPlaceholder: "نسبة الخصم",
      note: "ملاحظة: تأكد من أن الحد الأدنى أقل من الحد الأقصى في جميع القواعد.",
      refreshData: "تحديث البيانات",
      saveChanges: "حفظ التغييرات",
      editMode: "وضع التعديل",
      loading: "جاري التحميل...",
      tokenNotFound: "لم يتم العثور على رمز التوثيق",
      loadFailed: "فشل تحميل إعدادات التأخير",
      settingsNotFound: "لم يتم العثور على إعدادات التأخير",
      loaded: "تم تحميل إعدادات التأخير بنجاح",
      minMustBeLess: "يجب أن يكون الحد الأدنى أقل من الحد الأقصى",
      allFieldsRequired: "يرجى إدخال جميع الحقول (الحد الأدنى، الحد الأقصى، الخصم)",
      ruleError: "القاعدة",
      updateFailed: "فشل تحديث إعدادات التأخير",
      saved: "تم حفظ إعدادات التأخير بنجاح",
      enableLateSettings: "تفعيل إعدادات التأخير",
      enableLateSettingsDesc: "تفعيل أو تعطيل نظام الغرامات",
      enabled: "مفعل",
      disabled: "معطل",
      penaltyRules: "قواعد الغرامات",
      addRule: "إضافة قاعدة",
      addFirstRule: "إضافة أول قاعدة",
      availablePenaltyTypes: "أنواع الغرامات المتاحة:",
      autoPenaltyTypes: "ربع يوم / نصف يوم / يوم كامل:",
      autoPenaltyTypesDesc: "يتم احتسابها تلقائياً حسب ساعات العمل - لا حاجة لإدخال مبلغ",
      customPenaltyType: "مخصص:",
      customPenaltyTypeDesc: "يمكنك تحديد مبلغ الغرامة أو أيام الغرامة أو كليهما",
      noRulesDefined: "لا توجد قواعد محددة",
      rule: "قاعدة",
      minute: "دقيقة",
      day: "يوم",
      delayMinutes: "دقائق التأخير",
      penaltyType: "نوع الغرامة",
      selectPenaltyType: "اختر نوع الغرامة",
      none: "لا يوجد",
      quarterDay: "ربع يوم",
      halfDay: "نصف يوم",
      fullDay: "يوم كامل",
      custom: "مخصص",
      quarterDayAuto: "ربع يوم (تلقائي)",
      halfDayAuto: "نصف يوم (تلقائي)",
      fullDayAuto: "يوم كامل (تلقائي)",
      customSpecify: "مخصص (حدد المبلغ أو الأيام)",
      autoCalculatedHint: "سيتم احتساب هذه الغرامة تلقائياً حسب ساعات العمل",
      penaltyAmount: "مبلغ الغرامة",
      penaltyDays: "أيام الغرامة",
      optional: "(اختياري)",
      example15: "مثال: 15",
      example200: "مثال: 200",
      example05: "مثال: 0.5",
      leaveEmptyUseDays: "يمكنك ترك هذا الحقل فارغاً إذا كنت ستستخدم أيام الغرامة فقط",
      leaveEmptyUseAmount: "يمكنك ترك هذا الحقل فارغاً إذا كنت ستستخدم مبلغ الغرامة فقط"
    },
    autoCheckout: {
      title: "إعدادات الانصراف التلقائي",
      description: "تحديد متى يتم انصراف الموظف تلقائياً بعد انتهاء الشيفت إذا نسي تسجيل الخروج",
      loading: "جاري تحميل إعدادات الانصراف التلقائي...",
      refresh: "تحديث",
      edit: "تعديل",
      save: "حفظ",
      saving: "جاري الحفظ...",
      cancel: "إلغاء",
      enabled: "تفعيل الانصراف التلقائي",
      enabledHint: "عند التفعيل سيتم انصراف الموظفين تلقائياً بعد انتهاء الشيفت بمدة محددة",
      on: "مفعل",
      off: "معطل",
      graceHours: "ساعات بعد انتهاء الشيفت",
      graceHoursHint: "عدد الساعات بعد نهاية الدوام قبل تنفيذ الانصراف التلقائي (من 0 إلى 24)",
      graceHoursInvalid: "عدد الساعات يجب أن يكون بين 0 و 24",
      hours: "ساعة",
      countOvertime: "احتساب الوقت الإضافي",
      countOvertimeHint: "عند التفعيل يُحتسب الوقت بعد نهاية الشيفت كساعات إضافية ضمن الانصراف التلقائي",
      notifyEmployee: "إشعار الموظف",
      notifyEmployeeHint: "إرسال إشعار للموظف عند الانصراف التلقائي",
      notifyAdmin: "إشعار الإدارة",
      notifyAdminHint: "إرسال إشعار للإدارة عند الانصراف التلقائي",
      loadFailed: "فشل تحميل إعدادات الانصراف التلقائي",
      settingsNotFound: "لم يتم العثور على إعدادات الانصراف التلقائي",
      saved: "تم حفظ إعدادات الانصراف التلقائي بنجاح",
      saveFailed: "فشل حفظ إعدادات الانصراف التلقائي",
      deductionTitle: "خصم نسيان تسجيل الخروج",
      deductionHint: "حدد هل يتم خصم من الراتب عند نسيان تسجيل الخروج، وكم قيمة الخصم.",
      policyFree: "بدون خصم",
      policyQuarterDay: "ربع يوم",
      policyHalfDay: "نصف يوم",
      policyFixedAmount: "مبلغ ثابت",
      fixedAmount: "المبلغ الثابت",
      fixedAmountHint: "المبلغ المخصوم بعملة الراتب",
      fixedAmountInvalid: "أدخل مبلغاً أكبر من صفر وبحد أقصى منزلتين عشريتين"
    },
    checkInSelfie: {
      title: "إعدادات صورة الحضور",
      description: "الإعداد الافتراضي للشركة لصورة السيلفي عند تسجيل الحضور. يمكن للفروع اتباع الشركة أو تخصيص سياسة خاصة.",
      loading: "جاري تحميل إعدادات صورة الحضور...",
      refresh: "تحديث",
      edit: "تعديل",
      save: "حفظ",
      saving: "جاري الحفظ...",
      cancel: "إلغاء",
      mode: "وضع صورة الحضور",
      modeHint: "اختر تعطيل الصورة أو جعلها اختيارية أو إجبارية",
      modes: {
        off: "معطّل",
        optional: "اختياري",
        required: "إجباري",
      },
      modeHints: {
        off: "لا يُطلب سيلفي عند تسجيل الحضور",
        optional: "يظهر التقاط السيلفي مع إمكانية التخطي",
        required: "يجب على الموظف التقاط سيلفي لإكمال الحضور",
      },
      applyTo: "يُطبَّق على أنواع العمل",
      applyToHint: "تُطبَّق السياسة فقط على أنواع مواقع العمل المحددة",
      applyToRequired: "اختر نوع عمل واحد على الأقل",
      modeInvalid: "وضع صورة الحضور غير صالح",
      workTypes: {
        office: "مكتب",
        remote: "عن بُعد",
        hybrid: "هجين",
        delivery: "توصيل",
      },
      loadFailed: "فشل تحميل إعدادات صورة الحضور",
      settingsNotFound: "لم يتم العثور على إعدادات صورة الحضور",
      saved: "تم حفظ إعدادات صورة الحضور بنجاح",
      saveFailed: "فشل حفظ إعدادات صورة الحضور",
    },
    aiSettings: {
      title: "إعدادات الذكاء الاصطناعي",
      description: "إدارة مفتاح API الخاص بنماذج الذكاء الاصطناعي بسهولة وأمان",
      setApiKey: "SET API Key",
      newApiKey: "مفتاح API جديد",
      newApiKeyPlaceholder: "أدخل مفتاح API جديد",
      createApiKey: "إنشاء مفتاح API",
      noApiKeys: "لا توجد مفاتيح API متاحة",
      fetchFailed: "فشل في جلب مفاتيح API",
      fetchError: "خطأ في جلب مفاتيح API",
      onlyOneKey: "يمكنك إنشاء مفتاح API واحد فقط",
      createFailed: "فشل في إنشاء مفتاح API",
      createError: "خطأ في إنشاء مفتاح API",
      updateFailed: "فشل في تحديث مفتاح API",
      updateError: "خطأ في تحديث مفتاح API",
      deleteFailed: "فشل في حذف مفتاح API",
      deleteError: "خطأ في حذف مفتاح API",
      loading: "جاري التحميل..."
    },
    holidaysSettings: {
      title: "الأجازات الرسمية",
      description: "إدارة وإعداد الإجازات الرسمية",
      fetchFailed: "فشل في تحميل الإجازات",
      updateSuccess: "تم تحديث الإجازة بنجاح",
      updateFailed: "فشل في تحديث الإجازة",
      deleteConfirm: "هل أنت متأكد من حذف هذه الإجازة؟",
      deleteSuccess: "تم حذف الإجازة بنجاح",
      deleteFailed: "فشل في حذف الإجازة"
    },
    createdBy: "تم الإنشاء بواسطة",
    created: "تم الإنشاء",
    lastUpdated: "آخر تحديث",
    save: "حفظ",
    cancel: "إلغاء",
    edit: "تعديل",
    create: "إنشاء",
    createDepartment: "إنشاء قسم",
    newDepartmentName: "اسم القسم الجديد",
    departmentBadge: "قسم"
  },
  languageSelector: {
    title: "إعدادات اللغة",
    description: "اختر لغة الواجهة",
    arabic: "العربية",
    english: "English",
    save: "حفظ التغييرات",
    unsaved: "تغيير غير محفوظ",
    german: "Deutsch"
  },
  dashboard: {
    title: "لوحة التحكم",
    description: "نظرة شاملة على معلوماتك",
    seeMore: "عرض المزيد",
    seeLess: "عرض أقل",
    tabs: {
      employee: "للموظف",
      profile: "حسابي الشخصي",
      manager: "للمسؤول"
    },
    errors: {
      tokenNotFound: "لم يتم العثور على التوكن",
      fetchFailed: "فشل في جلب بيانات لوحة التحكم. يرجى المحاولة لاحقاً.",
      retry: "إعادة المحاولة"
    },
    loading: {
      loadingData: "جاري تحميل البيانات...",
      loadingPayroll: "جاري تحميل بيانات الرواتب...",
      loadingEmployees: "جاري تحميل بيانات الموظفين..."
    },
    leaveBalance: {
      sickLeave: "الإجازة المرضية",
      annualLeave: "الإجازة السنوية",
      workFromHome: "العمل من المنزل",
      days: "يوم",
      used: "مستخدم",
      total: "المجموع",
      thisMonth: "هذا الشهر"
    },
    empty: {
      noDashboardTitle: "لا توجد بيانات متاحة",
      noDashboardMessage: "لا توجد بيانات لوحة التحكم متاحة حالياً. يرجى المحاولة لاحقاً أو التواصل مع الإدارة.",
      noEmployeeTitle: "لا توجد بيانات",
      noEmployeeMessage: "لا توجد بيانات موظف متاحة للعرض."
    },
    roles: {
      admin: "مدير",
      manager: "مدير",
      employee: "موظف",
      hr: "موارد بشرية",
      accountant: "محاسب"
    },
    employeeInfo: {
      directManager: "المدير المباشر",
      department: "القسم",
      branch: "الفرع",
      workLocation: "موقع العمل الحالي"
    },
    manager: {
      totalEmployees: "إجمالي الموظفين",
      workFromHome: "عمل من المنزل",
      outsideOffice: "خارج المكتب",
      pendingRequests: "طلبات الإجازة المعلقة",
      pendingRequestsCount: "طلب إجازة يحتاج موافقة",
      expiringDocuments: "تذكير: مستندات على وشك الانتهاء",
      expiringDocumentsDesc: "المستندات التي ستنتهي خلال 30 يومًا",
      expiresIn: "ينتهي في",
      days: "يوم",
      quickShortcuts: "الطلبات المعلقة",
      quickShortcutsDesc: "الطلبات التي تحتاج إلى مراجعة",
      underReview: "قيد المراجعة",
      viewAllRequests: "عرض جميع الطلبات",
      noPendingRequests: "لا توجد طلبات معلقة",
      contract: "عقد عمل",
      visa: "فيزا عمل",
      present: "حاضر في الموعد",
      late: "متأخر",
      absent: "غائب",
      attendanceRate: "نسبة الحضور",
      totalAttendance: "إجمالي الحضور",
      activeEmployees: "الموظفين النشطين",
      pendingEmployees: "الموظفين المعلقين",
      inactiveEmployees: "الموظفين غير النشطين",
      seeMore: "عرض المزيد",
      seeLess: "عرض أقل",
      cardDetailsEmpty: "لا يوجد موظفون في هذه الفئة",
      cardDetailsLoading: "جاري تحميل البيانات...",
      cardDetailsClose: "إغلاق",
      cardDetailsName: "الاسم",
      cardDetailsDepartment: "القسم",
      cardDetailsPosition: "المسمى الوظيفي",
      cardDetailsStatus: "الحالة",
      cardDetailsCheckIn: "وقت الحضور",
      cardDetailsEmail: "البريد",
      cardDetailsPhone: "الهاتف",
      cardDetailsCount: "{count} موظف",
      cardDetailsLeaveCount: "{count} طلب",
      cardDetailsLeaveEmpty: "لا توجد طلبات إجازة معلقة",
      cardDetailsLeaveType: "نوع الإجازة",
      cardDetailsLeaveDates: "الفترة",
      cardDetailsLeaveDays: "الأيام",
      viewPendingLeavesPage: "صفحة الطلبات المعلقة",
      pendingLeavesViewOnlyHint: "عرض فقط بدون موافقة أو رفض. لفتح الطلبات اضغط هنا أو على أي صف للانتقال لصفحة الطلبات المعلقة.",
      leaveCategory: {
        annual: "سنوية",
        sick: "مرضية",
        workFromHome: "عمل من المنزل",
        emergency: "طارئة",
        maternity: "وضع"
      },
      inactiveEmployeesHint: "تظهر هنا الموظفون غير النشطين فقط: المعطّلون أو الذين حالتهم «تحت التدريب»، وأي حالة أخرى غير «نشط».",
      help: {
        totalEmployees: "إجمالي عدد الموظفين المسجّلين في النظام بغض النظر عن حالتهم أو حضورهم اليوم.",
        workFromHome: "موظفو العمل عن بُعد (Remote) الذين سجّلوا حضورهم اليوم.",
        outsideOffice: "موظفو Hybrid والمناديب (Delivery) الذين سجّلوا حضورهم اليوم من خارج زون المكتب.",
        pendingRequests: "طلبات الإجازة التي ما زالت بانتظار موافقة المدير أو المسؤول.",
        present: "الموظفون الذين سجّلوا حضورهم اليوم في الموعد (قبل انتهاء فترة السماح).",
        late: "الموظفون الذين سجّلوا حضورهم اليوم بعد انتهاء فترة السماح.",
        absent: "الموظفون الذين لم يُسجَّل لهم حضور اليوم ويُعتبرون غائبين.",
        attendanceRate: "نسبة الحاضرين والمتأخرين اليوم من إجمالي الموظفين النشطين.",
        totalAttendance: "مجموع سجلات الحضور اليوم (حاضر + متأخر + غائب).",
        activeEmployees: "الموظفون الذين حالتهم «نشط» في النظام، بغض النظر عن تسجيل الحضور اليوم.",
        pendingEmployees: "الموظفون بانتظار الموافقة على انضمامهم أو تفعيل حسابهم.",
        inactiveEmployees: "الموظفون غير النشطين: المعطّلون أو «تحت التدريب» أو أي حالة غير «نشط»."
      }
    },
    profile: {
      editMyInfo: "تعديل بياناتي",
      edit: "تعديل الملف الشخصي",
      save: "حفظ",
      saving: "جاري الحفظ...",
      cancel: "إلغاء",
      updateSuccess: "تم تحديث الملف الشخصي بنجاح",
      email: "البريد الإلكتروني",
      emailPlaceholder: "أدخل البريد الإلكتروني",
      phone: "رقم الهاتف",
      phonePlaceholder: "أدخل رقم الهاتف",
      employeeId: "رقم الموظف",
      joinDate: "تاريخ الانضمام",
      directManager: "المدير المباشر",
      department: "القسم",
      workLocation: "موقع العمل",
      additionalInfo: "معلومات إضافية",
      address: "العنوان",
      addressPlaceholder: "أدخل العنوان",
      nationalID: "الرقم القومي",
      gender: "الجنس",
      education: "التعليم",
      educationPlaceholder: "أدخل المؤهل التعليمي",
      skills: "المهارات",
      accountStatus: "حالة الحساب",
      active: "نشط",
      attendanceSummary: "ملخص الحضور",
      totalDeductions: "إجمالي الخصومات",
      allowances: "البدلات",
      allowancesAssigned: "البدلات المخصصة لك",
      emergencyContact: "جهة الاتصال للطوارئ",
      relation: "العلاقة",
      bank: "البنك",
      errors: {
        noEmployeeId: "لم يتم العثور على رقم الموظف",
        noChanges: "لا توجد تغييرات للحفظ",
        updateFailed: "فشل تحديث الملف الشخصي"
      }
    },
    common: {
      notSpecified: "غير محدد",
      unknown: "غير معروف",
      document: "مستند",
      leave: "إجازة"
    },
    activeEmployees: {
      title: "الموظفين النشطين",
      description: "الموظفين المسجلين حضور اليوم",
      presentCount: "{count} حاضر في الموعد",
      remoteCount: "{count} عن بُعد",
      attendanceRate: "{percent}% معدل الحضور",
      loading: "جارٍ تحميل الموظفين...",
      fetchError: "حدث خطأ أثناء جلب الموظفين النشطين",
      empty: "لا يوجد موظفين نشطين حالياً",
      arrivalTime: "وقت الوصول:",
      location: "الموقع:",
      call: "اتصال",
      email: "إيميل",
      sendEmail: "إرسال بريد",
      viewFullDetails: "عرض التفاصيل الكاملة",
      emailLabel: "البريد الإلكتروني",
      phoneLabel: "رقم الهاتف",
      locationLabel: "الموقع",
      baseSalary: "الراتب الأساسي",
      joinDate: "تاريخ الانضمام",
      status: "الحالة",
      unavailable: "غير متوفر",
      detailsLoadFailed: "فشل في تحميل التفاصيل",
      noEmail: "لا يوجد بريد إلكتروني",
      noPhone: "لا يوجد رقم هاتف",
      mainOffice: "المكتب الرئيسي",
      present: "حاضر في الموعد",
      inMeeting: "في اجتماع",
      remote: "عن بعد",
      active: "نشط"
    },
    lastRequests: {
      title: "الطلبات الأخيرة",
      description: "عرض جميع طلبات الإجازات الخاصة بك",
      all: "الكل",
      pending: "قيد المراجعة",
      approved: "موافق عليها",
      rejected: "مرفوضة",
      newest: "الأحدث",
      oldest: "الأقدم",
      noMatching: "لا توجد طلبات مطابقة للفلتر",
      reason: "السبب:",
      rejectionReason: "سبب الرفض:",
      date: "التاريخ:",
      duration: "المدة:",
      status: "الحالة:",
      statsTitle: "إحصائيات الطلبات",
      statsDescription: "نظرة عامة على حالات طلبات الإجازات",
      employeeIdMissing: "معرف الموظف غير متوفر",
      noRequests: "لا توجد طلبات متاحة",
      fetchError: "حدث خطأ أثناء تحميل الطلبات",
      unknown: "غير معروف",
      chartCount: "العدد"
    },
    notifications: {
      title: "لوحة الإشعارات",
      unreadSummary: "لديك {unread} إشعار غير مقروء من أصل {total}",
      markAllRead: "قراءة الكل",
      deleteAll: "حذف الكل",
      decreasePerPageAria: "تقليل عدد الإشعارات لكل صفحة",
      increasePerPageAria: "زيادة عدد الإشعارات لكل صفحة",
      perPageAria: "عدد الإشعارات لكل صفحة",
      perPageLabel: "عدد الإشعارات لكل صفحة",
      loading: "جارٍ تحميل الإشعارات...",
      noNotifications: "لا توجد إشعارات",
      notificationAria: "إشعار: {title}",
      untitled: "إشعار بدون عنوان",
      unreadAria: "إشعار غير مقروء",
      noMessage: "لا يوجد نص للإشعار",
      loadMoreAria: "تحميل المزيد من الإشعارات",
      loadMore: "عرض المزيد من الإشعارات",
      fetchFailed: "فشل في جلب الإشعارات",
      fetchError: "حدث خطأ أثناء جلب الإشعارات",
      markReadFailed: "فشل في تحديث حالة الإشعار",
      markAllReadFailed: "فشل في تحديث حالة الإشعارات",
      deleteFailed: "فشل في حذف الإشعار",
      deleteAllFailed: "فشل في حذف جميع الإشعارات"
    }
  },
  employees: {
    title: "إدارة الموظفين",
    description: "إدارة معلومات الموظفين",
    list: "قائمة الموظفين",
    manageAndView: "إدارة وعرض بيانات الموظفين",
    searchPlaceholder: "البحث عن موظف...",
    filter: {
      all: "الكل",
      admins: "أدمن",
      teamLeaders: "قادة الفرق",
      employees: "موظفين"
    },
    noEmployees: "لا توجد موظفين",
    noSearchResults: "لا توجد نتائج للبحث",
    addFirstEmployee: "إضافة أول موظف",
    unassignedShifts: {
      urgent: "عاجل — مطلوب فوراً",
      bannerOne: "موظف واحد بدون شيفت — التعيين ضروري الآن",
      bannerMany: "{count} موظفين بدون شيفت — التعيين ضروري الآن",
      bannerHint: "بدون شيفت قد تتأثر التذكيرات وحساب الغياب. اضغط للتعيين فوراً.",
      viewCta: "تعيين الآن",
      bannerCta: "تعيين الآن",
      panelTitle: "موظفون بدون شيفت",
      panelHint: "اضغط على الموظف لتعيين شيفت له. هذا الإجراء ضروري لدقة الحضور والرواتب.",
      branchLabel: "الفرع: {branch}",
      noBranch: "بدون فرع",
      missingShift: "بدون شيفت",
      backToList: "← رجوع للقائمة",
      assignHint: "اختر الشيفت المناسب ثم احفظ. التعيين من الأدمن أو قائد الفريق فقط.",
      assignCta: "تعيين الشيفت",
      selectShiftRequired: "اختر شيفت قبل الحفظ",
      assignSuccess: "تم تعيين الشيفت بنجاح",
      assignFailed: "فشل تعيين الشيفت",
      loadShiftsFailed: "فشل تحميل الشيفتات",
      noShiftsAvailable: "لا توجد شيفتات متاحة. أضف شيفتات من إعدادات الشركة أو الفرع أولاً."
    },
    pendingApproval: "لا يوجد موظفين في انتظار الموافقة",
    pendingApprovalTitle: "موظفين في انتظار الموافقة",
    pendingApprovalDescription: "يحتاجون موافقة الإدارة للانضمام للنظام",
    loading: "جاري التحميل...",
    updating: "جاري التحديث...",
    updateList: "تحديث القائمة",
    hide: "إخفاء",
    show: "إظهار",
    noDataForMonth: "لا توجد بيانات موظفين متاحة لشهر",
    sortOptions: {
      none: "بدون فرز",
      topSalary: "أعلى راتب",
      topBonuses: "أعلى مكافآت",
      topDeductions: "أعلى خصومات",
      oldestStartDate: "أقدم تاريخ بدء"
    },
    perPage: "لكل صفحة",
    pageOf: "صفحة",
    of: "من",
    previous: "السابق",
    next: "التالي",
    enterPerPage: "أدخل عدد لكل صفحة",
    apply: "تطبيق",
    invalidNumber: "يرجى إدخال رقم صحيح أكبر من 0",
    noMatchSearch: "لم يتم العثور على موظفين يطابقون",
    tryModifySearch: "جرب تعديل مصطلح البحث",
    startAddingEmployee: "ابدأ بإضافة أول موظف في النظام لتتمكن من إدارة الموظفين وتتبع الرواتب.",
    confirmDeleteEmployee: "هل أنت متأكد من حذف الموظف: {name}؟\n\nهذه العملية لا يمكن التراجع عنها.",
    deleteEmployeeSuccess: "تم حذف الموظف بنجاح",
    deleteEmployeeError: "حدث خطأ أثناء حذف الموظف",
    fetchEmployeesError: "حدث خطأ أثناء جلب بيانات الموظفين",
    promoteSuccess: "تم ترقية الموظف إلى مدير بنجاح",
    promoteError: "حدث خطأ أثناء ترقية الموظف إلى مدير",
    demoteSuccess: "تم تخفيض رتبة الموظف إلى موظف عادي بنجاح",
    demoteError: "حدث خطأ أثناء تخفيض رتبة الموظف",
    promoteToAdmin: "ترقية إلى مدير",
    demoteToEmployee: "تخفيض إلى موظف",
    deleteEmployeeTitle: "حذف الموظف",
    showEmployeeNumber: "إظهار رقم الموظف",
    employeeFallback: "الموظف",
    whatsappCustomPlaceholder: "اتركه فارغاً لاستخدام القالب الافتراضي أو اكتب رسالة مخصصة...",
    employeeInfo: "معلومات الموظف",
    selectEmployeeAndMessage: "يرجى التأكد من اختيار الموظف وكتابة الرسالة",
    whatsapp: {
      messageType: "نوع الرسالة",
      salarySlip: "كشف راتب",
      leaveBalance: "رصيد الإجازات",
      notification: "إشعار",
      customMessage: "رسالة مخصصة",
      templatePreview: "معاينة القالب",
      editMessageOptional: "تعديل الرسالة (اختياري)",
      nameLabel: "الاسم:",
      phoneLabel: "رقم الهاتف:",
      positionLabel: "المنصب:",
      departmentLabel: "القسم:",
      sending: "جاري إرسال الرسالة...",
      sendFailed: "فشل في إرسال الرسالة",
      reasonPrefix: "السبب:",
      sendingBtn: "جاري الإرسال...",
      sentSuccess: "تم الإرسال بنجاح",
      sendMessage: "إرسال الرسالة",
      to: "إلى:",
      chooseMessageType: "اختر نوع الرسالة",
      salarySlipDesc: "إرسال تفاصيل الراتب الشهري",
      leaveBalanceDesc: "إرسال تحديث الإجازات المتاحة",
      notificationTitle: "إشعار هام",
      notificationDesc: "إرسال إشعار عام أو تنبيه",
      customMessageDesc: "كتابة رسالة حرة ومخصصة",
      templateSalary: "📊 *كشف راتب شهر {month}*\nالسيد/ة: *{name}*\nالمنصب: {position}\nالقسم: {department}\n💰 *تفاصيل الراتب:*\n• الراتب الأساسي: {baseSalary}\n• البدلات: {allowances}\n• الخصومات: {deductions}\n💸 *إجمالي الراتب: {netSalary}*\nتاريخ الإستحقاق: {date}\nشكراً لك على جهودك المبذولة 🙏",
      templateLeave: "🏖️ *تحديث رصيد الإجازات*\nعزيزي/عزيزتي: *{name}*\n📊 *تفاصيل رصيد الإجازات:*\n• الرصيد المتاح: {leaveBalance} يوم\n• الأيام المستخدمة: {usedDays} يوم\n• إجمالي الأيام السنوية: 30 يوم\nتاريخ التحديث: {date}\nللاستفسار عن تقديم طلب إجازة، يرجى التواصل مع قسم الموارد البشرية.\nنتمنى لك إجازة سعيدة! 🌟",
      templateNotification: "🔔 *إشعار هام*\nعزيزي/عزيزتي: *{name}*\nالمنصب: {position}\nالقسم: {department}\nيرجى العلم أنه...[اكتب الإشعار هنا]\nالتاريخ: {date}\nشكراً لك على اهتمامك.",
      templateCustom: "السلام عليكم ورحمة الله وبركاته\nعزيزي/عزيزتي: *{name}*\n[اكتب رسالتك هنا]\nمع تحيات إدارة الموارد البشرية  {date}"
    },
    directoryTitle: "دليل الموظفين",
    directoryDescription: "تصفح معلومات الاتصال بزملائك في العمل وبياناتهم المهنية",
    totalEmployees: "إجمالي الموظفين",
    activeEmployees: "الموظفون النشطون",
    teamLeaders: "قادة الفرق",
    departmentsCount: "عدد الأقسام",
    displayedResults: "النتائج المعروضة",
    ofEmployees: "من {total} موظف",
    resultsCount: "({count} نتيجة)",
    searchDirectoryPlaceholder: "البحث بالاسم، القسم، المهارات...",
    allStatuses: "جميع الحالات",
    departmentLabel: "القسم:",
    emailLabel: "البريد:",
    phoneLabel: "الهاتف:",
    locationLabel: "الموقع:",
    hireDateLabel: "تاريخ التوظيف:",
    educationLabel: "التعليم:",
    skillsLabel: "المهارات:",
    projectsLabel: "المشاريع:",
    yearsExperience: "{n} سنوات خبرة",
    moreSkills: "+{n} أخرى",
    noResultsTitle: "لا توجد نتائج",
    noResultsHint: "لم يتم العثور على موظفين يطابقون البحث الحالي. جرب تغيير مصطلح البحث أو الفلتر.",
    rejectEmployeeTitle: "رفض الموظف",
    rejectEmployeeHint: "يرجى إدخال سبب رفض الموظف {name}",
    rejectReasonPlaceholder: "سبب الرفض (بين 10 و500 حرف)...",
    confirmReject: "تأكيد الرفض",
    privacyNoteTitle: "ملاحظة حول الخصوصية",
    privacyNoteBody: "يعرض دليل الموظفين معلومات الاتصال والبيانات المهنية الأساسية. المعلومات المالية الحساسة محمية وفقاً لسياسات الخصوصية.",
    unauthorizedPage: "غير مصرح لك باستخدام هذه الصفحة",
    adminCheckFailed: "تعذر التحقق من صلاحيات الأدمن",
    rejectFailed: "فشل في رفض الموظف",
    rejectError: "حدث خطأ أثناء رفض الموظف",
    tableHeaders: {
      employeeId: "رقم الموظف (ID)",
      name: "الاسم",
      email: "البريد الإلكتروني",
      position: "الوظيفة",
      department: "القسم",
      branch: "الفرع",
      actions: "الإجراءات"
    },
    details: {
      loading: "جاري تحميل بيانات الموظف...",
      notFound: "لم يتم العثور على بيانات الموظف",
      notFoundDesc: "يرجى التحقق من معرف الموظف أو المحاولة مرة أخرى",
      backToEmployees: "العودة إلى قائمة الموظفين",
      overview: "نظرة عامة",
      notSpecified: "غير محدد",
      teamLeader: "قائد فريق",
      edit: "تعديل",
      cancel: "إلغاء",
      save: "حفظ",
      saving: "جاري الحفظ...",
      quickActions: "الإجراءات السريعة",
      quickActionsMenu: "قائمة الإجراءات السريعة",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      workLocation: "موقع العمل",
      role: "الدور",
      joinDate: "تاريخ الانضمام",
      contractDurationMonths: "مدة العقد",
      contractMonthsUnit: "{count} شهر",
      contractStartDate: "بداية العقد",
      contractEndDate: "نهاية العقد",
      renewContract: "تجديد العقد",
      renewResidence: "تجديد الإقامة",
      renewContractTitle: "تجديد عقد الموظف",
      renewResidenceTitle: "تجديد فترة الإقامة",
      renewDurationMonths: "المدة الجديدة (بالأشهر)",
      renewDurationPlaceholder: "مثال: 12",
      renewDurationHint: "سيتم احتساب التاريخ الجديد من اليوم بعدد الأشهر المدخل.",
      renewConfirm: "تأكيد التجديد",
      renewing: "جاري التجديد...",
      contractRenewed: "تم تجديد العقد بنجاح",
      residenceRenewed: "تم تجديد فترة الإقامة بنجاح",
      renewFailed: "فشل التجديد. حاول مرة أخرى.",
      directManager: "المدير المباشر",
      approvalStatus: "حالة الموافقة",
      status: "الحالة",
      approved: "موافق عليه",
      rejected: "مرفوض",
      pending: "قيد الانتظار",
      notSet: "غير محدد",
      active: "نشط",
      inactive: "معطل",
      onLeave: "إجازة",
      underTraining: "تحت التدريب",
      serviceEnded: "منتهي الخدمة",
      assignTeamLeader: "تعيين قائد فريق",
      editTeamLeader: "تعديل قائد الفريق",
      employeeRole: "موظف",
      assignPermissionApprover: "تعيين مراجع الأذونات",
      permissionApproverHint: "حدد من يستلم طلبات الأذونات لهذا الموظف. الافتراضي: قائد فريق القسم إن وُجد، وإلا المدير.",
      useDefaultApprover: "الافتراضي (تيم ليدر / مدير)",
      addBonus: "إضافة مكافأة",
      addDeduction: "إضافة خصم",
      convertToEmployee: "تحويل إلى موظف عادي",
      converting: "جاري التحويل...",
      addAllowance: "إضافة بدل",
      addTax: "إضافة ضرائب",
      addInsurance: "إضافة تأمينات",
      errors: {
        fetchFailed: "فشل في جلب بيانات الموظف",
        fetchError: "حدث خطأ أثناء جلب بيانات الموظف",
        fetchDepartmentsFailed: "فشل في جلب الأقسام",
        fetchDepartmentsError: "حدث خطأ أثناء جلب الأقسام",
        selectDepartment: "يرجى اختيار قسم واحد على الأقل",
        noUserId: "لا يوجد معرف مستخدم للموظف",
        assignFailed: "فشل في تعيين قائد الفريق",
        assignError: "حدث خطأ أثناء تعيين قائد الفريق",
        convertFailed: "فشل في تحويل قائد الفريق",
        convertError: "حدث خطأ أثناء تحويل قائد الفريق",
        taxNameRequired: "يرجى إدخال اسم الخصم",
        taxAmountRequired: "يرجى إدخال مبلغ صحيح أكبر من صفر",
        taxAddFailed: "فشل في إضافة الضرائب",
        taxAddError: "حدث خطأ أثناء إضافة الضرائب",
        insuranceNameRequired: "يرجى إدخال اسم الخصم",
        insuranceAmountRequired: "يرجى إدخال مبلغ صحيح أكبر من صفر",
        insuranceAddFailed: "فشل في إضافة التأمينات",
        insuranceAddError: "حدث خطأ أثناء إضافة التأمينات",
        bonusFieldsRequired: "يرجى ملء جميع الحقول المطلوبة",
        bonusAmountRequired: "المبلغ يجب أن يكون أكبر من صفر",
        bonusAddFailed: "فشل في إضافة المكافأة",
        bonusAddError: "حدث خطأ أثناء إضافة المكافأة",
        bonusDeleteConfirm: "هل أنت متأكد من حذف هذه المكافأة؟ لا يمكن التراجع عن هذه العملية.",
        bonusDeleteFailed: "فشل في حذف المكافأة",
        bonusDeleteError: "حدث خطأ أثناء حذف المكافأة",
        deductionFieldsRequired: "يرجى ملء جميع الحقول المطلوبة",
        deductionAmountRequired: "المبلغ يجب أن يكون أكبر من صفر",
        deductionAddFailed: "فشل في إضافة الخصم",
        deductionAddError: "حدث خطأ أثناء إضافة الخصم",
        deductionDeleteConfirm: "هل أنت متأكد من حذف هذا الخصم؟ لا يمكن التراجع عن هذه العملية.",
        deductionDeleteFailed: "فشل في حذف الخصم",
        deductionDeleteError: "حدث خطأ أثناء حذف الخصم",
        allowanceFieldsRequired: "يرجى ملء جميع الحقول المطلوبة",
        allowanceEndDateRequired: "يرجى إدخال تاريخ الانتهاء أو تفعيل الخيار \"دائم\"",
        allowanceSaveFailed: "حدث خطأ أثناء حفظ البدل",
        allowanceIdInvalid: "معرف البدل غير صحيح",
        bonusIdInvalid: "معرف المكافأة غير صحيح",
        deductionIdInvalid: "معرف الخصم غير صحيح",
        convertToAdminFailed: "فشل في تحويل الموظف إلى مدير",
        permissionApproverLoadFailed: "فشل في تحميل إعدادات مراجع الأذونات",
        permissionApproverUpdateFailed: "فشل في تحديث مراجع الأذونات",
        updateFailed: "فشل التحديث",
        allowanceDeleteConfirm: "هل أنت متأكد من حذف هذا البدل؟ لا يمكن التراجع عن هذه العملية."
      },
      success: {
        permissionApproverUpdated: "تم تحديث مراجع الأذونات",
        convertToAdmin: "تم تحويل الموظف إلى مدير بنجاح",
        assignTeamLeader: "تم تعيين الموظف كقائد فريق بنجاح",
        convertToEmployee: "تم تحويل قائد الفريق إلى موظف عادي بنجاح",
        taxAdded: "تم إضافة الضرائب بنجاح",
        insuranceAdded: "تم إضافة التأمينات بنجاح",
        bonusAdded: "تم إضافة المكافأة بنجاح",
        bonusDeleted: "تم حذف المكافأة بنجاح",
        deductionAdded: "تم إضافة الخصم بنجاح",
        deductionDeleted: "تم حذف الخصم بنجاح",
        allowanceUpdated: "تم تحديث البدل بنجاح",
        allowanceAdded: "تم إضافة البدل بنجاح"
      },
      confirmations: {
        convertRoleToEmployee: "هل أنت متأكد من تحويل {role} إلى موظف؟",
        convertToAdmin: "هل أنت متأكد من تحويل هذا الموظف إلى مدير؟",
        convertToEmployee: "هل أنت متأكد من تحويل قائد الفريق إلى موظف عادي؟"
      },
      deductions: {
        socialInsurance: "التأمينات الاجتماعية",
        insurance: "التأمين",
        tax: "الضرائب",
        taxes: "الضرائب",
        loans: "القروض",
        absence: "الغياب"
      },
      fullDetails: "تفاصيل الموظف الكاملة",
      personalInfo: "المعلومات الشخصية",
      jobInfo: "المعلومات الوظيفية",
      datesAndContact: "التواريخ والاتصال",
      employeeNumber: "رقم الموظف",
      nationalID: "الرقم القومي",
      gender: "الجنس",
      male: "ذكر",
      female: "أنثى",
      birthDate: "تاريخ الميلاد",
      maritalStatus: "الحالة الاجتماعية",
      address: "العنوان",
      emergencyContact: "جهة الاتصال الطارئة",
      department: "القسم",
      position: "المنصب",
      yes: "نعم",
      no: "لا",
      periodOfStay: "مدة الإقامة (أيام)",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      contractDurationMonths: "مدة العقد",
      contractMonthsUnit: "{count} شهر",
      residenceExpiry: "انتهاء الإقامة",
      leaveBalance: "رصيد الإجازات",
      sickLeaveLabel: "إجازة مرضية",
      annualLeaveLabel: "إجازة سنوية",
      unpaidLeaveLabel: "إجازة بدون راتب",
      workFromHomeLabel: "عمل من المنزل",
      monthlyWorkFromHomeLabel: "عمل من المنزل (شهري)",
      yearLabel: "السنة",
      day: "يوم",
      days: "أيام",
      createdAt: "تاريخ الإنشاء",
      experience: "الخبرة",
      documents: "المستندات",
      documentN: "مستند",
      size: "الحجم",
      type: "النوع",
      viewDocument: "عرض المستند",
      customAllowances: "البدلات المخصصة",
      amount: "المبلغ",
      permanent: "دائم",
      delete: "حذف",
      deleting: "جاري...",
      accountInfo: "معلومات الحساب",
      lastDevice: "آخر جهاز",
      brand: "العلامة",
      deviceTypeLabel: "نوع الجهاز",
      system: "النظام",
      deviceRequests: "طلبات الأجهزة",
      requestsCount: "طلب",
      loadingDeviceRequests: "جاري تحميل طلبات الأجهزة...",
      noDeviceRequests: "لا توجد طلبات أجهزة حالياً",
      unknown: "غير معروف",
      pendingReview: "قيد المراجعة",
      deviceBrand: "العلامة التجارية",
      deviceName: "اسم الجهاز",
      deviceModel: "الموديل",
      deviceId: "معرف الجهاز",
      operatingSystem: "نظام التشغيل",
      carrier: "مزود الخدمة",
      requestDate: "تاريخ الطلب",
      approve: "موافقة",
      reject: "رفض",
      unavailable: "غير متوفر",
      minutes: "دقائق",
      hours: "ساعات",
      minute: "دقيقة",
      hour: "ساعة",
      convertToAdmin: "تحويل إلى مدير",
      convertingToAdmin: "جاري التحويل...",
      allowanceDeleted: "تم حذف البدل بنجاح",
      employeeUpdated: "تم تحديث بيانات الموظف بنجاح",
      rejectReasonPrompt: "يرجى إدخال سبب الرفض:",
      userEmail: "بريد المستخدم",
      noAllowances: "لا توجد بدلات",
      unselectAll: "إلغاء الكل",
      assigning: "جاري التعيين...",
      editAllowance: "تعديل البدل",
      addNewAllowance: "إضافة بدل جديد",
      addInsuranceForEmployee: "إضافة تأمينات للموظف",
      editEmployees: "تعديل الموظفين",
      editDepartments: "تعديل الأقسام",
      editBranches: "تعديل الفروع",
      editTasks: "تعديل المهام",
      editClients: "تعديل العملاء",
      editCategories: "تعديل التصنيفات",
      editEquipment: "تعديل الأصول",
      editTools: "تعديل الأدوات",
      editPositions: "تعديل المناصب",
      permissionLabels: {
        salaryFinance: "الرواتب والمالية",
        salary: "الرواتب",
        payroll: "كشوف المرتبات",
        transactions: "المعاملات المالية",
        employees: "الموظفين",
        viewEmployees: "عرض الموظفين",
        createEmployees: "إضافة موظفين",
        deleteEmployees: "حذف الموظفين",
        approveEmployees: "الموافقة على الموظفين",
        attendanceGroup: "الحضور والانصراف",
        checkIn: "تسجيل الحضور",
        attendance: "الحضور",
        dailyAttendance: "الحضور اليومي",
        departmentsBranches: "الأقسام والفروع",
        viewDepartments: "عرض الأقسام",
        viewBranches: "عرض الفروع",
        tasks: "المهام",
        viewTasks: "عرض المهام",
        createTasks: "إنشاء مهام",
        deleteTasks: "حذف المهام",
        leaveRequests: "طلبات الإجازة",
        viewLeaveRequests: "عرض طلبات الإجازة",
        leaveApprove: "الموافقة على الإجازات",
        permissionRequests: "طلبات الأذونات",
        viewPermissionRequests: "عرض طلبات الأذونات",
        permissionApprove: "الموافقة على الأذونات",
        reports: "التقارير",
        viewReports: "عرض التقارير",
        salaryReports: "تقارير الرواتب",
        attendanceReports: "تقارير الحضور",
        other: "أخرى",
        clients: "العملاء",
        categories: "التصنيفات",
        equipment: "الأصول",
        tools: "الأدوات",
        positions: "المناصب",
        notifications: "الإشعارات",
        dashboard: "لوحة التحكم",
        devices: "الأجهزة"
      },
      adminRole: "مدير",
      thisUser: "هذا المستخدم",
      assign: "تعيين",
      add: "إضافة",
      update: "تحديث",
      selectAll: "تحديد الكل",
      permissionsLabel: "الصلاحيات",
      departmentsMultiSelect: "الأقسام (يمكن اختيار أكثر من قسم)",
      noDepartmentsAvailable: "لا توجد أقسام متاحة",
      departmentsSelected: "تم اختيار {count} قسم",
      addBonusForEmployee: "إضافة مكافأة للموظف",
      addDeductionForEmployee: "إضافة خصم للموظف",
      addTaxForEmployee: "إضافة ضريبة للموظف",
      currentMonth: "الشهر الحالي",
      permanentAllowance: "بدل دائم",
      approverLabel: "المراجع",
      currentDefaultApprover: "المراجع الافتراضي الحالي",
      customApprover: "مخصص",
      teamLeaderOrAdmin: "تيم ليدر / مدير",
      dailyOrders: "عدد الطلبات اليومية",
      dailyOrdersPlaceholder: "أدخل عدد الطلبات اليومية",
      dailyOrdersHint: "يرجى إدخال عدد الطلبات اليومية المتوقع للموظف",
      contactInfo: "معلومات الاتصال",
      employmentInfo: "معلومات التوظيف",
      fullName: "الاسم الكامل",
      basicSalary: "الراتب الأساسي",
      branch: "الفرع",
      probationStatus: "حالة فترة التجربة",
      selectPosition: "اختر المنصب...",
      selectDepartment: "اختر القسم...",
      selectBranch: "اختر الفرع...",
      shift: "الشيفت",
      selectShift: "اختر الشيفت...",
      noShift: "بدون شيفت (مواعيد الفرع/الشركة)",
      branchChangedShiftWarning: "تم تغيير الفرع — لازم تختار شيفت مناسب للفرع الجديد قبل الحفظ (التوقيت والموقع بيتبعوا الفرع الجديد).",
      branchChangedShiftRequired: "اختر شيفت للفرع الجديد قبل حفظ التعديلات",
      selectStatus: "اختر الحالة",
      editData: "تعديل البيانات",
      saveChanges: "حفظ التغييرات",
      loadingEmployee: "جاري تحميل بيانات الموظف...",
      ended: "منتهي",
      notActivated: "غير مفعل",
      noChangesToSave: "لا توجد تغييرات لحفظها",
      saveDataError: "حدث خطأ أثناء حفظ البيانات",
      allowanceSaveError: "حدث خطأ أثناء حفظ البدل",
      modals: {
        allowanceName: "اسم البدل",
        allowanceNamePlaceholder: "مثال: بدل مواصلات",
        amountPlaceholder: "مثال: 500",
        bonusType: "نوع المكافأة",
        bonusTypePerformance: "مكافأة الأداء",
        bonusTypeAnnual: "مكافأة سنوية",
        bonusTypeProject: "مكافأة مشروع",
        bonusTypeOther: "أخرى",
        bonusDescriptionPlaceholder: "مثال: مكافأة الأداء للعمل الممتاز",
        deductionType: "نوع الخصم",
        deductionAmountPlaceholder: "مثال: 200",
        deductionDescriptionPlaceholder: "مثال: سداد قرض شهري",
        taxName: "اسم الخصم",
        taxNamePlaceholder: "مثال: الضرائب",
        taxAmountPlaceholder: "مثال: 200",
        endDateOptionalPermanent: "تاريخ النهاية (اتركه فارغاً للخصم الدائم)",
        insuranceNamePlaceholder: "مثال: التأمينات الاجتماعية",
        insuranceAmountPlaceholder: "مثال: 300",
        description: "الوصف",
        deductionTypeLoan: "خصم قرض",
        deductionTypeAdvance: "خصم سلفة",
        deductionTypeAbsence: "خصم غياب",
        deductionTypeLate: "خصم تأخير"
      },
      attendanceHeatmap: {
        title: "خريطة الحضور الشهرية",
        subtitle: "حالة كل يوم ظاهرة مباشرة — اضغط على أي يوم للتفاصيل",
        prevMonth: "الشهر السابق",
        nextMonth: "الشهر التالي",
        loading: "جاري تحميل خريطة الحضور...",
        loadError: "فشل تحميل بيانات الحضور",
        noRecord: "لا يوجد سجل",
        futureDay: "يوم قادم",
        legend: "المفتاح",
        selectedDay: "اليوم المحدد",
        presentShort: "في الموعد",
        lateShort: "تأخير",
        absentShort: "غياب",
        leaveShort: "إجازة",
        unpaidLeaveShort: "بدون أجر",
        holidayShort: "عطلة",
        earlyLeaveShort: "انصراف مبكر",
        halfDayShort: "نصف يوم",
        weekendShort: "عطلة",
        emptyShort: "—",
        futureShort: "—",
        pickMonth: "اختر الشهر",
        prevYear: "السنة السابقة",
        nextYear: "السنة التالية",
        thisMonth: "الشهر الحالي"
      }
    },
    quickStats: {
      attendanceDetails: "تفاصيل الحضور",
      attendanceStats: "إحصائيات حضور الموظف",
      attendance: "الحضور",
      coreStats: "الإحصائيات الأساسية",
      workDays: "أيام العمل",
      presentDays: "أيام الحضور",
      absentDays: "أيام الغياب",
      leaves: "الإجازات",
      holidayDays: "أيام العطل",
      secondaryStats: "إحصائيات إضافية",
      late: "التأخير",
      earlyLeave: "المغادرة المبكرة",
      halfDay: "نصف يوم",
      externalTasks: "مهام خارجية",
      hoursStats: "إحصائيات الساعات",
      totalHours: "إجمالي الساعات",
      overtimeHours: "ساعات العمل الإضافي",
      hoursUnit: "ساعة",
      viewDetails: "عرض التفاصيل",
      viewAttendanceLog: "عرض تفاصيل سجل الحضور",
      attendanceLogDetails: "تفاصيل سجل الحضور",
      closeModal: "إغلاق النافذة",
      searchPlaceholder: "ابحث بالتاريخ أو الملاحظات...",
      searchAria: "بحث في سجل الحضور",
      exportCsv: "تصدير كـ CSV",
      exportCsvAria: "تصدير البيانات كملف CSV",
      date: "التاريخ",
      delayHours: "ساعات التأخير",
      deductionAmount: "المبلغ المخصوم",
      overtimeAmount: "مبلغ العمل الإضافي",
      notes: "ملاحظات",
      noRecords: "لا توجد سجلات"
    },
    workTime: {
      title: "مواعيد العمل",
      checkInTime: "وقت الدخول:",
      checkOutTime: "وقت الخروج:",
      dailyHours: "ساعات العمل اليومية:",
      weeklyDays: "أيام العمل الأسبوعية:",
      noWorkDays: "لا توجد أيام محددة",
      settingsNotFound: "لم يتم العثور على إعدادات العمل",
      loadError: "حدث خطأ أثناء تحميل إعدادات العمل",
      hoursCount: "{hours} ساعات",
      hoursAndMinutes: "{hours} ساعات و{minutes} دقيقة",
      defaultHours: "8 ساعات"
    },
    documentsPage: {
      manageTitle: "إدارة المستندات",
      employeeIdMissing: "معرف الموظف غير متوفر",
      fetchFailed: "فشل في جلب المستندات",
      fetchAfterDeleteFailed: "فشل في جلب المستندات بعد الحذف",
      deleteFailed: "فشل في حذف المستند",
      noDescription: "لا يوجد وصف",
      error: "خطأ",
      noDocuments: "لا توجد مستندات",
      noDocumentsForEmployee: "لا يوجد مستندات متاحة لهذا الموظف",
      unknown: "غير معروف",
      viewDocument: "عرض المستند",
      deleteDocument: "حذف المستند",
      newest: "الأحدث",
      oldest: "الأقدم",
      sizeLargest: "حجم الملف (الأكبر)"
    },
    deviceRequests: {
      noRequestsHint: "لم يتم تقديم أي طلبات أجهزة حالياً",
      noDevicesTitle: "لا توجد أجهزة مسجلة",
      noDevicesHint: "لم يتم تسجيل أي أجهزة لهذا الموظف حالياً",
      manufacturer: "الشركة المصنعة",
      reviewDate: "تاريخ المراجعة",
      rejectionReason: "سبب الرفض"
    },
    detailsHolidays: {
      loading: "جاري تحميل الطلبات...",
      duration: "المدة",
      description: "الوصف",
      filterPendingRejectedApproved: "قيد الانتظار, مرفوض, مقبول",
      filterRejectedApprovedPending: "مرفوض, مقبول, قيد الانتظار"
    },
    pending: {
      processing: "جاري...",
      approveTitle: "الموافقة على الموظف",
      rejectTitle: "رفض الموظف",
      viewDetailsTitle: "عرض التفاصيل",
      rejectReasonPrompt: "سبب الرفض (اختياري):",
      noReasonProvided: "لم يتم تقديم سبب",
      employeeRole: "موظف",
      generalDepartment: "قسم عام",
      loadingDetails: "جاري تحميل التفاصيل...",
      loadDetailsFailed: "فشل في تحميل تفاصيل الموظف",
      tryAgain: "يرجى المحاولة مرة أخرى",
      educationAndSkills: "التعليم والمهارات",
      education: "التعليم",
      skills: "المهارات",
      username: "اسم المستخدم",
      maxDevices: "الحد الأقصى للأجهزة",
      registeredDevices: "الأجهزة المسجلة",
      salaryToBeSetByManager: "سوف يتم تحديده من قبل المدير",
      accountStatus: "حالة الحساب",
      approvedCheck: "✓ موافق عليه",
      pendingWait: "⏳ قيد الانتظار",
      rejectedCross: "✗ مرفوض",
      financialSetup: "إعدادات الموظف المالية",
      shiftHint: "اختر شيفت الموظف. التعيين من الأدمن أو قائد الفريق فقط.",
      selectWorkLocationOption: "اختر موقع العمل",
      workLocationHint: "يرجى اختيار موقع عمل الموظف",
      baseSalaryPlaceholder: "أدخل الراتب الأساسي",
      baseSalaryHint: "يرجى إدخال الراتب الأساسي للموظف",
      contractDurationMonths: "مدة العقد (بالأشهر)",
      contractDurationPlaceholder: "مثال: 12",
      contractDurationHint: "إلزامي. أدخل مدة العقد بالأشهر (عدد صحيح أكبر من 0).",
      addNewAllowance: "إضافة بدل جديد",
      allowanceName: "اسم البدل",
      allowanceNamePlaceholder: "مثال: بدل مواصلات، بدل سكن، بدل طعام",
      allowanceAmount: "مبلغ البدل",
      allowanceAmountPlaceholder: "أدخل مبلغ البدل",
      permanentAllowanceHint: "البدل سيكون دائماً مع الموظف بدون تاريخ انتهاء",
      addToList: "إضافة إلى القائمة",
      addedAllowances: "البدلات المضافة ({count})",
      amountPrefix: "المبلغ: {amount}",
      fromDate: "من {date}",
      fromToDate: "من {start} إلى {end}",
      noAllowancesYet: "لم يتم إضافة أي بدلات بعد",
      useFormAbove: "استخدم النموذج أعلاه لإضافة بدل",
      saveData: "حفظ البيانات",
      allowanceCount: "({count} بدل)",
      allowances: "البدلات",
      salaryAndAllowancesSuccess: "تم تعيين الراتب وإضافة {count} بدل بنجاح",
      salaryPartialAllowances: "تم حفظ الراتب وإضافة {success} بدل، ولكن فشل في إضافة {fail} بدل",
      salaryAllowancesAllFailed: "تم حفظ الراتب ولكن فشل في إضافة جميع البدلات",
      salarySavedAllowancesFailed: "تم حفظ الراتب ولكن فشل في إضافة بعض البدلات",
      salarySetSuccess: "تم تعيين الراتب بنجاح",
      saveFailed: "فشل في حفظ البيانات",
      documentN: "مستند {n}",
      sizeLabel: "الحجم: {size}",
      typeLabel: "النوع: {type}",
      leaveDaysCount: "{count} يوم"
    }
  },
  holidays: {
    title: "الاجازات",
    description: "إدارة وإعداد تقارير الإجازات",
    leaveDays: "أيام الإجازة",
    remainingDays: "الأيام المتبقية",
    sickLeave: "أجازة مرضية",
    usedDays: "الأيام المستخدمة",
    workFromHome: "العمل من المنزل",
    upcomingLeave: "إجازة قادمة",
    noLeaveRequests: "لم يتم العثور على طلبات إجازة",
    overview: "نظرة عامة",
    past: "اجازات سابقة",
    requests: "طلبات الاجازة",
    testRequest: "طلب اختباري",
    loading: "جاري التحميل...",
    employeeInfo: "معلومات الموظف",
    name: "الاسم",
    department: "القسم",
    position: "المنصب",
    tableHeaders: {
      leaveType: "نوع الإجازة",
      startDate: "تاريخ البدء",
      endDate: "تاريخ الانتهاء",
      totalDays: "إجمالي الأيام",
      submissionTime: "وقت التقديم",
      status: "الحالة",
      employeeNotes: "ملاحظات الموظف",
      managerNotes: "ملاحظات المدير",
      approvedBy: "الموافقة عليه من قبل"
    },
    status: {
      pending: "قيد الانتظار",
      approved: "موافق عليه",
      rejected: "رفض"
    },
    annualLeave: "الإجازة السنوية",
    remaining: "المتبقي",
    used: "المستخدم",
    day: "يوم",
    days: "أيام",
    sickLeaveTitle: "الإجازة المرضية",
    workFromHomeTitle: "العمل من المنزل",
    unpaidLeave: "الإجازة بدون راتب",
    of: "من",
    filterByStatus: "فلترة حسب الحالة:",
    all: "الكل",
    cancelled: "ملغاة",
    previous: "السابق",
    next: "التالي",
    page: "صفحة",
    request: "طلب",
    pendingRequestsTitle: "الطلبات المعلقة",
    pendingRequestsMessage: "لديك {count} طلب إجازة قيد الانتظار",
    recentRequests: "الطلبات الأخيرة",
    leaveRequests: "طلبات الإجازة",
    myRequests: "طلباتي",
    newRequest: "طلب إجازة جديد",
    hideForm: "إخفاء النموذج",
    reason: "السبب",
    reasonPlaceholder: "أدخل سبب الإجازة",
    leaveCategory: "نوع الإجازة",
    selectLeaveCategory: "اختر نوع الإجازة",
    leaveCategoryRequired: "يرجى اختيار نوع الإجازة",
    startDateRequired: "يرجى تحديد تاريخ البداية",
    endDateRequired: "يرجى تحديد تاريخ النهاية",
    endAfterStart: "تاريخ النهاية يجب أن يكون بعد تاريخ البداية",
    selectStartDate: "اختر تاريخ البداية",
    selectEndDate: "اختر تاريخ النهاية",
    leaveDaysLabel: "عدد أيام الإجازة:",
    submitting: "جاري الإرسال...",
    submitRequest: "إرسال الطلب",
    submitSuccess: "تم إرسال طلب الإجازة بنجاح",
    submitFailed: "فشل في إرسال طلب الإجازة",
    cancelConfirm: "هل أنت متأكد من إلغاء هذا الطلب؟",
    cancelSuccess: "تم إلغاء طلب الإجازة بنجاح",
    cancelFailed: "فشل في إلغاء الطلب",
    fetchFailed: "فشل في جلب طلبات الإجازة",
    employeeIdMissing: "معرف الموظف غير متوفر",
    notAvailable: "غير متوفر",
    from: "من:",
    to: "إلى:",
    daysCount: "{count} يوم",
    requestDate: "تاريخ الطلب:",
    cancel: "إلغاء",
    admin: {
      title: "الإجازات الرسمية",
      description: "إدارة الإجازات الرسمية للشركة والفروع",
      addHoliday: "إضافة إجازة",
      addNewHoliday: "إضافة إجازة جديدة",
      holidayName: "اسم الإجازة",
      holidayNamePlaceholder: "أدخل اسم الإجازة",
      date: "التاريخ",
      branch: "الفرع",
      descriptionLabel: "الوصف",
      descriptionPlaceholder: "أدخل وصف الإجازة",
      allBranchesOrg: "جميع الفروع (المنظمة)",
      allBranches: "جميع الفروع",
      add: "إضافة",
      cancel: "إلغاء",
      edit: "تعديل",
      delete: "حذف",
      save: "حفظ",
      durationDays: "المدة (أيام)",
      actions: "الإجراءات",
      status: "الحالة",
      active: "نشطة",
      inactive: "غير نشطة",
      isActive: "إجازة نشطة",
      employees: "الموظفون",
      employeesHint: "اترك القائمة فارغة لتطبيق الإجازة على الجميع في الفرع/المنظمة. أو اختر موظفين محددين (حينها لا تحتاج اختيار فرع).",
      branchHint: "اختياري. يُستخدم فقط عندما لا تختار موظفين محددين.",
      branchHiddenHint: "النطاق حسب الموظفين المختارين — لا حاجة لاختيار فرع.",
      scopeByEmployees: "حسب الموظفين",
      searchEmployees: "بحث عن موظف...",
      loadingEmployees: "جاري تحميل الموظفين...",
      noEmployees: "لا يوجد موظفون",
      selectAll: "تحديد الكل",
      clearSelection: "مسح التحديد",
      noEmployeesSelected: "لم يُحدد أحد — تنطبق على الجميع في النطاق المختار",
      selectedEmployeesCount: "تم تحديد {count} موظف",
      employeesCount: "{count} موظفون",
      allBranchEmployees: "كل موظفي الفرع",
      allOrgEmployees: "كل موظفي المنظمة",
      filterYear: "السنة",
      filterBranch: "الفرع",
      filterStatus: "الحالة",
      filterAllBranches: "كل الفروع",
      filterOrgWide: "على مستوى المنظمة فقط",
      filterAllStatuses: "كل الحالات",
      seedEgyptian: "إضافة إجازات مصر",
      seeding: "جاري الإضافة...",
      seedConfirm: "إضافة الإجازات الرسمية المصرية لهذه السنة؟",
      seedSuccess: "تم إضافة الإجازات المصرية بنجاح",
      seedFailed: "فشل في إضافة الإجازات المصرية",
      fetchEmployeesFailed: "فشل في تحميل الموظفين",
      noHolidays: "لا توجد إجازات",
      fillRequired: "يرجى ملء جميع الحقول المطلوبة",
      createSuccess: "تم إنشاء الإجازة بنجاح",
      createFailed: "فشل في إنشاء الإجازة",
      editHoliday: "تعديل الإجازة",
      fetchFailed: "فشل في تحميل الإجازات",
      updateSuccess: "تم تحديث الإجازة بنجاح",
      updateFailed: "فشل في تحديث الإجازة",
      deleteConfirm: "هل أنت متأكد من حذف هذه الإجازة؟",
      deleteSuccess: "تم حذف الإجازة بنجاح",
      deleteFailed: "فشل في حذف الإجازة"
    }
  },
  permissions: {
    title: "الأذونات",
    subtitle: "مراجعة وموافقة طلبات الأذونات المقدمة من الموظفين",
    submittedRequests: "الطلبات المقدمة",
    filterByStatus: "فلترة حسب الحالة:",
    all: "الكل",
    loading: "جاري التحميل...",
    noRequests: "لا توجد طلبات أذونات",
    fetchFailed: "فشل في تحميل طلبات الأذونات",
    refresh: "تحديث",
    approve: "موافقة",
    reject: "رفض",
    forwardToAdmin: "تحويل للمدير",
    takeOver: "سحب الطلب",
    approveTitle: "الموافقة على الطلب",
    rejectTitle: "رفض الطلب",
    approveNotes: "ملاحظات (اختياري)",
    approveNotesPlaceholder: "أدخل ملاحظات الموافقة",
    rejectReason: "سبب الرفض",
    rejectReasonPlaceholder: "أدخل سبب الرفض",
    rejectReasonRequired: "يرجى إدخال سبب الرفض",
    cancel: "إلغاء",
    confirmApprove: "تأكيد الموافقة",
    confirmReject: "تأكيد الرفض",
    approveSuccess: "تمت الموافقة على الطلب بنجاح",
    approveFailed: "فشل في الموافقة على الطلب",
    rejectSuccess: "تم رفض الطلب بنجاح",
    rejectFailed: "فشل في رفض الطلب",
    forwardSuccess: "تم تحويل الطلب للمدير",
    forwardFailed: "فشل في تحويل الطلب",
    takeOverSuccess: "تم سحب الطلب بنجاح",
    takeOverFailed: "فشل في سحب الطلب",
    status: {
      pending: "معلق",
      approved: "مقبول",
      rejected: "مرفوض",
      cancelled: "ملغي",
      forwarded: "محوّل للمدير"
    },
    table: {
      employee: "الموظف",
      type: "نوع الإذن",
      date: "التاريخ",
      time: "الوقت",
      reason: "السبب",
      status: "الحالة",
      actions: "الإجراءات"
    },
    previous: "السابق",
    next: "التالي",
    page: "صفحة",
    of: "من",
    requests: "طلب",
  },
  company: {
    title: "إدارة الشركة",
    description: "الوصف",
    branches: "فروع الشركة",
    allBranches: "جميع فروع الشركة",
    addBranch: "إضافة فرع جديد",
    branchName: "اسم الفرع",
    enterBranchName: "أدخل اسم الفرع",
    noBranches: "لا توجد فروع",
    cannotDeleteLast: "لا يمكن حذف آخر فرع",
    alexandriaBranch: "فرع الاسكندرية",
    cairoBranch: "فرع القاهرة",
    active: "نشط",
    inactive: "غير نشط",
    code: "الكود",
    manager: "المدير",
    departments: "الأقسام",
    employees: "الموظفين",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",
    address: "العنوان",
    emailPlaceholder: "example@company.com",
    phonePlaceholder: "01012345678",
    managerPlaceholder: "أدخل اسم المدير",
    addressPlaceholder: "أدخل عنوان الفرع",
    descriptionPlaceholder: "أدخل وصف الفرع (اختياري)",
    departmentsPlaceholder: "0",
    employeesPlaceholder: "0",
    tabs: {
      branches: "الفروع",
      departments: "الأقسام",
      documents: "المستندات",
      assets: "الأصول",
      tools: "الأدوات",
      jobPositions: "المناصب الوظيفية",
      leaveRequests: "طلبات الاجازة",
      devices: "الأجهزة",
      admins: "المديرين",
      orders: "المناديب",
      documentApprovals: "اعتماد المستندات",
      transfers: "التنقلات"
    },
    admins: {
      description: "إنشاء وإدارة مديري المؤسسة",
      createNew: "إنشاء مدير جديد",
      email: "البريد الإلكتروني",
      emailPlaceholder: "admin@example.com",
      username: "اسم المستخدم",
      usernamePlaceholder: "أدخل اسم المستخدم",
      password: "كلمة المرور",
      passwordPlaceholder: "أدخل كلمة المرور",
      firstName: "الاسم الأول",
      firstNamePlaceholder: "أدخل الاسم الأول",
      lastName: "اسم العائلة",
      lastNamePlaceholder: "أدخل اسم العائلة",
      phone: "رقم الهاتف",
      phonePlaceholder: "+201000110001",
      nationalID: "الرقم القومي",
      nationalIDPlaceholder: "أدخل الرقم القومي",
      create: "إنشاء مدير",
      creating: "جاري الإنشاء..."
    },
    content: {
      allCompanyDepartments: "جميع أقسام الشركة",
      uploadDocumentForEmployees: "رفع مستند للموظفين",
      uploadDocumentDescription: "قم برفع مستند وإرساله للموظفين المحددين",
      pendingDevices: "الأجهزة المعلقة",
      pendingRequests: "طلب معلق",
      employeeDevices: "أجهزة الموظفين",
      file: "الملف",
      changeFile: "تغيير الملف",
      clickToSelectFile: "اضغط لاختيار ملف",
      orDragFileHere: "أو اسحب الملف هنا",
      documentTitle: "عنوان المستند",
      enterDocumentTitle: "أدخل عنوان المستند",
      documentDescription: "وصف المستند",
      optional: "(اختياري)",
      enterDocumentDescription: "أدخل وصف المستند (اختياري)",
      selectEmployees: "اختيار الموظفين",
      optionalLeaveEmptyForAll: "(اختياري - اتركه فارغاً لإرسال للجميع)",
      selectAll: "تحديد الكل",
      deselectAll: "إلغاء التحديد",
      loadingEmployees: "جاري تحميل الموظفين...",
      noEmployeesAvailable: "لا يوجد موظفين متاحين",
      noEmployeesOrLoading: "لا يوجد موظفين أو جاري التحميل...",
      selectEmployeeOptional: "اختر موظف (اختياري)",
      employeesSelected: "تم تحديد",
      employee: "موظف",
      uploading: "جاري الرفع...",
      uploadDocument: "رفع المستند",
      refresh: "تحديث",
      uploadedDocuments: "المستندات المرفوعة",
      totalDocuments: "إجمالي",
      document: "مستند",
      all: "الكل",
      company: "الشركة",
      employees: "الموظفين",
      employeeBadge: "موظف",
      companyBadge: "شركة",
      untitledDocument: "مستند بدون عنوان",
      clickEmployeeToViewDocuments: "اضغط على اسم الموظف لعرض كل مستنداته",
      noCompanyDocuments: "لا توجد مستندات للشركة",
      noEmployeeDocuments: "لا توجد مستندات للموظفين",
      noDocumentsUploaded: "لا توجد مستندات مرفوعة",
      startUploadingAbove: "ابدأ برفع مستند جديد أعلاه",
      loading: "جاري التحميل...",
      assets: "الأصول",
      manageCompanyEquipment: "إدارة أصول الشركة",
      noEquipment: "لا توجد أصول",
      addEquipment: "إضافة أصل",
      editBranch: "تعديل الفرع",
      status: "الحالة",
      selectStatus: "اختر الحالة",
      active: "نشط",
      inactive: "غير نشط",
      branchLocation: "موقع الفرع (اختياري)",
      latitude: "خط العرض (Latitude)",
      longitude: "خط الطول (Longitude)",
      areaRadius: "نطاق المنطقة بالمتر (Radius)",
      useMyCurrentLocation: "استخدام موقعي الحالي",
      updateLocationOnMap: "تحديث الموقع على الخريطة",
      branchSettings: "إعدادات الفرع",
      loadingBranchSettings: "جاري تحميل إعدادات الفرع...",
      startTime: "وقت البدء",
      endTime: "وقت الانتهاء",
      gracePeriod: "فترة السماح (بالدقائق)",
      selectAtLeastOneWorkDay: "يرجى اختيار يوم عمل واحد على الأقل",
      scheduleInheritanceTitle: "إعدادات الدوام للفرع",
      scheduleInheritanceHint: "لو اخترت «اتبع الشركة»، موظفو هذا الفرع هيستخدموا إعدادات الشركة الرئيسية (أيام العمل، ساعات الدوام، فترة السماح، والمنطقة الزمنية). لو خصّصت للفرع، الإعدادات هتتطبّق على موظفي الفرع ده فقط.",
      useOrgWorkSchedule: "اتبع الشركة",
      useOrgWorkScheduleHint: "هيتم أخذ أيام العمل وساعات الدوام وفترة السماح والمنطقة الزمنية من إعدادات الشركة الرئيسية.",
      branchShiftsTitle: "شيفتات الفرع",
      useOrgShifts: "وراثة شيفتات الشركة الرئيسية",
      useOrgShiftsHint: "هيتم استخدام الشيفتات المعرّفة في إعدادات الشركة. موظفو هذا الفرع يُعيَّنون على شيفتات الشركة.",
      customizeBranchShifts: "تخصيص شيفتات الفرع",
      customizeBranchShiftsHint: "عرّف شيفتات خاصة بهذا الفرع بشكل مستقل عن شيفتات الشركة.",
      customizeBranchSchedule: "تخصيص لهذا الفرع",
      customizeBranchScheduleHint: "حدد إعدادات مستقلة لهذا الفرع فقط (أيام العمل، الساعات، فترة السماح، والمنطقة الزمنية).",
      fromOrganization: "اتبع الشركة",
      followCompanyLatePenalty: "اتبع الشركة",
      followCompanyLatePenaltyHint: "هيتم استخدام إعدادات غرامة التأخير من الشركة الرئيسية.",
      customizeBranchLatePenalty: "تخصيص لهذا الفرع",
      customizeBranchLatePenaltyHint: "حدد قواعد غرامة التأخير لهذا الفرع فقط.",
      autoCheckoutSettings: "إعدادات الانصراف التلقائي",
      followCompanyAutoCheckout: "اتبع الشركة",
      followCompanyAutoCheckoutHint: "هيتم استخدام إعدادات الانصراف التلقائي من الشركة الرئيسية.",
      customizeBranchAutoCheckout: "تخصيص لهذا الفرع",
      customizeBranchAutoCheckoutHint: "حدد إعدادات الانصراف التلقائي لهذا الفرع فقط.",
      checkInSelfieSettings: "إعدادات صورة الحضور",
      followCompanyCheckInSelfie: "اتبع الشركة",
      followCompanyCheckInSelfieHint: "سياسة صورة الحضور ستُؤخذ من الشركة الرئيسية.",
      customizeBranchCheckInSelfie: "تخصيص لهذا الفرع",
      customizeBranchCheckInSelfieHint: "تعيين وضع الصورة وأنواع العمل لهذا الفرع فقط.",
      checkInSelfieMode: "وضع صورة الحضور",
      checkInSelfieApplyTo: "يُطبَّق على أنواع العمل",
      checkInSelfieApplyToRequired: "اختر نوع عمل واحد على الأقل",
      checkInSelfieModes: {
        off: "معطّل",
        optional: "اختياري",
        required: "إجباري",
      },
      checkInSelfieWorkTypes: {
        office: "مكتب",
        remote: "عن بُعد",
        hybrid: "هجين",
        delivery: "توصيل",
      },
      autoCheckoutEnabled: "تفعيل الانصراف التلقائي",
      autoCheckoutGraceHours: "ساعات بعد انتهاء الشيفت",
      autoCheckoutGraceHoursHint: "عدد الساعات بعد نهاية الدوام قبل الانصراف التلقائي (0–24)",
      autoCheckoutGraceHoursInvalid: "عدد الساعات يجب أن يكون بين 0 و 24",
      autoCheckoutCountOvertime: "احتساب الوقت الإضافي",
      autoCheckoutNotifyEmployee: "إشعار الموظف",
      autoCheckoutNotifyAdmin: "إشعار الإدارة",
      autoCheckoutDeductionSettings: "خصم نسيان تسجيل الخروج",
      followCompanyAutoCheckoutDeduction: "اتبع الشركة",
      followCompanyAutoCheckoutDeductionHint: "هيتم استخدام سياسة الخصم عند نسيان الخروج من الشركة الرئيسية.",
      customizeBranchAutoCheckoutDeduction: "تخصيص لهذا الفرع",
      customizeBranchAutoCheckoutDeductionHint: "حدد سياسة الخصم لهذا الفرع فقط، بما في ذلك عدم الخصم.",
      autoCheckoutDeductionPolicy: "سياسة الخصم",
      autoCheckoutDeductionFree: "بدون خصم",
      autoCheckoutDeductionQuarterDay: "ربع يوم",
      autoCheckoutDeductionHalfDay: "نصف يوم",
      autoCheckoutDeductionFixedAmount: "مبلغ ثابت",
      autoCheckoutDeductionFixedAmountHint: "المبلغ المخصوم بعملة الراتب",
      autoCheckoutDeductionFixedAmountInvalid: "أدخل مبلغاً أكبر من صفر وبحد أقصى منزلتين عشريتين",
      hoursUnit: "ساعة",
      useOrgScheduledRemote: "اتبع أيام الريموت من الشركة",
      useOrgScheduledRemoteHint: "هيتم استخدام أيام العمل عن بُعد المجدولة من إعدادات الشركة الرئيسية.",
      customizeBranchScheduledRemote: "تخصيص أيام الريموت لهذا الفرع",
      customizeBranchScheduledRemoteHint: "حدد أيام الريموت المجدولة ونطاق الموظفين لهذا الفرع فقط.",
      scheduledRemoteFollowCompanyLocked: "غير قابل للتعديل لأن الفرع يتبع إعدادات الشركة. اختر «تخصيص أيام الريموت لهذا الفرع» لتعديل هذه الخيارات.",
      scheduledRemoteTitle: "أيام العمل عن بُعد المجدولة",
      scheduledRemoteHint: "هذا الإعداد لا يغيّر موقع العمل الدائم للموظف. في الأيام المختارة يُعامل كـ Remote ثم يعود تلقائيًا لحالته الأصلية (Office أو Hybrid).",
      scheduledRemoteEnable: "تفعيل أيام الريموت المجدولة",
      scheduledRemoteDays: "أيام الأسبوع",
      scheduledRemoteScope: "نطاق التطبيق",
      scheduledRemoteEmployees: "الموظفون",
      scheduledRemoteDepartments: "الأقسام",
      scheduledRemoteSearchEmployees: "بحث بالاسم أو البريد...",
      scheduledRemoteNoEmployees: "لا يوجد موظفون",
      scheduledRemoteNoDepartments: "لا توجد أقسام",
      scheduledRemoteScopeAll: "جميع الموظفين",
      scheduledRemoteScopeSelected: "موظفين محددين",
      scheduledRemoteScopeDepartment: "أقسام محددة",
      latePenaltySettings: "إعدادات غرامة التأخير",
      enable: "تفعيل",
      penaltyRules: "قواعد الغرامة",
      addRule: "إضافة قاعدة",
      noRulesMessage: "لا توجد قواعد. اضغط على \"إضافة قاعدة\" لإضافة قاعدة جديدة.",
      rule: "قاعدة",
      delayMinutes: "دقائق التأخير *",
      penaltyType: "نوع الغرامة",
      selectPenaltyType: "اختر نوع الغرامة",
      none: "لا يوجد",
      quarterDay: "ربع يوم",
      halfDay: "نصف يوم",
      fullDay: "يوم كامل",
      custom: "مخصص",
      penaltyAmount: "مبلغ الغرامة",
      penaltyDays: "أيام الغرامة",
      tools: {
        title: "الأدوات",
        totalTools: "إجمالي",
        tool: "أداة",
        addTool: "إضافة أداة",
        noTools: "لا توجد أدوات",
        startAddingTool: "ابدأ بإضافة أداة جديدة أعلاه",
        assignmentCount: "عدد التعيينات:",
        creationDate: "تاريخ الإنشاء:",
        showAssignedEmployees: "عرض الموظفين المعينين",
        hideAssignedEmployees: "إخفاء الموظفين المعينين",
        assignedAt: "تم التعيين:",
        addNewTool: "إضافة أداة جديدة",
        toolName: "اسم الأداة *",
        toolNamePlaceholder: "مثال: ChatGPT Pro",
        adding: "جاري الإضافة...",
        add: "إضافة",
        editTool: "تعديل الأداة",
        editToolPlaceholder: "مثال: ChatGPT Pro - محدث",
        updating: "جاري التحديث...",
        update: "تحديث",
        assignTool: "تعيين أداة:",
        selectAll: "تحديد الكل",
        deselectAll: "إلغاء التحديد",
        loadingEmployees: "جاري تحميل الموظفين...",
        noAvailableEmployees: "لا يوجد موظفين متاحين",
        employeesSelected: "تم تحديد",
        employee: "موظف",
        assigning: "جاري التعيين...",
        assign: "تعيين",
        removeTool: "إزالة أداة:",
        employeesSelectedForRemoval: "تم تحديد",
        employeesForRemoval: "موظف للإزالة",
        removing: "جاري الإزالة...",
        remove: "إزالة",
        fetchFailed: "فشل في جلب الأدوات"
      },
      jobPositions: {
        title: "المناصب الوظيفية",
        allPositions: "جميع المناصب الوظيفية",
        addNewPosition: "إضافة منصب جديد",
        noPositions: "لا توجد مناصب وظيفية",
        positionName: "اسم المنصب *",
        enterPositionName: "أدخل اسم المنصب",
        description: "الوصف",
        enterDescription: "أدخل وصف المنصب (اختياري)",
        status: "الحالة",
        selectStatus: "اختر الحالة",
        order: "ترتيب:",
        creating: "جاري الإنشاء...",
        create: "إنشاء",
        createSuccess: "تم إنشاء المنصب بنجاح",
        createFailed: "فشل في إنشاء المنصب",
        deleteConfirm: "هل أنت متأكد من حذف هذا المنصب؟",
        deleteSuccess: "تم حذف المنصب بنجاح",
        deleteFailed: "فشل في حذف المنصب",
        fetchFailed: "فشل في تحميل المناصب الوظيفية",
        orgIdNotFound: "لم يتم العثور على معرف المؤسسة. يرجى تسجيل الخروج والدخول مرة أخرى.",
        invalidOrgIdFormat: "تنسيق معرف المؤسسة غير صحيح. يجب أن يكون بالتنسيق XX-0000 (مثل: DE-5292)",
        enterPositionNameRequired: "يرجى إدخال اسم المنصب"
      },
      leaveRequests: {
        title: "طلبات الإجازة",
        request: "طلب",
        noRequests: "لا توجد طلبات إجازة",
        employee: "الموظف:",
        department: "القسم:",
        position: "المنصب:",
        from: "من:",
        to: "إلى:",
        daysCount: "عدد الأيام:",
        day: "يوم",
        reason: "السبب:",
        leaveCategory: "نوع الإجازة:",
        leaveType: "نوع الإجازة:",
        paid: "مدفوعة",
        unpaid: "غير مدفوعة",
        rejectionReason: "سبب الرفض:",
        notes: "ملاحظات:",
        requestDate: "تاريخ الطلب:",
        approve: "موافقة",
        reject: "رفض",
        previous: "السابق",
        next: "التالي",
        page: "صفحة",
        of: "من",
        approveTitle: "الموافقة على طلب الإجازة",
        leaveTypeLabel: "نوع الإجازة",
        notesLabel: "ملاحظات (اختياري)",
        notesPlaceholder: "أدخل ملاحظات إضافية",
        modifyDays: "تعديل عدد الأيام (اختياري)",
        modifyDaysPlaceholder: "اتركه فارغاً للاحتفاظ بعدد الأيام الأصلي",
        processing: "جاري المعالجة...",
        approveSuccess: "تم الموافقة على طلب الإجازة بنجاح",
        approveFailed: "فشل في الموافقة على الطلب",
        rejectTitle: "رفض طلب الإجازة",
        rejectReasonLabel: "سبب الرفض *",
        rejectReasonPlaceholder: "أدخل سبب رفض طلب الإجازة",
        rejectReasonRequired: "يرجى إدخال سبب الرفض",
        rejectSuccess: "تم رفض طلب الإجازة بنجاح",
        rejectFailed: "فشل في رفض الطلب",
        fetchFailed: "فشل في تحميل طلبات الإجازة",
        unknown: "غير معروف",
        notSpecified: "غير محدد",
        cancelled: "ملغي"
      },
      devices: {
        title: "أجهزة الموظفين",
        device: "جهاز",
        noDevices: "لا توجد أجهزة",
        noPendingRequests: "لا توجد طلبات أجهزة معلقة",
        status: {
          approved: "موافق عليه",
          pending: "قيد الانتظار",
          rejected: "مرفوض"
        },
        deviceType: "نوع الجهاز:",
        brand: "العلامة التجارية:",
        deviceName: "اسم الجهاز:",
        model: "الموديل:",
        deviceId: "معرف الجهاز:",
        system: "نظام التشغيل:",
        type: "نوع:",
        carrier: "مزود الخدمة:",
        requestDate: "تاريخ الطلب:",
        reviewDate: "تاريخ المراجعة:",
        id: "معرف:",
        unknown: "غير معروف",
        notSpecified: "غير محدد",
        unknownDevice: "جهاز غير محدد",
        approve: "موافقة",
        reject: "رفض",
        approveSuccess: "تم الموافقة على طلب الجهاز بنجاح",
        approveFailed: "فشل في الموافقة على طلب الجهاز",
        rejectSuccess: "تم رفض طلب الجهاز بنجاح",
        rejectFailed: "فشل في رفض طلب الجهاز",
        rejectReasonPrompt: "يرجى إدخال سبب الرفض:",
        deleteConfirm: "هل أنت متأكد من حذف هذا الجهاز؟",
        deleteSuccess: "تم حذف الجهاز بنجاح",
        deleteFailed: "فشل في حذف الجهاز",
        deviceIdNotFound: "معرف الجهاز غير موجود",
        previous: "السابق",
        next: "التالي",
        page: "صفحة",
        of: "من"
      },
      buttonTitles: {
        refreshList: "تحديث القائمة",
        branchSettings: "إعدادات الفرع",
        viewBranchLocation: "عرض موقع الفرع",
        editBranch: "تعديل الفرع",
        deleteBranch: "حذف الفرع",
        delete: "حذف",
        reassign: "إعادة تعيين",
        unassign: "إلغاء التعيين",
        assign: "تعيين",
        readingStatistics: "إحصائيات القراءة",
        viewDocument: "عرض المستند",
        deleteDocument: "حذف المستند",
        edit: "تعديل",
        assignToEmployees: "تعيين للموظفين",
        removeFromEmployees: "إزالة من الموظفين",
        deleteDevice: "حذف الجهاز",
        close: "إغلاق"
      },
      confirmDeleteBranch: "هل أنت متأكد من حذف هذا الفرع؟",
      confirmDeleteDepartment: "هل أنت متأكد من حذف هذا القسم؟",
      confirmDeleteEquipment: "هل أنت متأكد من حذف هذا الأصل؟",
      confirmUnassignEquipment: "هل أنت متأكد من إلغاء تعيين هذا الأصل؟",
      confirmDeleteTool: "هل أنت متأكد من حذف هذه الأداة؟",
      confirmDeleteDocument: "هل أنت متأكد من حذف المستند \"{title}\"؟",
      customPenaltyNeedsAmountOrDays: "العقوبة المخصصة تحتاج مبلغًا أو عدد أيام",
      createWithAssign: "إنشاء مع تعيين",
      createWithoutAssign: "إنشاء بدون تعيين",
      creating: "جاري الإنشاء...",
      orgNotFound: "المنظمة غير موجودة",
      addNewEquipment: "إضافة أصل جديد",
      equipmentNameRequired: "اسم الأصل *",
      equipmentNamePlaceholder: "مثال: لابتوب Dell Latitude 5540",
      equipmentDescPlaceholder: "مثال: لابتوب للعمل المكتبي",
      serialNumber: "الرقم التسلسلي",
      serialNumberPlaceholder: "مثال: DL-2024-001",
      priceEGPRequired: "السعر (ج.م) *",
      pricePlaceholder: "مثال: 25000",
      assignToEmployeeOptional: "تعيين لموظف (اختياري)",
      withoutAssignment: "بدون تعيين",
      ordersCount: "{n} طلب",
      loadMore: "تحميل المزيد",
      showingOf: "عرض {shown} من {total}",
      noOrders: "لا توجد طلبات",
      viewEmployeeDetails: "عرض تفاصيل الموظف",
      employeeLabel: "الموظف:",
      emailLabel: "البريد الإلكتروني:",
      phoneLabel: "الهاتف:",
      departmentLabel: "القسم:",
      positionLabel: "المنصب:",
      orderDateLabel: "تاريخ الطلب:",
      locationLabel: "الموقع:",
      createdAtLabel: "تاريخ الإنشاء:",
      viewOnMap: "عرض على الخريطة",
      perPageOption: "{n} لكل صفحة",
      enterCount: "أدخل العدد",
      apply: "تطبيق",
      pageOfOrders: "صفحة {page} من {pages} ({total} طلب)",
      editEquipment: "تعديل الأصل",
      assignEquipment: "تعيين الأصل",
      selectEmployeeRequired: "اختر الموظف *",
      selectEmployeePlaceholder: "اختر موظف",
      selectNewEmployeeRequired: "اختر الموظف الجديد *",
      selectNewEmployeePlaceholder: "اختر موظف جديد",
      equipmentColon: "الأصل:",
      currentlyAssigned: "المعين حالياً:",
      assigning: "جاري التعيين...",
      reassigning: "جاري إعادة التعيين...",
      assigned: "معين",
      returned: "مسترد",
      serialNumberColon: "الرقم التسلسلي:",
      priceLabel: "السعر",
      egp: "ج.م",
      assignedToColon: "معين ل:",
      assignmentDateColon: "تاريخ التعيين:",
      autoPenaltyCalculated: "سيتم احتساب هذه الغرامة تلقائياً حسب ساعات العمل",
      setWorkStartEndRequired: "يرجى تحديد وقت بداية ونهاية العمل للفرع",
      selectTimezoneRequired: "يرجى اختيار المنطقة الزمنية للفرع",
      addLatePenaltyRuleOrDisable: "أضف قاعدة تأخير واحدة واحدةحدة على الأقل أو عطّل عقوبات التأخير",
      invalidLatePenaltyType: "كل قاعدة تأخير يجب أن يكون لها نوع عقوبة صالح",
      totalReads: "إجمالي القراءات",
      employeesWhoRead: "الموظفين الذين قرأوا",
      readersList: "قائمة القراء",
      unknownEmployee: "موظف غير معروف",
      addressLabel: "العنوان:",
      coordinatesLabel: "الإحداثيات:",
      areaRadiusLabel: "نطاق المنطقة:",
      meters: "متر",
      addNewDepartment: "إضافة قسم جديد",
      editDepartment: "تعديل القسم",
      editPosition: "تعديل المنصب الوظيفي",
      editPositionHint: "سيتم تحديث الاسم عند جميع الموظفين الذين يحملون هذا المنصب تلقائيًا.",
      deleteDepartment: "حذف القسم",
      editDepartmentHint: "سيتم تحديث الاسم عند جميع الموظفين التابعين لهذا القسم تلقائيًا.",
      departmentName: "اسم القسم",
      enterDepartmentName: "أدخل اسم القسم",
      saving: "جاري الحفظ...",
      toasts: {
        loadBranchesFailed: "خطأ {status}: فشل في تحميل الفروع",
        fetchDevicesFailed: "فشل في جلب بيانات الأجهزة",
        fetchPendingDeviceRequestsFailed: "فشل في جلب طلبات الأجهزة المعلقة",
        createBranchSuccess: "تم إنشاء الفرع بنجاح",
        createBranchFailed: "فشل في إنشاء الفرع",
        deleteBranchSuccess: "تم حذف الفرع بنجاح",
        deleteBranchFailed: "فشل في حذف الفرع",
        updateBranchSuccess: "تم تحديث الفرع بنجاح",
        updateBranchFailed: "فشل في تحديث الفرع",
        loadBranchSettingsFailed: "فشل في تحميل إعدادات الفرع. سيتم استخدام البيانات المحفوظة محلياً.",
        updateBranchSettingsSuccess: "تم تحديث إعدادات الفرع بنجاح",
        updateBranchSettingsFailed: "فشل في تحديث إعدادات الفرع",
        loadDepartmentsFailed: "فشل في تحميل الأقسام",
        fetchOrdersFailed: "فشل في جلب بيانات الطلبات",
        createDepartmentSuccess: "تم إنشاء القسم بنجاح",
        createDepartmentFailed: "فشل في إنشاء القسم",
        updateDepartmentSuccess: "تم تحديث اسم القسم بنجاح",
        updateDepartmentFailed: "فشل في تحديث اسم القسم",
        updateDepartmentEmployeesUpdated: "(تم تحديث {count} موظف)",
        updatePositionSuccess: "تم تحديث اسم المنصب الوظيفي بنجاح",
        updatePositionFailed: "فشل في تحديث اسم المنصب الوظيفي",
        updatePositionEmployeesUpdated: "(تم تحديث {count} موظف)",
        deleteDepartmentSuccess: "تم حذف القسم بنجاح",
        deleteDepartmentFailed: "فشل في حذف القسم",
        fetchEquipmentFailed: "فشل في جلب بيانات الأصول",
        createEquipmentSuccess: "تم إنشاء الأصل بنجاح",
        createEquipmentAssignedSuccess: "تم إنشاء الأصل وتعيينه بنجاح",
        createEquipmentFailed: "فشل في إنشاء الأصل",
        updateEquipmentSuccess: "تم تحديث الأصل بنجاح",
        updateEquipmentFailed: "فشل في تحديث الأصل",
        deleteEquipmentSuccess: "تم حذف الأصل بنجاح",
        deleteEquipmentFailed: "فشل في حذف الأصل",
        assignEquipmentSuccess: "تم تعيين الأصل بنجاح",
        assignEquipmentFailed: "فشل في تعيين الأصل",
        unassignEquipmentSuccess: "تم إلغاء تعيين الأصل بنجاح",
        unassignEquipmentFailed: "فشل في إلغاء تعيين الأصل",
        reassignEquipmentSuccess: "تم إعادة تعيين الأصل بنجاح",
        reassignEquipmentFailed: "فشل في إعادة تعيين الأصل",
        fetchDocumentsFailed: "فشل في جلب المستندات",
        fetchDocumentStatsFailed: "فشل في جلب إحصائيات المستند",
        deleteDocumentSuccess: "تم حذف المستند بنجاح",
        deleteDocumentAffectedEmployees: " (تم تحديث {count} موظف)",
        deleteDocumentFailed: "فشل في حذف المستند",
        uploadDocumentSuccess: "تم رفع المستند بنجاح",
        uploadDocumentSummary: " (تم تحديث {updated} موظف، تم إشعار {notified} موظف)",
        uploadDocumentFailed: "فشل في رفع المستند",
        fetchEmployeesFailed: "فشل في جلب الموظفين",
        createToolSuccess: "تم إنشاء الأداة بنجاح",
        createToolFailed: "فشل في إنشاء الأداة",
        updateToolSuccess: "تم تحديث الأداة بنجاح",
        updateToolFailed: "فشل في تحديث الأداة",
        deleteToolSuccess: "تم حذف الأداة بنجاح",
        deleteToolFailed: "فشل في حذف الأداة",
        assignToolSuccess: "تم تعيين الأداة لـ {count} موظف بنجاح",
        assignToolFailed: "فشل في تعيين الأداة",
        removeToolSuccess: "تم إزالة الأداة من {count} موظف بنجاح",
        removeToolFailed: "فشل في إزالة الأداة",
        createAdminSuccess: "تم إنشاء المدير بنجاح",
        createAdminFailed: "فشل في إنشاء المدير",
        onlyOrgAdminsCanCreate: "فقط مشرفو المنظمة يمكنهم إنشاء مشرفين إضافيين"
      }
    },
    days: {
      sunday: "الأحد",
      monday: "الإثنين",
      tuesday: "الثلاثاء",
      wednesday: "الأربعاء",
      thursday: "الخميس",
      friday: "الجمعة",
      saturday: "السبت"
    }
  },
  reports: {
    title: "التقارير",
    description: "عرض وإدارة جميع تقارير النظام",
    generalInfo: "معلومات عامة",
    generalInfoDesc: "عرض المعلومات العامة عن الموظفين والشركة",
    salaryInfo: "معلومات المرتبات",
    salaryInfoDesc: "تقارير شاملة عن الرواتب والبدلات",
    employmentInfo: "معلومات التوظيف",
    employmentInfoDesc: "تفاصيل التوظيف وتاريخ التعيين",
    leaveBalance: "رصيد الأجازات",
    leaveBalanceDesc: "عرض رصيد الأجازات المتبقي لكل موظف",
    annualLeaves: "أجازات العام",
    annualLeavesDesc: "سجل جميع الأجازات خلال السنة",
    contactInfo: "معلومات الأتصال",
    contactInfoDesc: "بيانات الاتصال لجميع الموظفين",
    birthdays: "أعياد الميلاد",
    birthdaysDesc: "قائمة أعياد ميلاد الموظفين",
    emergencyContact: "الإتصال في حالات الطوارىء",
    emergencyContactDesc: "معلومات الاتصال للطوارئ",
    probationPeriods: "فترات التجربة",
    probationPeriodsDesc: "متابعة فترات التجربة للموظفين الجدد",
    formerEmployees: "الموظفين السابقين",
    formerEmployeesDesc: "سجل الموظفين الذين غادروا الشركة",
    bankAccounts: "الحسابات البنكية",
    bankAccountsDesc: "معلومات الحسابات البنكية للموظفين",
    fixedAssets: "العهد",
    fixedAssetsDesc: "سجل العهد ",
    attendanceData: "بيانات الحضور",
    attendanceDataDesc: "تقارير مفصلة عن الحضور والانصراف",
    disciplinaryReport: "تقرير الجزاءات",
    disciplinaryReportDesc: "سجل الجزاءات والتحذيرات",
    permissionRequests: "طلبات الإذونات",
    permissionRequestsDesc: "متابعة طلبات الإذونات والمصادقات",
    backToReports: "العودة إلى التقارير",
    reportNotFound: "التقرير غير موجود",
    reportNotFoundDesc: "التقرير المطلوب غير موجود أو تم حذفه.",
    loadingData: "جاري تحميل البيانات...",
    errorLoadingData: "حدث خطأ أثناء تحميل البيانات",
    errorFetchingData: "حدث خطأ أثناء جلب البيانات. يرجى المحاولة مرة أخرى.",
    errorExportingFile: "حدث خطأ أثناء تصدير الملف",
    dataLabel: "البيانات",
    reportSheetName: "التقرير",
    totalEmployees: "إجمالي الموظفين",
    activeEmployees: "الموظفين النشطين",
    onLeaveEmployees: "في إجازة",
    totalDepartments: "عدد الأقسام",
    averageSalary: "متوسط الراتب",
    totalSalary: "إجمالي الرواتب",
    maxSalary: "أعلى راتب",
    minSalary: "أقل راتب",
    totalAllowances: "إجمالي البدلات",
    totalDeductions: "إجمالي الخصومات",
    totalFormerEmployees: "إجمالي الموظفين السابقين",
    employeeList: "قائمة الموظفين",
    downloadExcel: "تحميل Excel",
    no: "لا",
    serialNo: "#",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    department: "القسم",
    position: "الوظيفة",
    status: "الحالة",
    joinDate: "تاريخ الانضمام",
    workLocation: "موقع العمل",
    baseSalary: "الراتب الأساسي",
    allowances: "البدلات",
    deductions: "الخصومات",
    netSalary: "صافي الراتب",
    approvalStatus: "حالة الموافقة",
    startDate: "تاريخ البدء",
    directManager: "المدير المباشر",
    teamLeader: "قائد فريق",
    distributionByStatus: "التوزيع حسب الحالة",
    birthDate: "تاريخ الميلاد",
    birthday: "عيد الميلاد",
    daysUntilBirthday: "الأيام المتبقية",
    probationEndDate: "تاريخ انتهاء التجربة",
    daysRemaining: "الأيام المتبقية",
    endDate: "تاريخ الانتهاء",
    reason: "السبب",
    requestDate: "تاريخ الطلب",
    duration: "المدة (أيام)",
    approvedBy: "وافق عليه",
    rejectionReason: "سبب الرفض",
    date: "التاريخ",
    checkIn: "وقت الدخول",
    checkOut: "وقت الخروج",
    workHours: "ساعات العمل",
    overtimeHours: "ساعات إضافية",
    earlyLeave: "مغادرة مبكرة",
    deductionAmount: "مبلغ الخصم",
    assetName: "اسم الأصل",
    assetStatus: "الحالة",
    assignedTo: "معين لـ",
    assetPrice: "السعر",
    assets: "الأصول",
    assetsCount: "عدد الأصول",
    assignedDate: "تاريخ التعيين",
    serialNumber: "الرقم التسلسلي",
    noAssets: "لا توجد أصول",
    noFixedAssetsData: "لا توجد بيانات أصول ثابتة متاحة",
    issuedAssets: "العهد",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    iban: "IBAN",
    noEmployeeData: "لا توجد بيانات موظفين متاحة",
    noDataAvailable: "لا توجد بيانات متاحة",
    employeesWithSalary: "الموظفون ذوو الراتب",
    notSpecified: "غير محدد",
    active: "نشط",
    inactive: "غير نشط",
    onLeave: "في إجازة",
    underTraining: "تحت التدريب",
    serviceEnded: "منتهي الخدمة",
    resigned: "استقال",
    pending: "قيد الانتظار",
    approved: "موافق عليه",
    rejected: "مرفوض",
    underReview: "قيد المراجعة",
    approvedPlural: "موافق عليهم",
    teamLeaders: "قادة الفرق",
    distributionByDepartments: "التوزيع حسب الأقسام",
    departmentLabels: {
      management: "الإدارة"
    },
    totalApprovedLeaves: "إجمالي الأجازات الموافق عليها",
    totalPendingLeaves: "إجمالي الأجازات قيد المراجعة",
    averageLeaveBalance: "متوسط رصيد الأجازات",
    totalLeaveBalance: "إجمالي رصيد الأجازات",
    totalRejectedLeaves: "إجمالي الأجازات المرفوضة",
    totalLeaveRequests: "إجمالي طلبات الأجازات",
    totalLeaves: "إجمالي الأجازات",
    totalPendingLeavesDays: "إجمالي أيام الأجازات قيد المراجعة",
    pendingCount: "قيد المراجعة (عدد)",
    pendingDays: "قيد المراجعة (أيام)",
    approvedCount: "موافق عليها (عدد)",
    approvedDays: "موافق عليها (أيام)",
    totalDeductionsLabel: "إجمالي الخصومات",
    selectYear: "اختر السنة",
    year: "السنة",
    totalAllLeaves: "إجمالي جميع الأجازات",
    totalApprovedLeaveDays: "إجمالي أيام الأجازات الموافق عليها",
    totalAllLeaveDays: "إجمالي أيام جميع الأجازات",
    annualLeavesTitle: "أجازات العام",
    totalPermissionDays: "إجمالي أيام الإذونات",
    leaveTypeAnnual: "سنوية",
    leaveTypeSick: "مرضية",
    leaveType: "نوع الإجازة",
    selectDays: "اختر عدد الأيام",
    notAvailable: "غير متوفر",
    selectTimePeriod: "اختر الفترة الزمنية",
    fromDate: "من تاريخ:",
    toDate: "إلى تاريخ:",
    search: "بحث",
    totalRecords: "إجمالي السجلات",
    numberOfEmployees: "عدد الموظفين",
    present: "حضور في الموعد",
    late: "تأخير",
    absent: "غياب",
    totalAbsences: "إجمالي الغيابات",
    totalLateArrivals: "إجمالي التأخيرات",
    absences: "غيابات",
    lateArrivals: "تأخيرات",
    hour: "ساعة",
    hours: "ساعات",
    yes: "نعم",
    noAttendanceDataForPeriod: "لا توجد بيانات حضور متاحة للفترة المحددة",
    attendanceDataReport: "بيانات الحضور",
    totalPositions: "عدد الوظائف",
    totalStatuses: "عدد الحالات",
    totalAssets: "إجمالي الأصول",
    all: "الكل",
    totalDisciplinaryActions: "إجمالي الجزاءات",
    totalWarnings: "إجمالي التحذيرات",
    totalPenalties: "إجمالي العقوبات",
    totalPenaltyAmount: "إجمالي مبلغ العقوبات",
    disciplinaryActions: "الجزاءات",
    warnings: "تحذيرات",
    penalties: "عقوبات",
    selectRequestStatus: "اختر حالة الطلبات",
    requestStatus: "الحالة:",
    totalRequests: "إجمالي الطلبات",
    noPermissionRequestsForStatus: "لا توجد طلبات إذونات متاحة للحالة المحددة",
    daysInProbation: "أيام في التجربة",
    departureDate: "تاريخ المغادرة",
    paymentMethod: "طريقة الدفع",
    bankTransfer: "تحويل بنكي",
    noContactData: "لا توجد بيانات اتصال متاحة",
    employeesWithEmail: "الموظفين الذين لديهم بريد إلكتروني",
    employeesWithPhone: "الموظفين الذين لديهم هاتف",
    employeesWithEmergencyContact: "الموظفين الذين لديهم جهة اتصال للطوارئ",
    address: "العنوان",
    probationCompleted: "اكتملت فترة التجربة",
    inProbationPeriod: "في فترة التجربة",
    averageDaysRemaining: "متوسط الأيام المتبقية",
    completed: "مكتمل",
    employeesWithBankAccount: "الموظفين الذين لديهم حساب بنكي",
    employeesWithIBAN: "الموظفين الذين لديهم IBAN",
    employeesWithSwiftCode: "الموظفين الذين لديهم Swift Code",
    employeesWithAssets: "الموظفين الذين لديهم أصول",
    totalWorkingHours: "إجمالي ساعات العمل",
    totalOvertimeHours: "إجمالي ساعات العمل الإضافي",
    employeesWithDisciplinary: "الموظفين الذين لديهم جزاءات",
    noSalaryData: "لا توجد بيانات مرتبات متاحة",
    salaryBreakdown: {
      title: "تفاصيل الراتب",
      clickHint: "اضغط على موظف لعرض شرح تفاصيل الراتب",
      close: "إغلاق",
      ok: "موافق",
      prorationTitle: "لماذا المبلغ أقل من الراتب المعين؟",
      prorationExplain: "لأن تاريخ الانضمام {date}، يُحتسب الراتب الأساسي والبدلات والمكافآت بنسبة أيام العمل هذا الشهر ({actual} يوم من أصل {total} يوم عمل).",
      baseSalaryExplain: "هذا هو الراتب الأساسي الكامل الذي عيّنته الإدارة للموظف.",
      baseSalaryExplainProrated: "هذا الراتب الأساسي الشهري الكامل. المبلغ المستحق محسوب جزئياً لهذا الشهر بسبب تاريخ الانضمام.",
      thisMonthBase: "الأساسي لهذا الشهر (بعد الاحتساب الجزئي)",
      bonuses: "المكافآت",
      totalBonuses: "إجمالي المكافآت",
      overtime: "عمل إضافي",
      noAllowances: "لا توجد بدلات معيّنة حالياً",
      noBonuses: "لا توجد مكافآت هذا الشهر",
      noDeductions: "لا توجد خصومات هذا الشهر",
      amountDue: "المبلغ المستحق (صافي الراتب)",
      amountDueHint: "بعد البدلات والمكافآت والخصومات",
      amountDueHintProrated: "مستحق عن {actual} يوم من أصل {total} يوم عمل",
      netFormula: "الصافي = الأساسي المحتسب + البدلات + المكافآت − الخصومات",
    },
    noEmploymentData: "لا توجد بيانات توظيف متاحة",
    noLeaveBalanceData: "لا توجد بيانات رصيد أجازات متاحة",
    noAnnualLeavesData: "لا توجد بيانات أجازات متاحة للعام",
    leaveDetails: "تفاصيل الأجازات:",
    from: "من",
    to: "إلى",
    totalBirthdays: "إجمالي أعياد الميلاد",
    upcomingBirthdays: "أعياد الميلاد القادمة",
    daysUntil: "الأيام المتبقية",
    age: "العمر",
    noBirthdaysInPeriod: "لا توجد أعياد ميلاد قادمة خلال",
    noProbationData: "لا توجد بيانات فترات تجربة متاحة",
    noDisciplinaryData: "لا توجد بيانات جزاءات متاحة",
    disciplinaryDetails: "تفاصيل الجزاءات:",
    penaltyAmount: "مبلغ العقوبة:",
    day: "يوم",
    days: "أيام",
    rejectedCount: "مرفوضة (عدد)",
    rejectedDays: "مرفوضة (أيام)",
    annual: "سنوية",
    sick: "مرضية",
    export: {
      notSpecified: "غير محدد",
      notAvailable: "غير متوفر",
      leaveAnnual: "سنوية",
      leaveSick: "مرضية",
      leaveApproved: "موافق عليها",
      leavePending: "قيد المراجعة",
      leaveRejected: "مرفوضة",
      male: "ذكر",
      female: "أنثى",
      yes: "نعم",
      no: "لا",
      approvedSingular: "موافق عليه",
      penalty: "عقوبة",
      warning: "تحذير",
      bankTransfer: "تحويل بنكي",
      leaveDetails: "تفاصيل الأجازات",
      disciplinaryDetails: "تفاصيل الجزاءات",
      employeesWithAddress: "موظفين لديهم عنوان",
      numberOfDays: "عدد الأيام",
      numberOfPositions: "عدد الوظائف",
      numberOfStatuses: "عدد الحالات",
      daysSuffix: "أيام",
      daySuffix: "يوم",
      headers: {
        number: "#",
        employeeNumber: "رقم الموظف",
        name: "الاسم",
        employeeName: "اسم الموظف",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        department: "القسم",
        position: "الوظيفة",
        status: "الحالة",
        joinDate: "تاريخ الانضمام",
        nationalId: "الرقم القومي",
        gender: "الجنس",
        birthDate: "تاريخ الميلاد",
        birthday: "عيد الميلاد",
        address: "العنوان",
        workLocation: "موقع العمل",
        directManager: "المدير المباشر",
        baseSalary: "الراتب الأساسي",
        allowances: "البدلات",
        deductions: "الخصومات",
        netSalary: "صافي الراتب",
        approvalStatus: "حالة الموافقة",
        startDate: "تاريخ البدء",
        endDate: "تاريخ الانتهاء",
        teamLead: "قائد فريق",
        periodOfStay: "فترة البقاء (أيام)",
        totalLeaves: "إجمالي الأجازات",
        approved: "موافق عليها",
        pending: "قيد المراجعة",
        rejected: "مرفوضة",
        leaveBalance: "رصيد الأجازات",
        year: "السنة",
        approvedCount: "موافق عليها (عدد)",
        approvedDays: "موافق عليها (أيام)",
        pendingCount: "قيد المراجعة (عدد)",
        pendingDays: "قيد المراجعة (أيام)",
        rejectedCount: "مرفوضة (عدد)",
        rejectedDays: "مرفوضة (أيام)",
        leaveType: "نوع الإجازة",
        daysCount: "عدد الأيام",
        emergencyContactName: "جهة اتصال الطوارئ - الاسم",
        emergencyContactPhone: "جهة اتصال الطوارئ - الهاتف",
        daysRemaining: "الأيام المتبقية",
        age: "العمر",
        daysInProbation: "أيام في التجربة",
        completed: "اكتملت",
        date: "التاريخ",
        checkIn: "وقت الدخول",
        checkOut: "وقت الخروج",
        workHours: "ساعات العمل",
        overtimeHours: "ساعات إضافية",
        earlyLeave: "مغادرة مبكرة",
        deductionAmount: "مبلغ الخصم",
        totalActions: "إجمالي الجزاءات",
        absences: "غيابات",
        lateArrivals: "تأخيرات",
        warnings: "تحذيرات",
        penalties: "عقوبات",
        type: "النوع",
        reason: "السبب",
        description: "الوصف",
        penaltyAmount: "مبلغ العقوبة",
        bankName: "اسم البنك",
        accountNumber: "رقم الحساب",
        iban: "IBAN",
        swiftCode: "Swift Code",
        paymentMethod: "طريقة الدفع",
        departureDate: "تاريخ المغادرة",
        requestId: "رقم الطلب",
        requestDate: "تاريخ الطلب",
        duration: "المدة (أيام)",
        approvedBy: "وافق عليه",
        rejectionReason: "سبب الرفض",
        totalEmployees: "إجمالي الموظفين",
        activeEmployees: "الموظفين النشطين",
        onLeave: "في إجازة",
        departmentsCount: "عدد الأقسام",
        totalBaseSalaries: "إجمالي الرواتب الأساسية",
        averageSalary: "متوسط الراتب",
        maxSalary: "أعلى راتب",
        minSalary: "أقل راتب",
        totalAllowances: "إجمالي البدلات",
        totalDeductions: "إجمالي الخصومات",
        employeesCount: "عدد الموظفين",
        approvedCountStat: "موافق عليهم",
        underReview: "قيد المراجعة",
        teamLeaders: "قادة الفرق",
        totalApprovedLeaves: "إجمالي الأجازات الموافق عليها",
        totalPendingLeaves: "إجمالي الأجازات قيد المراجعة",
        totalRejectedLeaves: "إجمالي الأجازات المرفوضة",
        totalLeaveBalance: "إجمالي رصيد الأجازات",
        averageLeaveBalance: "متوسط رصيد الأجازات",
        totalLeaveRequests: "إجمالي طلبات الأجازات",
        totalApprovedLeaveDays: "إجمالي أيام الأجازات الموافق عليها",
        totalPendingLeaveDays: "إجمالي أيام الأجازات قيد المراجعة",
        totalRejectedLeaveDays: "إجمالي أيام الأجازات المرفوضة",
        totalAllLeaveDays: "إجمالي أيام جميع الأجازات",
        employeesWithEmail: "موظفين لديهم بريد إلكتروني",
        employeesWithPhone: "موظفين لديهم رقم هاتف",
        employeesWithEmergencyContact: "موظفين لديهم جهة اتصال طوارئ",
        totalBirthdays: "إجمالي أعياد الميلاد",
        probationCompleted: "اكتملت فترة التجربة",
        inProbation: "قيد فترة التجربة",
        averageDaysRemaining: "متوسط الأيام المتبقية",
        totalDisciplinaryActions: "إجمالي الجزاءات",
        totalWarnings: "إجمالي التحذيرات",
        totalPenalties: "إجمالي العقوبات",
        totalAbsences: "إجمالي الغيابات",
        totalLateArrivals: "إجمالي التأخيرات",
        employeesWithActions: "موظفين لديهم جزاءات",
        totalPenaltyAmount: "إجمالي مبلغ العقوبات",
        employeesWithBankAccount: "موظفين لديهم حساب بنكي",
        employeesWithIBAN: "موظفين لديهم IBAN",
        employeesWithSwiftCode: "موظفين لديهم Swift Code",
        totalFormerEmployees: "إجمالي الموظفين السابقين",
        totalRequests: "إجمالي الطلبات",
        totalPermissionDays: "إجمالي أيام الإذونات"
      },
      fileNames: {
        generalInfo: "معلومات_عامة",
        salaryInfo: "معلومات_المرتبات",
        employmentInfo: "معلومات_التوظيف",
        leaveBalance: "رصيد_الأجازات",
        annualLeaves: "أجازات_العام",
        contactInfo: "معلومات_الاتصال",
        upcomingBirthdays: "أعياد_الميلاد_القادمة",
        days: "أيام",
        probationPeriods: "فترات_التجربة",
        attendanceData: "بيانات_الحضور",
        disciplinaryReport: "تقرير_الجزاءات",
        bankAccounts: "الحسابات_البنكية",
        formerEmployees: "الموظفين_السابقين",
        permissionRequests: "طلبات_الإذونات",
        statusAll: "الكل",
        statusPending: "قيد_المراجعة",
        statusApproved: "موافق_عليها",
        statusRejected: "مرفوضة"
      }
    }
  },
  payroll: {
    title: "نظام إدارة الرواتب",
    description: "إدارة شاملة لرواتب الموظفين والفترات المالية",
    totalSalaries: "إجمالي الرواتب",
    beforeDeductions: "قبل الخصومات والمكافآت",
    allBasicSalaries: "جميع الرواتب الأساسية",
    beforeModifications: "قبل أي تعديلات",
    remainingSalaries: "الرواتب المتبقية",
    afterDeductions: "بعد الخصومات والمكافآت",
    forDisplayedEmployees: "للموظفين المعروضين",
    readyForPayment: "جاهزة للدفع",
    bonuses: "المكافآت",
    bonusesThisMonth: "مكافآت هذا الشهر",
    totalBonuses: "إجمالي المكافآت",
    forMonth: "لشهر",
    deductions: "الخصومات",
    deductionsThisMonth: "خصومات هذا الشهر",
    totalDeductions: "إجمالي الخصومات",
    monthlySummary: "ملخص الرواتب الشهرية",
    monthlySummaryDesc: "عرض تفاصيل الرواتب لشهر محدد",
    showSummary: "عرض الملخص",
    hideSummary: "إخفاء الملخص",
    backToEmployees: "العودة للموظفين",
    loading: "جارٍ تحميل البيانات...",
    adjustments: "التعديلات",
    adjustmentsDesc: "دفع جزئي (سلفه), تعديلات المرتب , خصم , مكافأه , دفع المرتب",
    stats: "الإحصائيات",
    statsDesc: "تحليلات مفصلة للرواتب",
    categoryAdjustments: "تعديلات",
    categoryAnalytics: "تحليلات",
    tabs: {
      payments: "المدفوعات",
      adjustments: "التعديلات (مكافآت/خصومات)"
    },
    adjustmentsPage: {
      title: "إدارة الرواتب والتعديلات",
      employeeLabel: "الموظف: {name}",
      viewDetails: "عرض التفاصيل",
      selectEmployee: "يرجى اختيار موظف",
      fillRequiredFields: "يرجى ملء جميع الحقول المطلوبة",
      fillRequiredAmount: "يرجى ملء جميع الحقول المطلوبة (المبلغ يجب أن يكون أكبر من 0)",
      fullPaymentTitle: "دفع الراتب الكامل",
      partialPaymentTitle: "دفع جزئي (سلفة)",
      month: "الشهر",
      monthPlaceholder: "YYYY-MM (مثال: 2025-01)",
      paymentMethod: "طريقة الدفع",
      bankTransfer: "تحويل بنكي",
      cash: "نقدي",
      referenceNumberOptional: "رقم المرجع (اختياري)",
      referenceNumber: "رقم المرجع",
      notesOptional: "ملاحظات (اختياري)",
      notesPlaceholder: "أي ملاحظات إضافية",
      earlyPayment: "دفع مبكر",
      earlyPaymentReason: "سبب الدفع المبكر",
      earlyPaymentReasonPlaceholder: "سبب الدفع المبكر",
      confirmFullPayment: "تأكيد دفع الراتب",
      amountRequired: "المبلغ *",
      amountPlaceholder: "أدخل المبلغ",
      partialReasonRequired: "سبب الدفع الجزئي *",
      partialReasonPlaceholder: "مثال: سلفة للطوارئ",
      confirmPartialPayment: "تأكيد الدفع الجزئي",
      addBonus: "إضافة مكافأة",
      addDeduction: "إضافة خصم",
      adjustmentType: "نوع التعديل",
      bonusOption: "مكافأة (+)",
      deductionOption: "خصم (-)",
      bonusTypeRequired: "نوع المكافأة *",
      deductionTypeRequired: "نوع الخصم *",
      bonusTypePlaceholder: "مثال: كفاءة في العمل",
      deductionTypePlaceholder: "مثال: تأخير",
      amountMustBePositive: "المبلغ * (يجب أن يكون أكبر من 0)",
      descriptionRequired: "الوصف *",
      descriptionPlaceholder: "مثال: مكافأة بسبب التفاني في العمل",
      submitBonus: "إضافة المكافأة",
      submitDeduction: "إضافة الخصم",
      adjustmentSuccess: "تم إضافة التعديل بنجاح",
      adjustmentFailed: "فشل في إضافة التعديل",
      adjustmentFailedWithError: "فشل في إضافة التعديل: {error}",
      paySuccess: "تم دفع الراتب بنجاح",
      payFailed: "فشل في دفع الراتب",
      payFailedWithError: "فشل في دفع الراتب: {error}",
      partialPaySuccess: "تم دفع الدفعة الجزئية بنجاح",
      partialPayFailed: "فشل في دفع الدفعة الجزئية",
      fetchEmployeeFailed: "فشل في جلب بيانات الموظف",
      fetchEmployeeFailedWithError: "فشل في جلب بيانات الموظف: {error}",
      employeeDataTitle: "بيانات الموظف: {name}",
      close: "إغلاق",
      bonuses: "المكافآت",
      noBonuses: "لا توجد مكافآت",
      deductions: "الخصومات",
      noDeductions: "لا توجد خصومات",
      monthlyPayments: "المدفوعات الشهرية",
      monthPrefix: "الشهر: {month}",
      netSalary: "الراتب الصافي: {amount}",
      paid: "المدفوع: {amount}",
      remaining: "المتبقي: {amount}",
      statusCompleted: "مكتمل",
      statusPending: "معلق"
    },
    labels: {
      basicSalary: "الراتب الأساسي",
      bonusesIncentivesAllowances: "المكافآت والحوافز والبدلات",
      allowances: "البدلات",
      totalRevenue: "إجمالي الإيرادات",
      deductions: "الخصومات",
      deductionsLabel: "الخصومات",
      latePenalties: "غرامات التأخير",
      totalDeductions: "إجمالي الخصومات",
      netSalary: "صافي الراتب",
      totalEmployees: "إجمالي الموظفين",
      totalGrossSalaries: "إجمالي الرواتب الإجمالية",
      totalNetSalaries: "إجمالي صافي الرواتب",
      totalDeductionsSummary: "إجمالي الخصومات",
      totalPaid: "إجمالي المدفوع",
      totalRemaining: "إجمالي المتبقي",
      workDays: "أيام العمل",
      workHours: "ساعات العمل",
      timezone: "المنطقة الزمنية",
      revenue: "الإيرادات"
    },
    currentPeriod: "تعديل الفترة الحالية",
    currentPeriodDesc: "إدارة وحساب رواتب الشهر الحالي",
    previousPeriods: "الفترات السابقة",
    previousPeriodsDesc: "عرض وتعديل رواتب الفترات السابقة",
    previousPeriodsViewDesc: "عرض رواتب الفترات السابقة",
    viewRecords: "عرض السجلات",
    taxSettings: "إعدادات الضرائب والتأمينات",
    taxSettingsDesc: "إدارة إعدادات الضرائب والتأمينات الاجتماعية",
    taxSettingsViewDesc: "عرض وإدارة خصومات جميع الموظفين",
    editSettings: "تعديل الإعدادات",
    back: "العودة",
    downloadPayrollFile: "تحميل ملف الرواتب",
    markAllAsPaid: "تسجيل الجميع كمدفوع",
    deletePayroll: "حذف حساب الرواتب",
    calculateSalary: "احسب الراتب",
    calculating: "جاري الحساب...",
    processing: "جاري المعالجة...",
    markAsPaid: "تسجيل كمدفوع",
    downloadPayslip: "تحميل كشف الراتب",
    revenue: "الإيرادات",
    bankInformation: "معلومات البنك",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    swiftCode: "SWIFT Code",
    selectMonth: "اختر الشهر",
    selectMonthPlaceholder: "-- اختر الشهر --",
    selectMonthToView: "يرجى اختيار شهر لعرض بيانات الرواتب",
    noPayrollData: "لا توجد بيانات رواتب لهذا الشهر. اضغط على \"احسب الراتب\" لبدء الحساب.",
    noPayrollDataForMonth: "لا توجد بيانات رواتب لهذا الشهر.",
    currency: "",
    notSpecified: "غير محدد",
    notAvailable: "غير متوفر",
    row: "الصف",
    filtersAndSearch: "الفلاتر والبحث",
    hide: "إخفاء",
    showFilters: "عرض الفلاتر",
    search: "بحث...",
    allDepartments: "جميع الأقسام",
    allEmployees: "جميع الموظفين",
    withDeductions: "مع خصومات",
    withoutDeductions: "بدون خصومات",
    noSort: "بدون ترتيب",
    highestDeductions: "أعلى خصومات",
    lowestDeductions: "أقل خصومات",
    nameAsc: "الاسم (أ-ي)",
    nameDesc: "الاسم (ي-أ)",
    sortByDepartment: "حسب القسم",
    minAmount: "الحد الأدنى للمبلغ",
    maxAmount: "الحد الأقصى للمبلغ",
    noLimit: "لا يوجد حد",
    clearAllFilters: "مسح جميع الفلاتر",
    noEmployeesAvailable: "لا توجد موظفين متاحين",
    noSearchResults: "لا توجد نتائج للبحث",
    edit: "تعديل",
    cancel: "إلغاء",
    save: "حفظ",
    saving: "جاري الحفظ...",
    delete: "حذف",
    deductionName: "اسم الخصم",
    amount: "المبلغ",
    endDate: "تاريخ النهاية",
    addDeduction: "إضافة خصم",
    addNewDeduction: "إضافة خصم جديد",
    noDeductionsDefined: "لا توجد خصومات محددة",
    showing: "عرض",
    to: "إلى",
    of: "من",
    employees: "موظف",
    previous: "السابق",
    next: "التالي",
    page: "صفحة",
    itemsPerPage: "عدد العناصر",
    deductionTypes: {
      socialInsurance: "التأمينات الاجتماعية",
      insurance: "التأمين",
      tax: "الضرائب",
      loans: "القروض",
      absence: "الغياب"
    },
    status: {
      paid: "مدفوع",
      pending: "قيد الانتظار",
      partiallyPaid: "مدفوع جزئيًا"
    },
    export: {
      employeeName: "اسم الموظف",
      baseSalary: "الراتب الأساسي",
      bonuses: "المكافآت",
      allowances: "البدلات",
      deductions: "الخصومات",
      grossSalary: "الراتب الإجمالي",
      netSalary: "صافي الراتب",
      status: "الحالة",
      sheetName: "رواتب الموظفين",
      fileNamePrefix: "رواتب"
    },
    saveDeductionsSuccess: "تم حفظ الخصومات بنجاح",
    downloadPayrollFileSuccess: "تم تحميل ملف الرواتب بنجاح",
    downloadPayslipSuccess: "تم تحميل كشف الراتب بنجاح",
    markAsPaidSuccess: "تم تسجيل الراتب كمدفوع بنجاح",
    payAllEmployeesSuccess: "تم تسجيل جميع الرواتب كمدفوعة بنجاح",
    calculatePayrollSuccess: "تم حساب الرواتب بنجاح",
    deletePayrollSuccess: "تم حذف حساب الرواتب بنجاح",
    errorFetchingPayroll: "فشل في جلب بيانات الرواتب",
    errorFetchingEmployees: "فشل في تحميل بيانات الموظفين",
    errorDeductionNameRequired: "يرجى إدخال اسم الخصم في",
    errorDeductionAmountRequired: "يرجى إدخال مبلغ صحيح في",
    saveDeductionsFailed: "فشل في حفظ الخصومات",
    errorSavingDeductions: "حدث خطأ أثناء حفظ الخصومات",
    downloadPayrollFileFailed: "فشل في تحميل ملف الرواتب",
    downloadPayslipFailed: "فشل في تحميل كشف الراتب",
    errorSelectMonth: "يرجى تحديد الشهر",
    errorEmployeeIdNotAvailable: "معرف الموظف غير متوفر",
    errorPayrollDataRequired: "يرجى التأكد من وجود بيانات الراتب والشهر",
    markAsPaidFailed: "فشل في تسجيل الراتب كمدفوع",
    payAllEmployeesFailed: "فشل في تسجيل جميع الرواتب كمدفوعة",
    calculatePayrollFailed: "فشل في حساب الرواتب",
    calculatingPayroll: "جاري حساب الرواتب...",
    deletePayrollConfirm: "هل أنت متأكد من حذف حساب الرواتب لهذا الشهر؟ سيتم حذف جميع البيانات المحسوبة.",
    payAllEmployeesConfirm: "هل أنت متأكد من تسجيل جميع الموظفين كمدفوعين؟ سيتم تسجيل جميع رواتب الموظفين لهذا الشهر كمدفوعة.",
    bulkPaymentNote: "دفع جماعي",
    byMonth: {
      searchTitle: "البحث عن شهر محدد",
      year: "السنة",
      monthOptional: "الشهر (اختياري)",
      summaryTitle: "ملخص الرواتب {year}",
      employees: "الموظفين",
      totalSalaries: "إجمالي الرواتب",
      remaining: "المتبقي",
      paid: "المدفوع",
      pending: "معلق",
      paidCount: "مدفوع",
      viewEmployeeDetails: "عرض تفاصيل موظف محدد",
      selectEmployeeOptional: "اختر موظفًا (اختياري)",
      employeePayrollDetails: "تفاصيل رواتب: {name}",
      statusCompleted: "مكتمل",
      statusPartial: "جزئي",
      statusPending: "معلق",
      net: "الصافي:",
      paidLabel: "المدفوع:",
      remainingLabel: "المتبقي:",
      noPayrollData: "لا توجد بيانات رواتب متاحة",
      employeeNotFound: "لم يتم العثور على بيانات لهذا الموظف",
      noDataHint: "لا توجد بيانات متاحة. يرجى اختيار السنة والشهر ثم الضغط على \"بحث\"",
      fetchFailed: "فشل في جلب البيانات"
    }
  },
  attendance: {
    title: "سجل الحضور",
    description: "عرض حضور جميع الموظفين لشهر محدد",
    employeeRecord: "سجل حضور",
    loadingEmployees: "جاري تحميل الموظفين...",
    loadingData: "جاري تحميل البيانات...",
    noEmployees: "لا توجد موظفين",
    noSearchResults: "لا توجد نتائج للبحث",
    noAttendanceData: "لا توجد بيانات حضور لهذا الشهر",
    noAttendanceDataYet: "لا توجد بيانات حضور متاحة حتى الآن",
    employeesList: "سجل الحضور",
    viewAttendance: "عرض الحضور",
    viewAttendanceDetails: "عرض تفاصيل الحضور",
    monthlyDetails: "تفاصيل الحضور الشهري",
    searchPlaceholder: "البحث عن موظف بالاسم، الوظيفة، أو القسم...",
    viewingMonth: "عرض حضور شهر",
    clickToView: "اضغط على زر \"عرض الحضور\" لأي موظف لعرض تفاصيل حضورهم الكاملة لهذا الشهر",
    stats: {
      presentDays: "أيام الحضور",
      absentDays: "أيام الغياب",
      lateDays: "أيام التأخير",
      holidayDays: "أيام الإجازة",
      earlyLeaveDays: "أيام الانصراف المبكر",
      totalHours: "ساعات العمل",
      overtimeHours: "ساعات إضافية"
    },
    tableHeaders: {
      number: "رقم",
      name: "الاسم",
      position: "الوظيفة",
      department: "القسم",
      actions: "الإجراءات",
      employeeName: "اسم الموظف",
      date: "التاريخ",
      checkIn: "الحضور",
      checkOut: "الانصراف",
      checkInLocation: "موقع الحضور",
      checkOutLocation: "موقع الانصراف",
      workingHours: "ساعات العمل",
      status: "الحالة"
    },
    status: {
      present: "حاضر في الموعد",
      absent: "غائب",
      late: "متأخر",
      holiday: "إجازة رسمية",
      leave: "إجازة مدفوعة",
      unpaidLeave: "إجازة غير مدفوعة",
      halfDay: "نصف يوم",
      quarterDay: "ربع يوم",
      earlyLeave: "انصراف مبكر",
      autoCheckout: "انصراف تلقائي",
      externalTask: "مهمة خارجية",
      notSpecified: "غير محدد"
    },
    time: {
      morning: "صباحاً",
      evening: "مساءً",
      hours: "ساعة"
    },
    payroll: {
      generateTitle: "إنشاء خطط الرواتب لهذا الشهر",
      generateDescription: "سيتم حساب الراتب من الحضور والانصراف والخصومات وإنشاء الـ payroll للشهر المحدد",
      generating: "جاري الإنشاء...",
      generateButton: "Generate plans for this month",
      selectEmployeeFirst: "الرجاء اختيار موظف أولاً",
      confirmGenerate: "هل تريد إنشاء payroll للموظف",
      confirmForMonth: "لشهر",
      success: "تم إنشاء payroll بنجاح للموظف",
      error: "حدث خطأ أثناء إنشاء payroll",
      failed: "فشل في إنشاء payroll"
    },
    days: {
      sunday: "الأحد",
      monday: "الإثنين",
      tuesday: "الثلاثاء",
      wednesday: "الأربعاء",
      thursday: "الخميس",
      friday: "الجمعة",
      saturday: "السبت"
    },
    errorLoadingAttendance: "فشل في تحميل بيانات الحضور",
    errorLoadingAttendanceMessage: "حدث خطأ أثناء تحميل بيانات الحضور",
    errorSelectDates: "يرجى تحديد تاريخ البداية والنهاية",
    errorFetchingData: "فشل في جلب البيانات للتصدير",
    noDataToExport: "لا توجد بيانات للتصدير",
    errorExporting: "حدث خطأ أثناء تصدير البيانات",
    userIDNotAvailable: "معرف المستخدم غير متوفر",
    errorLoadingWeeklyAttendance: "فشل في تحميل بيانات الحضور الأسبوعية",
    errorLoadingTodayAttendance: "فشل في تحميل بيانات الحضور اليوم",
    attendanceData: "بيانات الحضور",
    selectDateRange: "اختر الفترة الزمنية",
    selectDateRangeTitle: "اختر الفترة الزمنية",
    cancel: "إلغاء",
    save: "حفظ",
    loading: "جاري التحميل...",
    todayAttendance: "حضور اليوم",
    workedFrom: "عمل من",
    workedTo: "إلى",
    presentDays: "أيام الحضور",
    absentDays: "أيام الغياب",
    earlyLeaveDays: "أيام الانصراف المبكر",
    lateDays: "أيام التأخير",
    holidayDays: "أيام الإجازة",
    periodAttendance: "حضور الفترة",
    workingHoursLabel: "ساعات العمل:",
    hours: "ساعات",
    overtimeHoursLabel: "ساعات إضافية:",
    deductionHoursLabel: "ساعات الخصم:",
    errorFetchingLocation: "خطأ في جلب الموقع",
    enableLocationPermission: "يرجى تفعيل أذونات الموقع في المتصفح",
    browserNotSupportGeolocation: "المتصفح لا يدعم Geolocation API",
    mainOffice: "المكتب الرئيسي",
    deliveryByOrder: "التوصيل بالطلب",
    deliveryByOrderNoCheckIn: "نوع العمل هذا لا يتطلب تسجيل دخول أو خروج",
    yourCurrentLocation: "موقعك الحالي",
    companyLocation: "موقع الشركة",
    errorLoadingUserData: "فشل في تحميل بيانات المستخدم",
    errorLoadingDailyAttendance: "فشل في تحميل بيانات الحضور اليومية",
    errorLoadingData: "حدث خطأ أثناء تحميل البيانات",
    enableLocationPermissionForCheckIn: "أذونات الموقع مطلوبة لتسجيل الدخول",
    outsideCompanyRadius: "أنت خارج نطاق أي فرع من فروع الشركة.",
    checkInSuccess: "تم تسجيل الدخول بنجاح",
    checkInFailed: "فشل تسجيل الدخول",
    errorDuringCheckIn: "حدث خطأ أثناء تسجيل الدخول",
    enableLocationPermissionForCheckOut: "أذونات الموقع مطلوبة لتسجيل الخروج",
    checkOutSuccess: "تم تسجيل الخروج بنجاح",
    checkOutFailed: "فشل تسجيل الخروج",
    errorDuringCheckOut: "حدث خطأ أثناء تسجيل الخروج",
    notRegistered: "غير مسجل",
    registered: "مسجل",
    checkIn: "تسجيل الدخول",
    checkedOut: "تم تسجيل الخروج",
    checkOut: "تسجيل الخروج",
    lastUpdate: "آخر تحديث:",
    statistics: "الإحصائيات",
    selectStatisticsPeriod: "اختر فترة الإحصائيات",
    halfDay: "نصف يوم",
    attendanceRate: "نسبة الحضور",
    dailyHoursAverage: "متوسط الساعات اليومية",
    hoursPerDay: "ساعة في اليوم",
    totalWorkingHours: "إجمالي ساعات العمل",
    thisMonth: "هذا الشهر",
    lastMonth: "الشهر الماضي",
    allData: "جميع البيانات",
    startDatePlaceholder: "تاريخ البدء",
    endDatePlaceholder: "تاريخ الانتهاء",
    search: "بحث",
    enter: "دخول",
    exit: "خروج",
    extra: "إضافي",
    deduction: "خصم",
    and: "و",
    updateEmployeeLocation: "تحديث موقع الموظف",
    updateMapData: "تحديث بيانات الخريطة",
    clearBrowserCache: "مسح كاش المتصفح",
    todayAttendanceTitle: "حضور اليوم",
    exportSuccess: "تم تصدير",
    exportSuccessRecords: "سجل حضور بنجاح",
    employeeNumber: "رقم الموظف",
    employeeName: "اسم الموظف",
    position: "المنصب",
    date: "التاريخ",
    checkInTime: "وقت الدخول",
    checkOutTime: "وقت الخروج",
    checkInPhoto: "صورة الحضور",
    viewCheckInPhoto: "عرض صورة الحضور",
    noCheckInPhoto: "لا توجد صورة",
    closePhoto: "إغلاق الصورة",
    workingHours: "ساعات العمل",
    overtimeHours: "ساعات إضافية",
    earlyLeave: "انصراف مبكر",
    deductionAmount: "مبلغ الخصم",
    attendanceRecord: "سجل الحضور",
    refresh: "تحديث",
    exportExcel: "تحميل Excel",
    exporting: "جاري التصدير...",
    fromDate: "من التاريخ",
    toDate: "إلى التاريخ",
    rejectReasonOptional: "سبب الرفض (اختياري):",
    enterRejectionReason: "يرجى إدخال سبب الرفض:",
    rejectionReasonLabel: "سبب الرفض:",
    enterDeductionNameInRow: "يرجى إدخال اسم الخصم في الصف",
    enterValidAmountInRow: "يرجى إدخال مبلغ صالح في الصف",
    enterAllowanceName: "يرجى إدخال اسم البدل",
    enterValidAllowanceAmount: "يرجى إدخال مبلغ بدل صالح",
    enterValidBaseSalary: "يرجى إدخال راتب أساسي صالح",
    enterDailyOrdersCount: "يرجى إدخال عدد الطلبات اليومية (يجب أن يكون 1 أو أكثر)",
    enterExpectedDailyOrders: "يرجى إدخال عدد الطلبات اليومية المتوقعة للموظف",
    enterBaseSalaryInEGP: "يرجى إدخال الراتب الأساسي للموظف",
    enterEndDateOrEnablePermanent: "يرجى إدخال تاريخ الانتهاء أو تفعيل خيار \"دائم\"",
    enterRejectionReasonMinLength: "يجب أن يكون سبب الرفض 10 أحرف على الأقل",
    enterRejectionReasonMaxLength: "سبب الرفض طويل جداً (الحد الأقصى 500 حرف)",
    enterRejectionReasonForEmployee: "يرجى إدخال سبب الرفض للموظف",
    rejectionReasonPlaceholder: "سبب الرفض (بين 10 و 500 حرف)...",
    enterValidCoordinates: "يرجى إدخال إحداثيات صحيحة",
    enterBranchName: "يرجى إدخال اسم الفرع",
    enterDepartmentName: "يرجى إدخال اسم القسم",
    enterAssetName: "يرجى إدخال اسم الأصل",
    enterValidPrice: "يرجى إدخال سعر صالح",
    enterDocumentTitle: "يرجى إدخال عنوان المستند",
    enterToolName: "يرجى إدخال اسم الأداة",
    confirmApproveTransaction: "هل تريد الموافقة على هذه المعاملة؟",
    failedToApproveTransaction: "فشل في الموافقة على المعاملة. يرجى المحاولة لاحقاً.",
    failedToFetchTransactions: "فشل في جلب المعاملات. يرجى المحاولة لاحقاً."
  },
  tasks: {
    title: "مدير المهام",
    description: "إدارة ومتابعة المهام",
    allTasks: "جميع المهام",
    extensionRequests: "طلبات التمديد",
    extensionRequestsDesc: "مراجعة والرد على طلبات تمديد الوقت من الموظفين",
    addTask: "إضافة مهمة",
    editTask: "تعديل المهمة",
    taskTitle: "عنوان المهمة",
    taskDescription: "وصف المهمة",
    enterTaskTitle: "أدخل عنوان المهمة",
    enterTaskDescription: "أدخل وصف المهمة",
    enterTaskTitleRequired: "يرجى إدخال عنوان المهمة",
    selectEmployeeRequired: "يرجى اختيار موظف",
    selectTeamRequired: "يرجى اختيار قسم",
    selectDeadlineRequired: "يرجى اختيار تاريخ الاستحقاق",
    assignType: "نوع التعيين",
    singleEmployee: "موظف واحد",
    fullTeam: "قسم كامل",
    selectEmployee: "اختر الموظف",
    selectTeam: "اختر القسم",
    selectEmployeePlaceholder: "اختر موظف...",
    selectTeamPlaceholder: "اختر قسم...",
    deadline: "تاريخ الاستحقاق",
    priority: "الأولوية",
    status: "الحالة",
    high: "عالي",
    medium: "متوسط",
    low: "منخفض",
    completed: "مكتملة",
    pending: "قيد الانتظار",
    inProgress: "قيد التنفيذ",
    cancelled: "ملغاة",
    allStatuses: "جميع الحالات",
    allPriorities: "جميع الأولويات",
    all: "الكل",
    approved: "موافق عليها",
    rejected: "مرفوضة",
    search: "بحث",
    searchPlaceholder: "ابحث في العنوان والوصف...",
    clearFilters: "مسح الفلاتر",
    loading: "جاري التحميل...",
    noTasks: "لا توجد مهام",
    noTasksDesc: "ابدأ بإضافة مهمة جديدة",
    employee: "موظف",
    team: "قسم",
    department: "القسم",
    expired: "منتهي",
    createdAt: "تاريخ الإنشاء",
    completedAt: "تاريخ الإكمال",
    updates: "التحديثات",
    viewDetails: "عرض التفاصيل",
    markDone: "تحديد كمكتملة",
    addUpdate: "إضافة تحديث/تعليق",
    requestExtension: "طلب تمديد الوقت",
    edit: "تعديل",
    delete: "حذف",
    taskDetails: "تفاصيل المهمة",
    extensionReason: "سبب طلب التمديد",
    extensionReasonPlaceholder: "أدخل سبب طلب تمديد الوقت...",
    extensionReasonRequired: "يرجى إدخال سبب طلب التمديد",
    sendRequest: "إرسال الطلب",
    updateMessage: "التحديث/التعليق",
    updateMessagePlaceholder: "أدخل تحديث أو تعليق على المهمة...",
    updateMessageRequired: "يرجى إدخال تحديث أو تعليق",
    sendUpdate: "إرسال",
    addTaskButton: "إضافة",
    deleteTaskConfirm: "هل أنت متأكد من حذف هذه المهمة؟",
    notSpecified: "غير محدد",
    untitled: "مهمة بدون عنوان",
    requestMessage: "رسالة الطلب",
    responseMessage: "رسالة الرد",
    respondedAt: "تاريخ الرد",
    requestDate: "تاريخ الطلب",
    approve: "موافقة",
    reject: "رفض",
    noExtensionRequests: "لا توجد طلبات تمديد",
    refresh: "تحديث",
    page: "صفحة",
    of: "من",
    tasks: "مهمة",
    requests: "طلب",
    previous: "السابق",
    next: "التالي",
    createSuccess: "تم إنشاء المهمة بنجاح",
    updateSuccess: "تم تحديث المهمة بنجاح",
    deleteSuccess: "تم حذف المهمة بنجاح",
    markDoneSuccess: "تم تحديد المهمة كمكتملة بنجاح",
    extensionRequestSuccess: "تم إرسال طلب التمديد بنجاح",
    addUpdateSuccess: "تم إضافة التحديث بنجاح",
    approveExtensionSuccess: "تم الموافقة على طلب التمديد بنجاح",
    rejectExtensionSuccess: "تم رفض طلب التمديد بنجاح",
    errorFetchingEmployees: "حدث خطأ أثناء جلب بيانات الموظفين",
    errorFetchingTasks: "حدث خطأ أثناء جلب المهام",
    errorFetchingTaskDetails: "حدث خطأ أثناء جلب تفاصيل المهمة",
    errorCreatingTask: "حدث خطأ أثناء إنشاء المهمة",
    errorUpdatingTask: "حدث خطأ أثناء تحديث المهمة",
    errorDeletingTask: "حدث خطأ أثناء حذف المهمة",
    markDoneFailed: "فشل في تحديد المهمة كمكتملة",
    extensionRequestFailed: "فشل في إرسال طلب التمديد",
    addUpdateFailed: "فشل في إضافة التحديث",
    approveExtensionFailed: "فشل في الموافقة على الطلب",
    rejectExtensionFailed: "فشل في رفض الطلب",
    errorFetchingExtensionRequests: "فشل في جلب طلبات التمديد",
    deadlineLabel: "الموعد النهائي",
    task: "المهمة",
    enterUpdateMessage: "أدخل رسالة التحديث...",
    markPending: "تعيين كقيد التنفيذ",
    cannotUpdateCompleted: "لا يمكن إضافة تحديثات للمهام المكتملة"
  },
  approvals: {
    title: "الموافقات",
    description: "إدارة الموافقات على المعاملات والطلبات",
    rejectReasonOptional: "سبب الرفض (اختياري):",
    enterRejectionReason: "يرجى إدخال سبب الرفض:",
    rejectionReasonLabel: "سبب الرفض:",
    confirmApproveTransaction: "هل تريد الموافقة على هذه المعاملة؟",
    failedToApproveTransaction: "فشل في الموافقة على المعاملة. يرجى المحاولة لاحقاً.",
    failedToFetchTransactions: "فشل في جلب المعاملات. يرجى المحاولة لاحقاً.",
    rejectReasonForMultipleTransactions: "سبب الرفض لـ",
    transactions: "معاملة",
    rejectionReasonOptionalForMultiple: "(اختياري):"
  },
  common: {
    all: "الكل",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    edit: "تعديل",
    delete: "حذف",
    create: "إنشاء",
    update: "تحديث",
    search: "بحث",
    searchPlaceholder: "ابحث في الإعدادات أو الأقسام...",
    loading: "جاري التحميل...",
    saving: "جاري الحفظ...",
    error: "حدث خطأ",
    success: "تم بنجاح",
    other: "أخرى",
    clearCacheConfirm: "هل تريد مسح البيانات المخزنة وإعادة تحميل الصفحة؟\nسوف يؤدي ذلك الي حذف البيانات المؤقته\nستحتاج الي اعاده تسجيل الدخول من جديد",
    clearCacheError: "حصلت مشكلة أثناء مسح الكاش. حاول تاني.",
    clearCacheSuccess: "تم مسح الكاش بنجاح",
    aiGreeting: "عايزك تلقي التحيه و تعرفهم انك ذكاء اصطناعي تم برمجتك من خلال حمدي محمد",
    unknown: "غير معروف",
    notSpecified: "غير محدد",
    confirm: "تأكيد",
    deletedUndo: "تم الحذف",
    undoSuccessful: "تم التراجع بنجاح",
    undo: "تراجع",
    warning: "تحذير",
    info: "معلومات",
    retry: "إعادة المحاولة",
    reloadPage: "تحديث الصفحة",
    pageNotFoundTitle: "404 - الصفحة غير موجودة",
    pageNotFoundMessage: "عذرًا، الصفحة التي تبحث عنها غير موجودة.",
    login: "تسجيل الدخول",
    user: "المستخدم",
    amount: "المبلغ",
    amountMustBePositive: "{label} يجب أن يكون رقمًا موجبًا",
    amountMustNotExceed: "{label} يجب ألا يتجاوز {max}",
    emptyData: "لا توجد بيانات متاحة",
    emptyDataMessage: "لا توجد بيانات متاحة للعرض حالياً",
    loadingData: "جاري تحميل البيانات...",
    orgNotFound: "المؤسسة غير موجودة. يرجى التواصل مع الدعم الفني.",
    routeNotFound: "الصفحة غير موجودة",
    now: "الآن",
    agoDay: "منذ {n} يوم",
    agoDays: "منذ {n} أيام",
    agoHour: "منذ {n} ساعة",
    agoHours: "منذ {n} ساعات",
    agoMinute: "منذ {n} دقيقة",
    agoMinutes: "منذ {n} دقائق",
    pause: "إيقاف مؤقت",
    resume: "استئناف",
    previous: "السابق",
    next: "التالي",
    read: "مقروء",
    unread: "غير مقروء"
  },
  errorBoundary: {
    connectionIssue: "مشكلة في الاتصال",
    sessionExpired: "انتهت الجلسة",
    somethingWentWrong: "حدث خطأ",
    chunkError: "تعذر تحميل الصفحة بعد التحديث. امسح الكاش أو حدّث الصفحة يدوياً مرة واحدة.",
    networkError: "لا يمكن الاتصال بالخادم. يرجى التحقق من اتصالك بالإنترنت والمحاولة مرة أخرى.",
    authError: "انتهت صلاحية جلسة تسجيل الدخول. يرجى تسجيل الدخول مرة أخرى.",
    unexpectedError: "عذرًا، حدث خطأ غير متوقع. حاول مرة أخرى لاحقًا.",
    errorDetails: "تفاصيل الخطأ (للتطوير فقط)"
  },
  layout: {
    supportSessionActive: "جلسة دعم نشطة",
    supportSessionBy: " (بواسطة {name})",
    supportSessionSuffix: " — أنت ترى النظام كالمستخدم المحدد.",
    supportSessionEnd: "إنهاء جلسة الدعم"
  },
  supportSession: {
    invalidLinkNoToken: "رابط الجلسة غير صالح (لا يوجد توكن).",
    invalidLinkMissingToken: "رابط الجلسة غير صالح (التوكن مفقود).",
    invalidToken: "التوكن غير صالح.",
    sessionExpired: "انتهت صلاحية رابط الجلسة. اطلب انتحالًا جديدًا من لوحة الإدارة.",
    notSupportSession: "هذا الرابط ليس لجلسة دعم.",
    invalidOrgId: "معرّف المؤسسة في رابط الدعم غير صالح.",
    invalidTenantId: "معرّف المستأجر في رابط الدعم غير صالح.",
    openFailed: "تعذر فتح جلسة الدعم. حاول مرة أخرى من لوحة الإدارة.",
    title: "تعذر فتح الجلسة",
    opening: "جاري فتح جلسة الدعم…",
    confirmTitle: "بدء جلسة الدعم؟",
    confirmBody: "ستعرض التطبيق كالمستخدم المحدد. تابع فقط إذا طلبت ذلك من لوحة الإدارة.",
    confirmReplaceWarning: "سيؤدي هذا إلى استبدال جلسة تسجيل الدخول الحالية على هذا المتصفح.",
    startSession: "بدء جلسة الدعم",
    cancel: "إلغاء"
  },
  infoPop: {
    title: "ميزة جديدة رائعة!",
    description: "اكتشف الميزة الجديدة التي ستغير تجربتك معنا",
    actionText: "جرب الآن"
  },
  updates: {
    newUpdate: "تحديث جديد",
    close: "إغلاق",
    pause: "إيقاف مؤقت",
    resume: "استئناف",
    pauseTitle: "إيقاف مؤقت (Space)",
    resumeTitle: "استئناف (Space)",
    clickToPause: "انقر للإيقاف المؤقت (أو اضغط Space)",
    clickToResume: "انقر للاستئناف (أو اضغط Space)",
    previous: "السابق",
    next: "التالي",
    read: "مقروء",
    unread: "غير مقروء",
    noText: "لا يوجد نص للتحديث",
    video: "فيديو"
  },
  chat: {
    title: "المحادثات",
    mobileTitle: "الدردشة",
    searchPlaceholder: "بحث...",
    noConversations: "لا توجد محادثات",
    noMessages: "لا توجد رسائل بعد. ابدأ المحادثة!",
    noMessagesPlaceholder: "لا توجد رسائل",
    selectConversation: "اختر محادثة للبدء",
    typeMessage: "اكتب رسالة...",
    attachFile: "إرفاق ملف",
    attachImage: "إرفاق صورة",
    addEmoji: "إضافة رمز تعبيري",
    sendMessage: "إرسال رسالة",
    openConversations: "فتح قائمة المحادثات",
    now: "الآن",
    minutesAgo: "منذ",
    minute: "دقيقة",
    employee: "موظف",
    department: "قسم",
    minutes: "دقائق",
    startConversation: "ابدأ المحادثة مع فريقك",
    members: "عضو",
    groupChat: "محادثة المجموعة",
    groups: "الاقسام",
    selectGroup: "اختر مجموعة للبدء",
    deleteMessageConfirm: "هل أنت متأكد من حذف هذه الرسالة؟",
    delete: "حذف",
    cancel: "إلغاء",
    deleteSuccess: "تم حذف الرسالة بنجاح",
    fetchGroupsFailed: "فشل في جلب المجموعات",
    fetchMessagesFailed: "فشل في جلب الرسائل",
    sendMessageFailed: "فشل في إرسال الرسالة",
    deleteMessageFailed: "فشل في حذف الرسالة",
    unnamedGroup: "مجموعة بدون اسم",
    today: "اليوم",
    yesterday: "أمس",
    connected: "متصل",
    disconnected: "غير متصل",
    you: "أنت",
    welcomeGeneral: "مرحباً بك في المحادثة العامة!",
    welcomeDepartment: "مرحباً بك في محادثة {name}!",
    welcomeSubtitle: "ابدأ المحادثة مع فريقك. أرسل رسالة للبدء!",
    minuteShort: "م",
    reply: "رد",
    replyingTo: "الرد على",
    cancelReply: "إلغاء الرد",
    react: "تفاعل",
    pin: "تثبيت",
    unpin: "إلغاء التثبيت",
    pinnedMessages: "رسائل مثبتة",
    pinnedMessage: "رسالة مثبتة",
    searchMessages: "بحث في الرسائل",
    searchMessagesPlaceholder: "ابحث في الرسائل...",
    noSearchResults: "لا توجد نتائج",
    pinSuccess: "تم تثبيت الرسالة",
    unpinSuccess: "تم إلغاء تثبيت الرسالة",
    pinFailed: "فشل في تثبيت الرسالة",
    pinUnauthorized: "التثبيت متاح للأدمن وقائد الفريق فقط.",
    pinLimitReached: "يمكنك تثبيت 5 رسائل فقط. ألغِ تثبيت رسالة أولاً لتثبيت أخرى.",
    reactionFailed: "فشل في إضافة التفاعل",
    searchFailed: "فشل في البحث"
  },
  sidebar: {
    title: "نظام HR",
    expand: "توسيع",
    collapse: "طي",
    settings: "الإعدادات",
    mainMenu: "القائمة الرئيسية",
    hrSystem: "نظام إدارة الموارد البشرية",
    version: "النسخة 1.0.0",
    dashboard: "لوحة التحكم",
    employees: "الموظفين",
    payroll: "الرواتب",
    salary: "الراتب",
    holidays: "الاجازات",
    permissions: "الأذونات",
    company: "الشركه",
    reports: "التقارير",
    attendance: "سجل الحضور",
    tasks: "مدير المهام",
    chat: "المحادثات",
    documents: "مستنداتي",
    myProfile: "حسابي الشخصي",
    employeesList: "دليل الموظفين",
    home: "الرئيسية",
    connected: "متصل",
    searchPlaceholder: "البحث في النظام...",
    notifications: "الإشعارات",
    newNotification: "إشعار جديد",
    viewUpdates: "عرض التحديثات",
    viewUpdate: "عرض",
    newUpdate: "تحديث جديد",
    companyCode: "كود الشركة",
    roles: {
      employee: "موظف",
      admin: "مدير",
      teamLeader: "قائد فريق",
      user: "مستخدم"
    }
  },
  topHeader: {
    searchPlaceholder: "البحث في النظام...",
    assistBar: {
      ask: "اسأل",
      askHint: "اسأل عن مكان أي شيء في النظام",
      jump: "انتقال سريع",
      jumpHint: "افتح قائمة الانتقال السريع"
    },
    toggleLightMode: "تبديل إلى الوضع الفاتح",
    toggleDarkMode: "تبديل إلى الوضع المظلم",
    changeLanguage: "تغيير اللغة",
    notifications: "الإشعارات",
    notificationsPanel: "لوحة الإشعارات",
    loading: "جاري التحميل...",
    loadError: "خطأ في التحميل",
    noNotifications: "لا توجد إشعارات لعرضها",
    loadingNotifications: "جارٍ تحميل الإشعارات...",
    loadingMore: "جارٍ التحميل...",
    loadMore: "عرض المزيد من الإشعارات",
    seeMore: "عرض المزيد",
    seeLess: "عرض أقل",
    allRead: "جميع الإشعارات مقروءة",
    justNow: "الآن",
    unreadNotification: "إشعار غير مقروء",
    total: "إجمالي",
    notificationCount: "عدد الإشعارات:",
    decreaseCount: "تقليل عدد الإشعارات لكل صفحة",
    increaseCount: "زيادة عدد الإشعارات لكل صفحة",
    countPerPage: "عدد الإشعارات لكل صفحة",
    markAllAsRead: "تعيين الكل كمقروء",
    deleteAll: "حذف الكل",
    closeWindow: "إغلاق النافذة",
    noNotificationsTitle: "لا توجد إشعارات حاليًا",
    noNotificationsMessage: "سيتم إشعارك عند وصول إشعارات جديدة",
    notificationWithoutTitle: "إشعار بدون عنوان",
    noNotificationText: "لا يوجد نص للإشعار",
    unreadNotificationLabel: "إشعار غير مقروء",
    notificationLabel: "إشعار:",
    fetchFailed: "فشل في جلب الإشعارات",
    fetchError: "حدث خطأ أثناء جلب الإشعارات",
    fetchNewFailed: "فشل في جلب الإشعارات الجديدة. جارٍ المحاولة مجددًا...",
    markReadFailed: "فشل في تحديث حالة الإشعار",
    markAllReadFailed: "فشل في تحديث حالة الإشعارات",
    deleteFailed: "فشل في حذف الإشعار",
    deleteAllFailed: "فشل في حذف جميع الإشعارات",
    unauthorized: "غير مصرح، يرجى التحقق من التوكن",
    noTitle: "بدون عنوان",
    noMessage: "بدون رسالة",
    read: "مقروء",
    unread: "غير مقروء",
    markAsRead: "تعيين كمقروء",
    delete: "حذف",
    viewAllNotifications: "عرض جميع الإشعارات",
    userMenu: "قائمة المستخدم",
    profile: "الملف الشخصي",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    login: "تسجيل الدخول",
    user: "مستخدم",
    admin: "مدير النظام",
    teamLeader: "قائد فريق",
    employee: "موظف",
    newNotification: "إشعار جديد",
    youHaveNewNotification: "لديك إشعار جديد",
    browserNotSupportNotifications: "المتصفح لا يدعم الإشعارات.",
    notificationPermissionDenied: "تم رفض إذن الإشعارات. يرجى تمكين الإشعارات في إعدادات المتصفح.",
    notificationPermissionError: "حدث خطأ أثناء طلب إذن الإشعارات.",
    searchPopup: {
      title: "اسأل TeamIN",
      description: "اعثر على أي صفحة أو ميزة بكلمات بسيطة",
      placeholder: "بتدور على إيه؟",
      closeHint: "للإغلاق",
      sendHint: "للإرسال",
      sending: "جارٍ البحث...",
      fullScreen: "ملء الشاشة",
      exitFullScreen: "الخروج من ملء الشاشة",
      welcomeMessage: "مرحباً! اسألني عن مكان أي شيء — مثلاً: «فين الرواتب؟» أو «إعدادات الشركة»",
      welcomeMessageEmployee: "مرحباً! اسألني عن مكان أي شيء — مثلاً: «فين الراتب؟» أو «كيف أطلب إجازة؟»",
      responseMessage: "حدث خطأ. يرجى المحاولة مرة أخرى.",
      takeMeThere: "خذني إلى هناك",
      suggestion1: "فين الرواتب؟",
      suggestion2: "إعدادات الشركة",
      suggestion3: "تقارير الحضور",
      suggestion1Employee: "فين راتبي؟",
      suggestion2Employee: "كيف أطلب إجازة؟",
      suggestion3Employee: "مستنداتي"
    },
    report: {
      title: "الإبلاغ عن مشكلة أو اقتراح",
      description: "اختر الجزء المتعلق بالمشكلة واكتب وصفًا مختصرًا. هنراجع البلاغ في أقرب وقت.",
      subject: "الموضوع",
      subjectPlaceholder: "مثال: الحضور فشل بسبب الموقع",
      category: "عن إيه المشكلة؟",
      categoryHint: "اختار الجزء الأقرب لمشكلتك عشان نوصلها للفريق الصح.",
      categories: {
        attendance: "الحضور والانصراف",
        notifications: "الإشعارات",
        payroll: "الراتب وكشوف المرتبات",
        leaves_permissions: "الإجازات والتصاريح",
        tasks_chat: "المهام والمحادثات",
        account_login: "الدخول والحساب والجهاز",
        suggestion: "اقتراح تحسين",
        other: "شيء آخر",
        technical: "فني",
        billing: "مالي / فواتير",
        account: "حساب المستخدم",
        feature_request: "طلب ميزة جديدة"
      },
      descriptionLabel: "الوصف",
      placeholder: "اكتب ماذا حصل، ومتى، وأي رسالة خطأ ظهرت لك...",
      submit: "إرسال",
      cancel: "إلغاء",
      close: "إغلاق",
      sending: "جاري الإرسال...",
      thankYou: "شكراً لك. تم استلام رسالتك بنجاح.",
      errorSending: "حدث خطأ أثناء الإرسال. يرجى المحاولة مرة أخرى."
    }
  },
  forgetPassword: {
    title: "إعادة تعيين كلمة المرور",
    titleStep2: "إدخال الرمز وكلمة المرور الجديدة",
    description: "أدخل بريدك الإلكتروني لتلقي رمز إعادة التعيين",
    descriptionStep2: "أدخل الرمز المرسل إلى بريدك الإلكتروني وكلمة المرور الجديدة",
    email: "البريد الإلكتروني",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    code: "رمز التحقق",
    codePlaceholder: "أدخل رمز التحقق",
    newPassword: "كلمة المرور الجديدة",
    newPasswordPlaceholder: "أدخل كلمة المرور الجديدة",
    sendCode: "إرسال رمز التحقق",
    sending: "جاري الإرسال...",
    resetPassword: "إعادة تعيين كلمة المرور",
    resetting: "جاري إعادة التعيين...",
    backToLogin: "العودة إلى تسجيل الدخول",
    codeSent: "تم إرسال رمز إعادة التعيين إلى بريدك الإلكتروني",
    resetSuccess: "تم إعادة تعيين كلمة المرور بنجاح",
    sendError: "حدث خطأ أثناء إرسال الرمز",
    resetError: "حدث خطأ أثناء إعادة تعيين كلمة المرور",
    passwordTooShort: "كلمة المرور مطلوبة",
    validationCodeLength: "أدخل رمز التحقق المكوّن من 6 أرقام"
  },
  deleteAccount: {
    title: "حذف الحساب",
    description:
      "اطلب حذف حساب TeamIN وبياناتك الشخصية نهائياً. هذه الصفحة مطلوبة لاستمارة Data safety في Google Play.",
    verifyHint: "سجّل الدخول ببريدك الإلكتروني وكلمة المرور للتحقق من هويتك قبل الحذف.",
    continue: "متابعة",
    verifying: "جاري التحقق...",
    confirmDescription: "أكّد أنك تريد حذف هذا الحساب وبياناته نهائياً.",
    accountLabel: "الحساب",
    confirmCheckbox:
      "أفهم أن حذف الحساب سيزيل ملفي الشخصي وبريدي الإلكتروني والبيانات المرتبطة به نهائياً، ولا يمكن التراجع عن ذلك.",
    confirmCheckboxRequired: "يرجى تأكيد أنك تفهم أن هذا الإجراء نهائي.",
    deleteButton: "احذف حسابي",
    deleting: "جاري الحذف...",
    back: "رجوع",
    backHome: "العودة للرئيسية",
    failed: "فشل حذف الحساب. حاول مرة أخرى.",
    doneTitle: "تم حذف الحساب",
    doneDescription: "تم حذف حسابك والبيانات الشخصية المرتبطة به.",
    doneNote: "يمكنك إغلاق هذه الصفحة. إذا كنت تستخدم تطبيق الجوال، سجّل الخروج أو احذف التطبيق عند الحاجة.",
    warningTitle: "هذا الإجراء نهائي",
    warningItem1: "سيتم إزالة بيانات تسجيل الدخول والملف الشخصي.",
    warningItem2: "سيتم حذف البيانات الشخصية المرتبطة بحسابك من أنظمتنا.",
    warningItem3: "لن تتمكن من تسجيل الدخول بهذا الحساب مرة أخرى.",
    appHint: "يمكنك أيضاً حذف حسابك من الإعدادات داخل تطبيق TeamIN. اقرأ",
  },
  login: {
    admin: "مدير",
    employee: "موظف",
    teamLeader: "قائد فريق",
    superAdmin: "مدير متميز",
    expired: "منتهي",
    sessionExpired: "انتهت صلاحية جلسة العمل، الرجاء تسجيل الدخول مرة أخرى",
    invalidToken: "لم يتم إرجاع توكن صحيح",
    error: "حدث خطأ أثناء تسجيل الدخول",
    toggleTheme: "تبديل الثيم",
    switchToLight: "تبديل إلى الوضع الفاتح",
    switchToDark: "تبديل إلى الوضع المظلم",
    title: "تسجيل الدخول",
    subtitle: "أدخل بياناتك للوصول إلى حسابك",
    username: "البريد الإلكتروني",
    usernamePlaceholder: "أدخل بريدك الإلكتروني",
    password: "كلمة المرور",
    passwordPlaceholder: "أدخل كلمة المرور",
    forgotPassword: "نسيت كلمة المرور؟",
    submitting: "جاري تسجيل الدخول...",
    submit: "تسجيل الدخول",
    noAccount: "ليس لديك حساب؟",
    createAccountAlert: "يجب عليك تثبيت تطبيق Teamin من المتجر لإنشاء حساب جديد",
    createAccount: "إنشاء حساب",
    copyright: "جميع الحقوق محفوظة.",
    privacyPolicy: "سياسة الخصوصية",
    selectOrg: "اختر المنظمة",
    selectOrgDesc: "يوجد لديك حسابات في أكثر من منظمة. يرجى اختيار المنظمة التي تريد تسجيل الدخول إليها",
    rateLimitExceeded: "لقد حاولت تسجيل الدخول عدة مرات. انتظر قليلًا ثم حاول مرة أخرى.",
    deviceNotRegistered: "هذا الجهاز غير مسجل لحسابك. يرجى التواصل مع المسؤول لتفعيل الجهاز.",
    accountLocked: "تم تعليق تسجيل الدخول مؤقتًا بسبب عدة محاولات فاشلة. حاول مرة أخرى بعد بضع دقائق.",
    heroTitle: "نظام إدارة الموارد البشرية",
    heroSubtitle: "منصة شاملة لإدارة الموظفين والرواتب والعمليات المالية",
    features: {
      employees: {
        title: "إدارة الموظفين",
        description: "إضافة وتعديل بيانات الموظفين بسهولة"
      },
      payroll: {
        title: "إدارة الرواتب",
        description: "حساب ومتابعة الرواتب والبدلات"
      },
      reports: {
        title: "التقارير المالية",
        description: "تقارير شاملة عن الوضع المالي"
      },
      attendance: {
        title: "إدارة الحضور",
        description: "متابعة حضور وغياب الموظفين"
      }
    }
  },
  landing: {
    footer: {
      allRightsReserved: "جميع الحقوق محفوظة.",
      portfolio: "Portfolio"
    },
    marquee: {
      label: "موثوق به من فرق حول العالم"
    }
  },
  smartSearch: {
    placeholder: "اكتب للانتقال بسرعة...",
    close: "إغلاق",
    navigate: "انتقل",
    select: "اختر",
    noResults: "لا توجد نتائج",
    noResultsDescription: "جرب مصطلحات بحث مختلفة",
    selected: "محدد",
    footer: {
      assistant: "تنقل سريع · أدلة · تسميات الواجهة · Ctrl/⌘ K",
      results: "النتائج"
    },
    categories: {
      route: "الصفحات",
      guide: "الأدلة",
      i18n: "من تسميات الواجهة"
    },
    routes: {
      dashboard: "لوحة التحكم",
      "dashboard.description": "عرض نظرة عامة على النظام",
      employees: "الموظفين",
      "employees.description": "إدارة الموظفين",
      payroll: "الرواتب",
      "payroll.description": "إدارة الرواتب",
      settings: "الإعدادات",
      "settings.description": "إعدادات النظام",
      "system-logs": "سجلات النظام",
      "system-logs.description": "عرض سجلات نشاط النظام",
      reports: "التقارير",
      "reports.description": "عرض التقارير والتحليلات",
      company: "الشركة",
      "company.description": "معلومات الشركة والفروع",
      notifications: "الإشعارات",
      "notifications.description": "عرض جميع الإشعارات",
      tasks: "المهام",
      "tasks.description": "إدارة المهام والمشاريع",
      chat: "المحادثة",
      "chat.description": "رسائل الفريق",
      attendance: "الحضور",
      "attendance.description": "سجلات الحضور",
      holidays: "الإجازات",
      "holidays.description": "طلبات الإجازة ومتابعتها",
      permissions: "الصلاحيات",
      "permissions.description": "إدارة الأدوار والصلاحيات",
      "employees-list": "دليل الموظفين",
      "employees-list.description": "تصفح دليل الموظفين",
      salary: "الراتب",
      "salary.description": "عرض معلومات الراتب",
      me: "ملفي الشخصي",
      "me.description": "ملفك الشخصي",
      overview: "نظرة عامة",
      "overview.description": "نظرة عامة على الملف الشخصي",
      "desktop-tracking": "تتبع سطح المكتب",
      "desktop-tracking.description": "تتبع نشاط سطح المكتب",
      Msg: "الرسائل",
      "Msg.description": "رسائلك",
      performance: "الأداء",
      "performance.description": "تقييم الأداء",
      myDocument: "مستنداتي",
      "myDocument.description": "مستنداتك وملفاتك",
      requests: "الطلبات",
      "requests.description": "طلباتك"
    },
    help: {
      dashboard: {
        title: "لوحة التحكم",
        description: "عرض نظرة عامة على النظام"
      },
      employees: {
        title: "الموظفين",
        description: "إدارة الموظفين"
      },
      attendance: {
        title: "الحضور",
        description: "سجل الحضور"
      },
      payroll: {
        title: "الرواتب",
        description: "إدارة الرواتب"
      }
    }
  },
  hero: {
    badge: "حل شامل لإدارة الموارد البشرية",
    title: "TeamIN",
    subtitle: "نظام الموارد البشرية",
    description: "إدارة الموارد البشرية في جيبك - من الموظفين إلى المدراء",
    joinWaitingList: "انضم إلى قائمة الانتظار",
    learnMore: "اعرف المزيد",
    poweredBy: "النظام مدعوم بالذكاء الاصطناعي",
    downloadApp: "حمّل التطبيق",
    appStore: "آب ستور",
    googlePlay: "جوجل بلاي",
    downloadOn: "حمّله من",
    getItOn: "احصل عليه من",
    secureEncrypted: "آمن ومشفر",
    cloudBased: "سحابي بالكامل",
    aiPowered: "مدعوم بالذكاء الاصطناعي"
  },
  features: {
    title: "المميزات",
    subtitle: "حل شامل لإدارة الموارد البشرية للموظفين والمدراء.",
    eyebrow: "نظام متنامٍ لـ",
    bentoSubtitle: "الوحدات اللي الفرق فعلاً بتستخدمها — حضور، رواتب، دردشة، والمزيد في مكان واحد.",
    stats: {
      modules: "حضور ورواتب",
      platforms: "دردشة ومهام",
      featuresCount: "في نظام واحد"
    },
    allFeatures: "المميزات الرئيسية",
    categories: {
      employeeManagement: "إدارة الموظفين",
      attendance: "الحضور وتتبع الوقت",
      payroll: "الرواتب والمالية",
      communication: "التواصل والتعاون",
      tasks: "المهام والمشاريع",
      reports: "التقارير والتحليلات",
      admin: "الإدارة والإعدادات"
    },
    employeeManagement: {
      title: "إدارة الموظفين",
      description: "إدارة شاملة لبيانات الموظفين"
    },
    teamLeader: {
      title: "قائد الفريق",
      description: "إدارة الفرق والمشاريع"
    },
    documents: {
      title: "المستندات",
      description: "إدارة المستندات والملفات"
    },
    performance: {
      title: "الأداء",
      description: "تقييم أداء الموظفين"
    },
    companyManagement: {
      title: "إدارة الشركة",
      description: "إدارة بيانات الشركة والفروع"
    },
    clientsManagement: {
      title: "إدارة العملاء",
      description: "إدارة بيانات العملاء"
    },
    checkInOut: {
      title: "تسجيل الدخول والخروج",
      description: "نظام تسجيل دخول وخروج متقدم"
    },
    deviceBinding: {
      title: "ربط الأجهزة",
      description: "ربط الأجهزة بالأمان"
    },
    timeAttendance: {
      title: "الحضور والانصراف",
      description: "تتبع الحضور بدقة"
    },
    payslip: {
      title: "كشف الراتب",
      description: "إنشاء كشوف الرواتب"
    },
    payrollManagement: {
      title: "إدارة الرواتب",
      description: "حساب وإدارة الرواتب"
    },
    transactions: {
      title: "المعاملات",
      description: "تتبع المعاملات المالية"
    },
    groupChat: {
      title: "المحادثة الجماعية",
      description: "تواصل مع الفريق"
    },
    realtimeChat: {
      title: "المحادثة الفورية",
      description: "محادثة فورية مع الموظفين"
    },
    aiChatbot: {
      title: "مساعد ذكي",
      description: "مساعد ذكي للرد على الاستفسارات"
    },
    notifications: {
      title: "الإشعارات",
      description: "نظام إشعارات متقدم"
    },
    tasksManagement: {
      title: "إدارة المهام",
      description: "إنشاء ومتابعة المهام"
    },
    advancedAnalytics: {
      title: "التحليلات المتقدمة",
      description: "تحليلات شاملة للبيانات"
    },
    reportsAnalytics: {
      title: "تقارير وتحليلات",
      description: "تقارير مفصلة وإحصائيات"
    },
    adminDashboard: {
      title: "لوحة تحكم المدير",
      description: "لوحة تحكم شاملة للمدير"
    },
    holidaysManagement: {
      title: "إدارة الإجازات",
      description: "إدارة الإجازات والطلبات"
    },
    approvals: {
      title: "الموافقات",
      description: "نظام الموافقات والاعتمادات"
    },
    categoriesManagement: {
      title: "إدارة الأقسام",
      description: "إدارة أقسام الشركة"
    },
    desktopTracking: {
      title: "تتبع سطح المكتب",
      description: "تتبع نشاط الموظفين"
    },
    mobileApp: {
      title: "تطبيق الهاتف",
      description: "تطبيق للهواتف المحمولة"
    }
  },
  benefits: {
    title: "لماذا تختار",
    titleTeamIN: "TeamIN",
    titleQuestion: "؟",
    eyebrow: "ليش الفرق بتتحول",
    description: "نظام إدارة الموارد البشرية الشامل الذي يجمع كل ما تحتاجه لإدارة قوتك العاملة بكفاءة وفعالية.",
    getStarted: "ابدأ الآن",
    benefit1: "إدارة شاملة للموظفين من التوظيف إلى التقاعد",
    benefit2: "تتبع الحضور في الوقت الفعلي مع تتبع الموقع",
    benefit3: "حساب الرواتب الآلي مع المكافآت والخصومات",
    benefit4: "تواصل سلس من خلال الدردشة الجماعية",
    benefit5: "تقارير وتحليلات مفصلة لاتخاذ قرارات مستنيرة",
    benefit6: "أمان عالي مع ربط الجهاز وحماية البيانات",
    benefit7: "ذكاء اصطناعي متقدم لتحليل البيانات والتنبؤات الذكية",
    chat: {
      groupName: "فريق الموارد البشرية",
      online: "١٢ متصل الآن",
      members: "٢٤ عضو",
      typing: "سارة تكتب...",
      placeholder: "اكتب رسالة...",
      avatarInitials: "سا"
    },
    aiPowered: "مدعوم بالذكاء الاصطناعي"
  },
  contact: {
    title: "انضم إلى",
    waitingList: "قائمة الانتظار",
    eyebrow: "احصل على وصول مبكر",
    description: "كن من أوائل من يحصل على TeamIN HR System. سجل بريدك الإلكتروني وسنخبرك عندما نكون جاهزين!",
    contactUs: "اتصل بنا",
    viewPortfolio: "عرض Portfolio"
  },
  privacy: {
    title: "سياسة الخصوصية",
    paragraph1: "نحن ملتزمون بحماية خصوصيتك. معلوماتك الشخصية لن يتم مشاركتها مع أي طرف ثالث.",
    paragraph2: "إذا كان لديك أي أسئلة حول سياسة الخصوصية، يرجى الاتصال بنا على",
    close: "إغلاق",
    readFull: "قراءة سياسة الخصوصية الكاملة"
  },
  form: {
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "أدخل بريدك الإلكتروني",
    phoneLabel: "رقم الهاتف",
    phonePlaceholder: "أدخل رقم هاتفك",
    categoryLabel: "فئة الشركة",
    categoryPlaceholder: "اختر فئة الشركة",
    success: "تم التسجيل بنجاح! سنتواصل معك قريباً.",
    viewPortfolio: "عرض",
    back: "السابق",
    next: "التالي",
    joining: "جاري الانضمام...",
    joinWaitingList: "انضم إلى قائمة الانتظار",
    privacyPolicy: "سياسة الخصوصية"
  },
  capabilities: {
    title: "قدرات النظام",
    subtitle: "نظام قوي ومرن مصمم لينمو مع عملك",
    eyebrow: "مصمم لينمو معك",
    scrollHint: "اسكرول للاستكشاف",
    multiPlatform: {
      title: "منصات متعددة",
      description: "يعمل على Android و iOS والويب - وصول كامل من أي جهاز"
    },
    realTimeSync: {
      title: "مزامنة فورية",
      description: "مزامنة فورية لجميع البيانات عبر جميع الأجهزة"
    },
    secure: {
      title: "آمن ومحمي",
      description: "حماية متقدمة لبياناتك مع تشفير قوي"
    },
    scalable: {
      title: "قابل للتوسع",
      description: "ينمو مع عملك من شركة صغيرة إلى مؤسسة كبيرة"
    },
    customizable: {
      title: "قابل للتخصيص",
      description: "قم بتخصيص النظام ليناسب احتياجات شركتك الفريدة",
      modules: {
        attendance: "الحضور",
        chat: "الدردشة",
        tasks: "المهام",
        reports: "التقارير"
      }
    },
    support: {
      title: "دعم فني",
      description: "فريق دعم مخصص متاح لمساعدتك في أي وقت"
    },
    platforms: {
      androidIos: {
        title: "تطبيقات الجوال",
        description: "تطبيقات أصلية لـ Android و iOS"
      },
      webDashboard: {
        title: "لوحة تحكم الويب",
        description: "لوحة تحكم قوية للمدراء"
      },
      realTimeSync: {
        title: "مزامنة فورية",
        description: "مزامنة فورية عبر جميع المنصات"
      }
    }
  },
  screenshots: {
    title: "شاهد TeamIN في العمل",
    subtitle: "استكشف نظامنا من خلال لقطات شاشة حقيقية من تطبيق الجوال ولوحة تحكم الويب",
    mobile: "تطبيق الجوال",
    web: "لوحة تحكم الويب",
    viewFullSize: "عرض بالحجم الكامل",
    items: {
      mobileDashboard: {
        title: "لوحة تحكم الجوال",
        description: "لوحة تحكم جميلة وبديهية للموظفين"
      },
      mobileAttendance: {
        title: "تسجيل الدخول/الخروج",
        description: "تسجيل دخول وخروج سهل مع تتبع الموقع"
      },
      mobileTasks: {
        title: "إدارة المهام",
        description: "إدارة وتتبع مهامك أثناء التنقل"
      },
      mobileChat: {
        title: "دردشة الفريق",
        description: "رسائل فورية مع فريقك"
      },
      mobilePayslip: {
        title: "كشف الراتب الرقمي",
        description: "عرض وتحميل كشوف الرواتب الشهرية"
      },
      adminDashboard: {
        title: "لوحة تحكم المدير",
        description: "لوحة تحكم شاملة للمدراء مع التحليلات"
      },
      employeeManagement: {
        title: "إدارة الموظفين",
        description: "نظام إدارة موظفين كامل"
      },
      payrollManagement: {
        title: "إدارة الرواتب",
        description: "حساب وإدارة الرواتب الآلي"
      },
      attendanceTracking: {
        title: "تتبع الحضور",
        description: "مراقبة الحضور والتقارير في الوقت الفعلي"
      },
      reportsAnalytics: {
        title: "التقارير والتحليلات",
        description: "لوحة تحكم شاملة للتقارير والتحليلات"
      }
    },
    placeholder: "مكان الصورة",
    placeholderHint: "مكان الصورة - أضف صور لقطات الشاشة الفعلية"
  },
  systemLogs: {
    title: "سجلات النظام",
    description: "عرض وإدارة سجلات نشاط النظام",
    searchPlaceholder: "البحث في السجلات...",
    exportSuccess: "تم تصدير السجلات بنجاح",
    exportFailed: "حدث خطأ في تصدير السجلات",
    clearConfirm: "هل أنت متأكد من حذف جميع السجلات؟ هذا الإجراء لا يمكن التراجع عنه.",
    clearSuccess: "تم حذف جميع السجلات بنجاح",
    clearFailed: "حدث خطأ في حذف السجلات",
    fetchFailed: "حدث خطأ في جلب السجلات",
    statsFailed: "حدث خطأ في جلب الإحصائيات",
    noLogs: "لا توجد سجلات",
    action: "الإجراء",
    resource: "المورد",
    dateFrom: "من تاريخ",
    dateTo: "إلى تاريخ",
    clearFilters: "مسح الفلاتر",
    export: "تصدير",
    clearAll: "حذف الكل",
    totalLogs: "إجمالي السجلات",
    financialTransactions: "المعاملات المالية",
    today: "اليوم",
    thisMonth: "هذا الشهر",
    searchFilters: "فلاتر البحث",
    showFilters: "إظهار الفلاتر",
    hideFilters: "إخفاء الفلاتر",
    search: "البحث",
    allActions: "جميع العمليات",
    allResources: "جميع الموارد",
    logsCount: "السجلات ({count})",
    pageOf: "صفحة {current} من {pages}",
    datetime: "التاريخ والوقت",
    user: "المستخدم",
    operation: "العملية",
    financialDetails: "التفاصيل المالية",
    status: "الحالة",
    actions: "الإجراءات",
    details: "تفاصيل",
    logDetails: "تفاصيل السجل",
    unknownUser: "غير معروف",
    unavailable: "غير متاح",
    ip: "الـ IP",
    amount: "المبلغ",
    transactionType: "نوع المعاملة",
    category: "الفئة",
    transactionDate: "تاريخ المعاملة",
    descriptionLabel: "الوصف",
    transactionId: "معرف المعاملة",
    transactionStatus: "حالة المعاملة",
    completed: "مكتمل",
    endpoint: "المسار",
    detailsLabel: "التفاصيل",
    userAgent: "متصفح المستخدم",
    showingRange: "عرض {from} إلى {to} من {total} سجل",
    previous: "السابق",
    next: "التالي",
    actionLabels: {
      add: "إضافة",
      edit: "تعديل",
      delete: "حذف",
      view: "عرض",
      login: "تسجيل دخول",
      logout: "تسجيل خروج"
    },
    resourceLabels: {
      financial: "المعاملات المالية",
      employees: "الموظفين",
      payroll: "الرواتب",
      whatsapp: "واتساب",
      systemLog: "سجل النظام"
    }
  },
  invoices: {
    title: "الفواتير",
    description: "إدارة الفواتير والمدفوعات",
    addInvoice: "إضافة فاتورة جديدة",
    editInvoice: "تعديل الفاتورة",
    deleteConfirm: "هل أنت متأكد من حذف هذه الفاتورة؟",
    deleteSuccess: "تم حذف الفاتورة بنجاح",
    createSuccess: "تم إنشاء الفاتورة بنجاح",
    updateSuccess: "تم تحديث الفاتورة بنجاح",
    statusUpdateSuccess: "تم تحديث حالة الفاتورة بنجاح",
    statusUpdateFailed: "فشل تحديث حالة الفاتورة",
    fetchFailed: "حدث خطأ في جلب البيانات",
    noPermissionDelete: "ليس لديك صلاحية لحذف الفواتير",
    noInvoices: "لا توجد فواتير",
    client: "العميل",
    amount: "المبلغ",
    descriptionLabel: "الوصف",
    dueDate: "تاريخ الاستحقاق",
    paymentMethod: "طريقة الدفع",
    notes: "ملاحظات",
    status: "الحالة",
    paid: "مدفوعة",
    pending: "قيد الانتظار",
    overdue: "متأخرة",
    cancelled: "ملغاة"
  },
  me: {
    desktopNotConnected: "التطبيق المكتبي غير متصل",
    serverDisconnected: "غير متصل بالخادم",
    desktopRequiredForAttendance: "يجب تشغيل تطبيق سطح المكتب أولاً لتسجيل الحضور/الانصراف",
    commandFailed: "فشل في إرسال الأمر",
    actionSuccess: "بنجاح",
    remoteWorkStarted: "تم بدء العمل عن بُعد",
    remoteWorkEnded: "تم إنهاء العمل عن بُعد",
    remoteWorkResumed: "تم استكمال العمل عن بُعد",
    remoteWorkPaused: "تم إيقاف العمل مؤقتاً عن بُعد",
    breakEnded: "تم إنهاء الاستراحة عن بُعد",
    breakStarted: "تم بدء الاستراحة",
    noReason: "بدون سبب محدد",
    monthRecordsSynced: "تم تحديث جميع سجلات الشهر من بيانات التطبيق",
    monthRecordsSyncFailed: "فشل في تحديث سجلات الشهر",
    monthRecordsSyncError: "خطأ في تحديث سجلات الشهر",
    todayRecordsSynced: "تم تحديث سجلات اليوم بنجاح",
    todayRecordsSyncFailed: "فشل في تحديث السجلات",
    todayRecordsSyncError: "خطأ في تحديث السجلات",
    allDataSynced: "تم تحديث جميع البيانات من التطبيق",
    syncError: "حدث خطأ في المزامنة",
    breakSettingsNotFound: "لم يتم العثور على إعدادات وقت الاستراحة",
    breakSettingsFetchError: "خطأ في جلب إعدادات وقت الاستراحة",
    employeeFetchFailed: "فشل في جلب بيانات الموظف",
    employeeFetchError: "خطأ في جلب بيانات الموظف",
    holidaysFetchFailed: "فشل في جلب طلبات الإجازات",
    holidaysFetchError: "خطأ في جلب طلبات الإجازات",
    weeklyAttendanceFailed: "فشل تحميل بيانات الحضور الأسبوعي",
    weeklyAttendanceError: "حدث خطأ أثناء تحميل بيانات الحضور",
    todayAttendanceFailed: "فشل تحميل بيانات حضور اليوم",
    todayAttendanceError: "حدث خطأ أثناء تحميل بيانات حضور اليوم",
    selectMonth: "يرجى تحديد الشهر",
    payslipDownloadSuccess: "تم تحميل كشف الراتب بنجاح",
    noPayslipMonths: "لا توجد أشهر بها كشف راتب حتى الآن",
    payrollDataRequired: "يرجى التأكد من وجود بيانات الراتب والشهر",
    markPaidSuccess: "تم تسجيل الراتب كمدفوع بنجاح",
    documentsPage: {
      title: "مستنداتي",
      description: "عرض وإدارة المستندات الخاصة بك",
      fetchFailed: "فشل في جلب المستندات",
      noDocuments: "لا توجد مستندات",
      noDocumentsAvailable: "لا توجد مستندات متاحة للعرض حالياً",
      noDescription: "لا يوجد وصف",
      untitled: "مستند بدون عنوان",
      unknown: "غير معروف",
      view: "عرض",
      viewUnavailable: "عرض غير متاح",
      download: "تحميل",
      successKeyword: "نجاح",
      upload: "رفع",
      uploading: "جاري الرفع...",
      uploadSuccess: "تم رفع المستند بنجاح",
      uploadFailed: "فشل في رفع المستند",
      uploadToManagement: "رفع مستند للإدارة",
      uploadToManagementHint: "أرسل مستندًا ليصل إلى الأدمن أو المدير",
      descriptionOptional: "الوصف (اختياري)",
      titleRequired: "عنوان المستند مطلوب قبل اختيار الملف",
      titleRequiredPlaceholder: "عنوان المستند (مطلوب)",
      fromManagement: "من الإدارة",
      uploadedByMe: "الملفات التي رفعتها",
      noFromManagement: "لا توجد مستندات مرسلة من الإدارة بعد",
      noUploadedByMe: "لم ترفع أي مستندات بعد"
    },
    salaryPage: {
      manageTitle: "إدارة الراتب والمزايا",
      manageDesc: "إدارة الراتب والمكافآت والخصومات للموظف",
      markAsPaid: "تسجيل الراتب كمدفوع",
      noDataForMonth: "لا توجد بيانات راتب متاحة لهذا الشهر. يرجى التواصل مع الإدارة.",
      noData: "لا توجد بيانات راتب متاحة.",
      displayError: "حدث خطأ في عرض بيانات الراتب",
      displayErrorHint: "يرجى تحديث الصفحة أو التواصل مع الدعم الفني",
      monthlyFixed: "المبلغ الثابت الشهري",
      monthlyBonuses: "المكافآت الشهرية",
      monthlyDeductions: "خصومات شهرية: {amount}",
      remainingAfterPartial: "المبلغ المتبقي للاستلام بعد الدفعات الجزئية",
      paidAmount: "المبلغ المدفوع: {amount}",
      fromDailySalary: "من الراتب اليومي",
      dailyRate: "الراتب اليومي (÷ أيام العمل)",
      hourlyRate: "الراتب بالساعة (÷ 8)",
      finalNetSalary: "صافي الراتب النهائي",
      cash: "نقدي",
      fullyPaid: "مدفوع بالكامل",
      byUser: "بواسطة: {user} في {date}",
      earnings: "الإيرادات",
      totalEarnings: "إجمالي الإيرادات:",
      totalDeductionsColon: "إجمالي الخصومات:",
      baseSalaryColon: "الراتب الأساسي:",
      netSalaryColon: "صافي الراتب:",
      bonusesAllowances: "المكافآت والحوافز و البدلات:",
      allowancesColon: "البدلات:",
      deductionsColon: "الخصومات:",
      monthlyLateHours: "ساعات التأخير الشهري",
      totalInDays: "إجمالي في {days} يوم",
      deductionPerHour: "معدل الخصم/ساعة",
      monthDeduction: "خصم الشهر",
      actualWorkDays: "أيام العمل الفعلية (بدون عطل):",
      daysCount: "{count} يوم"
    },
    ui: {
      overview: "نظرة عامة",
      attendanceCheckout: "الحضور والانصراف",
      skillsAndCertificates: "المهارات و الشهادات",
      messaging: "مراسله",
      myDocuments: "مستنداتي",
      holidays: "الإجازات",
      tasks: "المهام",
      welcome: "مرحباً،",
      employeeNumber: "رقم الموظف:",
      joined: "انضمام:",
      directManager: "المدير المباشر:",
      todayStatus: "حالة اليوم",
      checkInLabel: "دخول:",
      netSalary: "الراتب الصافي",
      attendanceRate: "نسبة الحضور",
      performanceRating: "تقييم الأداء",
      todayBreakTime: "وقت الاستراحة اليوم",
      currentlyOnBreak: "في استراحة حالياً",
      completedTasks: "المهام المكتملة",
      recentNotifications: "الإشعارات الحديثة",
      recentRequests: "الطلبات الأخيرة",
      attendanceStatus: "حالة الحضور",
      status: "الحالة:",
      totalTime: "إجمالي الوقت:",
      activeTime: "وقت النشاط:",
      idleTime: "وقت عدم النشاط:",
      checkIn: "تسجيل الحضور",
      checkOut: "تسجيل الانصراف",
      checkInEmoji: "🟢 تسجيل الحضور",
      checkOutEmoji: "🔴 تسجيل الانصراف",
      break: "استراحة",
      startBreak: "بدء الاستراحة",
      endBreak: "إنهاء الاستراحة",
      breakNotes: "ملاحظات الاستراحة",
      breakNotesCount: "ملاحظات الاستراحة ({count})",
      viewBreakNotes: "عرض ملاحظات الاستراحات ({count} ملاحظة)",
      breakDuration: "مدة الاستراحة:",
      breakTime: "وقت الاستراحة:",
      currentlyOnBreakColon: "في استراحة حالياً:",
      startedAt: "بدأت الساعة:",
      workingAlready: "العمل جاري بالفعل",
      workingInProgress: "العمل جاري...",
      onBreakHint: "في استراحة...",
      canStartWorkNow: "يمكنك بدء العمل الآن",
      workingCanPauseOrBreak: "العمل جاري - يمكنك الإيقاف المؤقت أو الاستراحة",
      workPausedCanResumeOrEnd: "العمل متوقف مؤقتاً - يمكنك الاستكمال أو الإنهاء",
      onBreakCanEndOrWork: "في استراحة - يمكنك إنهاء الاستراحة أو العمل",
      canControlFromHere: "يمكنك التحكم في التطبيق من هنا",
      onTime: "في الوقت",
      late: "متأخر",
      absent: "غائب",
      onBreak: "في استراحة",
      present: "حاضر في الموعد",
      weekend: "عطلة أسبوعية",
      unavailable: "غير متوفر",
      holiday: "عطلة",
      leave: "إجازة",
      officialHoliday: "إجازة رسمية",
      offline: "غير متصل",
      connected: "متصل",
      activeWorking: "نشط - يعمل حالياً",
      paused: "إيقاف مؤقت",
      connectedReady: "متصل - جاهز للعمل",
      appStatus: "حالة التطبيق",
      todayWorkTime: "وقت العمل اليوم:",
      productivity: "الإنتاجية:",
      workPausedHint: "العمل متوقف مؤقتاً - يمكنك الاستكمال أو الإنهاء",
      appReadyHint: "التطبيق متصل وجاهز لبدء العمل",
      appOfflineHint: "التطبيق غير متصل - يرجى تشغيل تطبيق سطح المكتب",
      timeTracking: "تتبع الوقت",
      refresh: "تحديث",
      retry: "إعادة المحاولة",
      verifyMatch: "تحقق من التطابق",
      updateTodayRecord: "تحديث سجل اليوم",
      endWork: "إنهاء العمل",
      resumeWork: "استكمال العمل",
      startWork: "بدء العمل",
      pause: "إيقاف مؤقت",
      resume: "استكمال",
      remoteControl: "التحكم عن بُعد",
      useDesktopAppHint: "استخدم التطبيق المكتبي للحصول على أفضل تجربة تتبع",
      todayActivity: "النشاط اليوم",
      productivityRate: "نسبة الإنتاجية:",
      lastActivity: "آخر نشاط:",
      noActivityToday: "لا يوجد نشاط اليوم",
      monitoring: "المراقبة",
      monitoringMode: "وضع المراقبة:",
      active: "نشط",
      screenshots: "لقطات الشاشة",
      recentScreenshots: "لقطات الشاشة الأخيرة",
      noScreenshots: "لا توجد لقطات شاشة متاحة",
      ensureDesktopRunning: "تأكد من تشغيل تطبيق سطح المكتب",
      syncing: "جاري المزامنة...",
      syncNow: "مزامنة البيانات الآن",
      totalBreakTime: "إجمالي وقت الاستراحة",
      lastImage: "آخر صورة:",
      view: "عرض",
      noImages: "لا توجد صور",
      connectedNow: "متصل حالياً",
      verifyDataMatch: "التحقق من تطابق البيانات",
      clear: "مسح",
      export: "تصدير",
      viewOnlyNoClear: "للمشاهدة فقط - لا يمكن المسح",
      updateMonth: "تحديث الشهر",
      date: "التاريخ",
      day: "اليوم",
      remainingTime: "الوقت المتبقي",
      productivityCol: "الإنتاجية",
      statusCol: "الحالة",
      dataCol: "البيانات",
      today: "اليوم",
      weeklyStats: "إحصائيات الأسبوع",
      avgProductivity: "متوسط الإنتاجية",
      totalWork: "إجمالي العمل",
      workDays: "أيام العمل",
      hours: "ساعة",
      minutes: "دقيقة",
      detailedDailyLog: "جدول سجل الأيام التفصيلي",
      notLoggedIn: "لم يتم تسجيل الدخول",
      pleaseLogin: "يرجى تسجيل الدخول للوصول إلى هذه الصفحة",
      loadingData: "جاري تحميل البيانات...",
      pleaseWait: "يرجى الانتظار",
      loadingTrackingData: "جاري تحميل بيانات التتبع...",
      fetchingLatestFromDesktop: "يتم جلب أحدث البيانات من التطبيق المكتبي",
      fetchDataError: "خطأ في جلب البيانات",
      verifyAndSyncTitle: "التحقق من تطابق البيانات ومزامنتها",
      createUpdateTodayRecordTitle: "إنشاء/تحديث سجل اليوم",
      desktopTimeTrackingApp: "تطبيق تتبع الوقت المكتبي",
      desktopAppFeatures: "تتبع دقيق للوقت • تحليل الإنتاجية • إدارة المهام",
      completelyFree: "مجاني تماماً",
      easyToUse: "سهل الاستخدام",
      instantSync: "تزامن فوري",
      downloadApp: "تحميل التطبيق",
      compatibleWithOs: "متوافق مع Windows, Mac, Linux",
      weeklyStatsDesc: "تتبع ساعات العمل والإنتاجية خلال الأسبوع الماضي",
      productivityRateLabel: "نسبة الإنتاجية",
      workTimeLabel: "وقت العمل",
      activeTimeLabel: "وقت النشاط",
      dayLabel: "يوم {day}",
      productivityPercentLabel: "نسبة الإنتاجية %",
      workTimeHoursLabel: "وقت العمل (ساعة)",
      activeTimeHoursLabel: "وقت النشاط (ساعة)",
      filters: "فلاتر",
      screenshotsProtectedDesc: "يتم أخذ لقطات عشوائية كل فترة لضمان الحضور الفعلي - البيانات محمية ولا يمكن مسحها",
      search: "بحث",
      searchImagesPlaceholder: "البحث في الصور...",
      activityType: "نوع النشاط",
      allActivities: "جميع الأنشطة",
      activeWork: "عمل نشط",
      idle: "خمول",
      timePeriod: "الفترة الزمنية",
      allTimes: "جميع الأوقات",
      morningRange: "صباح (6 ص - 12 ظ)",
      afternoonRange: "ظهر (12 ظ - 6 م)",
      eveningRange: "مساء (6 م - 6 ص)",
      productivityLevel: "مستوى الإنتاجية",
      allLevels: "جميع المستويات",
      highProductivity: "عالي (80%+)",
      mediumProductivity: "متوسط (50%-80%)",
      lowProductivity: "منخفض (أقل من 50%)",
      dateRange: "النطاق الزمني",
      fromDate: "من تاريخ",
      toDate: "إلى تاريخ",
      reset: "إعادة تعيين",
      ofImages: "{filtered} من {total} صورة",
      applyFilters: "تطبيق المرشحات",
      totalImagesCount: "إجمالي الصور: {count}",
      pageOf: "الصفحة {current} من {total}",
      showingRange: "عرض {start}-{end} من {total}",
      screenshotN: "لقطة {n}",
      screenshot: "لقطة شاشة",
      workActivity: "نشاط عمل",
      previous: "السابق",
      next: "التالي",
      liveConnected: "مربوط مباشر",
      sameAppData: "نفس بيانات التطبيق",
      updateMonthTitle: "تحديث جميع سجلات الشهر (بما في ذلك اليوم الحالي) من بيانات التطبيق",
      liveConnectedDesc: "مربوط مباشر مع تطبيق سطح المكتب - البيانات متطابقة 100% مع التطبيق (إجمالي، نشاط، خمول، استراحة)",
      loadingOrDefaultData: "جاري تحميل البيانات أو استخدام البيانات الافتراضية",
      showingDefaultData: "يتم عرض البيانات الافتراضية - تأكد من تشغيل التطبيق المكتبي",
      zeroMinutes: "0 دقيقة",
      hoursAndMinutes: "{hours} ساعة {minutes} دقيقة",
      minutesOnly: "{minutes} دقيقة",
      completed: "مكتمل",
      fromApp: "تطبيق",
      none: "لا توجد",
      realDataDays: "أيام بيانات حقيقية",
      totalWorkHours: "إجمالي ساعات العمل",
      totalActiveHours: "إجمالي ساعات النشاط",
      totalIdleTime: "إجمالي وقت الخمول",
      dailyLogLinkedToDb: "جدول سجل الأيام التفصيلي مربوط مباشرة مع قاعدة البيانات",
      dataMatch100: "البيانات متطابقة 100%:",
      dataMatchExample: "لو التطبيق يظهر 4 دقائق وقت كلي و 2 دقيقة نشط، ستجد نفس الأرقام هنا في الجدول",
      totalTimeBullet: "إجمالي الوقت:",
      totalTimeBulletDesc: "نفس الرقم الموجود في التطبيق تماماً",
      activeTimeBullet: "وقت النشاط:",
      activeTimeBulletDesc: "نفس وقت النشاط في التطبيق",
      idleTimeBullet: "وقت الخمول:",
      idleTimeBulletDesc: "نفس وقت الخمول المحسوب في التطبيق",
      breakTimeBullet: "وقت الاستراحة:",
      breakTimeBulletDesc: "نفس وقت الاستراحة إذا تم أخذ فترات راحة",
      updateTodayBullet: "زر \"تحديث اليوم\":",
      updateTodayBulletDesc: "يحدث سجل اليوم الحالي فقط من بيانات التطبيق",
      updateMonthBullet: "زر \"تحديث الشهر\":",
      updateMonthBulletDesc: "يحدث جميع سجلات الشهر الحالي من بيانات التطبيق",
      appIndicatorBullet: "مؤشر تطبيق:",
      appIndicatorBulletDesc: "يظهر للأيام التي تحتوي على بيانات حقيقية من التطبيق",
      desktopMonitoringGuide: "إرشادات نظام مراقبة سطح المكتب",
      desktopMonitoringGuideDesc: "دليل شامل لاستخدام نظام مراقبة الحضور والإنتاجية",
      basicRequirements: "المتطلبات الأساسية",
      desktopApp: "تطبيق سطح المكتب",
      desktopAppDesc: "تحميل وتثبيت التطبيق على جهاز العمل المخصص",
      stableInternet: "اتصال إنترنت مستقر",
      stableInternetDesc: "لضمان مزامنة البيانات مع الخادم",
      login: "تسجيل الدخول",
      loginDesc: "استخدام نفس بيانات تسجيل الدخول للموقع",
      monitoringAndTracking: "المراقبة والتتبع",
      autoActivityTracking: "تتبع النشاط التلقائي",
      autoActivityTrackingDesc: "مراقبة حركة الماوس ولوحة المفاتيح لحساب وقت العمل الفعلي",
      randomScreenshots: "لقطات الشاشة العشوائية",
      randomScreenshotsDesc: "كل 10-30 دقيقة للتحقق من الحضور الفعلي - محمية من المسح",
      productivityCalculation: "حساب نسبة الإنتاجية",
      productivityCalculationDesc: "بناءً على نسبة الوقت النشط إلى الوقت الإجمالي",
      activeAppRequired: "شرط التطبيق النشط",
      activeAppRequiredDesc: "لا يمكن تسجيل الحضور من الموقع إلا بوجود التطبيق متصل",
      dualCheckIn: "التسجيل المزدوج",
      dualCheckInDesc: "يمكن التسجيل من التطبيق أو الموقع (بشرط اتصال التطبيق)",
      preciseTiming: "التوقيت الدقيق",
      preciseTimingDesc: "تسجيل دقيق لأوقات الدخول والخروج والفترات الزمنية",
      privacyAndSecurity: "الخصوصية والأمان",
      protectedData: "بيانات محمية",
      protectedDataDesc: "جميع البيانات مشفرة ومحمية وفقاً لمعايير الأمان",
      viewOnly: "مشاهدة فقط",
      viewOnlyDesc: "يمكن للموظف مشاهدة لقطات الشاشة الخاصة به فقط",
      cannotDelete: "عدم إمكانية المسح",
      cannotDeleteDesc: "البيانات محمية ولا يمكن حذفها من قبل الموظف",
      importantNotice: "تنبيه مهم",
      importantNoticeDesc: "نظام المراقبة مصمم لضمان العدالة والشفافية في بيئة العمل. جميع البيانات تُستخدم لأغراض إدارية فقط ومحمية بأعلى معايير الخصوصية. في حالة وجود أي استفسارات، يرجى التواصل مع قسم الموارد البشرية.",
      screenshotGallery: "معرض لقطات الشاشة ({count})",
      galleryFilters: "فلاتر المعرض",
      galleryDesc: "جميع الصور التي تم التقاطها أثناء العمل - مع إمكانية التصفح والفلترة",
      galleryImagesCount: "معرض الصور: {count} صورة",
      clickToViewFull: "انقر على أي صورة لعرضها بالحجم الكامل",
      screenshotTitle: "لقطة شاشة - {timestamp}",
      close: "إغلاق",
      screenshotPreview: "معاينة لقطة الشاشة",
      activityColon: "النشاط:",
      imageProtected: "هذه الصورة محمية ولا يمكن تحميلها أو مسحها",
      noDataAvailable: "لا توجد بيانات متاحة",
      noEmployeeProfile: "لا يوجد ملف موظف مرتبط بحسابك حالياً.",
      noEmployeeProfileContactAdmin: "لا يوجد ملف موظف مرتبط بحسابك حالياً. يرجى التواصل مع الإدارة لإضافة ملف الموظف.",
      noEmployeeFile: "لا يوجد ملف موظف",
      adminNoEmployeeFile: "أنت مسجل كمسؤول ولا يوجد لديك ملف موظف مرتبط بحسابك.",
      needEmployeeFileAccess: "للوصول إلى معلومات الموظف، يجب أن يكون لديك ملف موظف مرتبط بحسابك.",
      backToDashboard: "العودة إلى لوحة التحكم",
      breakReason: "سبب الاستراحة",
      breakReasonPrompt: "اكتب سبب أخذ الاستراحة (اختياري):",
      breakReasonPlaceholder: "مثال: وقت الغداء، استراحة قهوة، مكالمة هاتفية...",
      noBreakNotes: "لا توجد ملاحظات استراحة محفوظة",
      breakNotesWillAppear: "ستظهر هنا ملاحظات الاستراحات التي تسجلها",
      totalBreaksLogged: "إجمالي الاستراحات المسجلة:",
      deleteThisNote: "حذف هذه الملاحظة",
      confirmDeleteAllBreakNotes: "هل أنت متأكد من حذف جميع ملاحظات الاستراحة؟",
      deleteAllNotes: "حذف جميع الملاحظات",
      work: "عمل",
      zeroMinShort: "0د",
      minShort: "{m}د",
      hourShort: "{h}س",
      hourMinShort: "{h}س {m}د",
      zeroHoursMinutes: "0 ساعة 0 دقيقة",
      verifyDataMatchDetailedTitle: "التحقق من تطابق البيانات بين التطبيق والجدول التفصيلي",
      unspecified: "غير محدد",
      loadPartialDataFailed: "فشل في تحميل بعض البيانات",
      months: {
        1: "يناير",
        2: "فبراير",
        3: "مارس",
        4: "أبريل",
        5: "مايو",
        6: "يونيو",
        7: "يوليو",
        8: "أغسطس",
        9: "سبتمبر",
        10: "أكتوبر",
        11: "نوفمبر",
        12: "ديسمبر"
      }
    },
    msg: {
      companyGroup: "مجموعة الشركة",
      readOnly: "للقراءة فقط",
      title: "رسائلي المرسلة",
      underDevelopment: "مازالت تحت التطوير ...!",
      loading: "جاري تحميل الرسائل...",
      aiEnabled: "الذكاء الاصطناعي: مفعل",
      aiDisabled: "الذكاء الاصطناعي: معطل",
      enableAi: "تفعيل وضع الذكاء الاصطناعي",
      disableAi: "تعطيل وضع الذكاء الاصطناعي",
      sentCount: "{count} رسالة مرسلة",
      sortNewest: "الأحدث",
      sortOldest: "الأقدم",
      sortAria: "ترتيب الرسائل",
      searchAria: "بحث في الرسائل",
      emptyTitle: "لا توجد رسائل مرسلة بعد",
      emptyHint: "الرسائل التي ترسلها ستظهر هنا.",
      noContent: "لا يوجد محتوى متاح",
      languageLabel: "لغة: {lang}",
      sendFailed: "فشل في الإرسال",
      aiFeatures: "ميزات الذكاء الاصطناعي",
      translateTo: "ترجم إلى لغة:",
      languagePlaceholder: "اكتب اللغة (مثال: English)",
      translate: "ترجمة",
      messagePlaceholder: "اكتب رسالتك المهنية هنا...",
      messageAria: "إدخال رسالة جديدة",
      improveTitle: "تحسين الرسالة لغوياً",
      translateToTitle: "ترجمة إلى {lang}",
      sendAria: "إرسال الرسالة",
      translateError: "خطأ في ترجمة الرسالة",
      improveError: "خطأ في تحسين الرسالة",
      invalidDate: "تاريخ غير صالح",
      invalidToken: "رمز التوثيق غير صالح أو مفقود",
      unauthorized: "غير مصرح: رجاء تسجيل الدخول مرة أخرى",
      badRequest: "طلب غير صالح",
      sendFailedStatus: "فشل في إرسال الرسالة: {status}",
      sendSuccess: "تم إرسال الرسالة بنجاح",
      sendUnknownError: "خطأ غير معروف أثناء إرسال الرسالة",
      you: "أنت",
      hrTitle: "إعلانات الموارد البشرية",
      loadingChat: "جاري تحميل المحادثة...",
      noSearchResults: "لا توجد رسائل لـ \"{term}\"",
      noSearchHint: "جرّب مصطلح بحث آخر أو امسح البحث.",
      noAnnouncements: "لا توجد إعلانات بعد",
      noAnnouncementsHint: "ستظهر هنا الرسائل من المسؤولين.",
      unknownSender: "مرسل غير معروف",
      employeesOnlySend: "فقط الموظفين يستطيعون الارسال",
      selectLanguage: "اختر اللغة",
      customLanguagePlaceholder: "أدخل لغة مخصصة (مثال: Italian)",
      searchPlaceholder: "ابحث في الرسائل بالنص أو التاريخ (مثال: 'مارس 2023')",
      translatedTo: "تمت الترجمة إلى {lang}:",
      read: "مقروء",
      unread: "غير مقروء",
      newest: "الأحدث",
      oldest: "الأقدم",
      toggleSearch: "إظهار/إخفاء البحث",
      toggleTranslate: "إظهار/إخفاء الترجمة",
      sortBy: "ترتيب الرسائل",
      selectTranslateAll: "اختر لغة لترجمة كل الرسائل",
      selectTranslateOne: "اختر لغة لترجمة الرسالة",
      submitLanguage: "تأكيد اللغة",
      submitCustomLanguage: "تأكيد اللغة المخصصة",
      toggleTranslateDropdown: "إظهار قائمة الترجمة"
    }
  },
  notifications: {
    title: "لوحة الإشعارات",
    fetchFailed: "فشل في جلب الإشعارات",
    fetchError: "حدث خطأ أثناء جلب الإشعارات",
    markReadFailed: "فشل في تحديث حالة الإشعار",
    markAllReadFailed: "فشل في تحديث حالة الإشعارات",
    deleteFailed: "فشل في حذف الإشعار",
    deleteAllFailed: "فشل في حذف جميع الإشعارات",
    noNotifications: "لا توجد إشعارات",
    markAllRead: "قراءة الكل",
    deleteAll: "حذف الكل",
    all: "الكل",
    unread: "غير مقروء",
    read: "مقروء",
    unreadCount: "{count} إشعار غير مقروء"
  },
  employeesPending: {
    selectShiftRequired: "يرجى اختيار شيفت للموظف",
    invalidEmployeeId: "معرف الموظف غير صالح",
    enterAllowanceName: "يرجى إدخال اسم البدل",
    enterValidAllowanceAmount: "يرجى إدخال مبلغ البدل صحيح",
    selectStartDate: "يرجى اختيار تاريخ البدء",
    selectEndDateOrPermanent: "يرجى اختيار تاريخ الانتهاء أو تفعيل الخيار \"بدل دائم\"",
    allowanceAddedToList: "تم إضافة البدل إلى القائمة",
    employeeIdMissing: "معرف الموظف غير موجود",
    selectWorkLocation: "يرجى اختيار موقع العمل",
    enterValidBaseSalary: "يرجى إدخال راتب أساسي صحيح",
    enterValidContractDuration: "يرجى إدخال مدة عقد صحيحة بالأشهر (عدد صحيح أكبر من 0)",
    enterDailyOrders: "يرجى إدخال عدد الطلبات اليومية (يجب أن يكون 1 أو أكثر)",
    enterRejectionReason: "يرجى إدخال سبب الرفض",
    rejectionReasonMin: "سبب الرفض يجب أن يكون 10 أحرف على الأقل",
    rejectionReasonMax: "سبب الرفض طويل جدًا (الحد الأقصى 500 حرف)",
    approveSuccess: "تم الموافقة على الموظف بنجاح",
    rejectSuccess: "تم رفض الموظف بنجاح",
    noEmployeesFound: "لم يتم العثور على بيانات موظفين.",
    fetchEmployeesFailed: "تعذر جلب بيانات الموظفين من الخادم. حاول مرة أخرى.",
    notAuthorizedFetch: "غير مصرح لك بجلب بيانات الموظفين",
    whatsappOpened: "تم فتح WhatsApp Web لإرسال الرسالة إلى {name}",
    whatsappOpenFailed: "حدث خطأ أثناء فتح WhatsApp Web. يرجى المحاولة مرة أخرى.",
    sendWhatsAppMessage: "إرسال رسالة WhatsApp",
    sendWhatsAppTo: "إرسال رسالة WhatsApp إلى {name}",
    confirmApprove: "هل أنت متأكد من الموافقة على هذا الموظف؟",
    approving: "جاري الموافقة...",
    approve: "موافقة",
    rejecting: "جاري الرفض...",
    reject: "رفض",
    pendingApproval: "في انتظار الموافقة",
    approved: "تمت الموافقة",
    rejected: "مرفوض",
    approveFailed: "فشل في الموافقة على الموظف",
    approveError: "حدث خطأ أثناء الموافقة على الموظف"
  },
  companyValidation: {
    htmlInsteadOfJson: "تم استلام استجابة HTML بدلاً من JSON. قد تكون هذه صفحة ngrok. يرجى التحقق من الاتصال.",
    parseResponseFailed: "فشل في تحليل استجابة الخادم",
    corsError: "خطأ في الاتصال بالخادم. يرجى التحقق من إعدادات CORS في الخادم.",
    connectionError: "خطأ في الاتصال بالخادم",
    unknownError: "خطأ غير معروف",
    enterValidCoordinates: "يرجى إدخال إحداثيات صحيحة",
    latitudeRange: "خط العرض يجب أن يكون بين -90 و 90",
    longitudeRange: "خط الطول يجب أن يكون بين -180 و 180",
    browserNoGeolocation: "المتصفح لا يدعم تحديد الموقع",
    getLocationFailed: "فشل في الحصول على الموقع",
    enterBranchName: "يرجى إدخال اسم الفرع",
    branchIdMissing: "معرف الفرع غير موجود",
    noLocationForBranch: "لا يوجد موقع محدد لهذا الفرع",
    invalidOrgIdFormat: "تنسيق معرف المؤسسة غير صحيح. يجب أن يكون بالتنسيق XX-0000 (مثل: DE-5292). يرجى التحقق من إعدادات المؤسسة.",
    orgIdSavedRetry: "تم حفظ معرف المؤسسة. يرجى المحاولة مرة أخرى.",
    enterDepartmentName: "يرجى إدخال اسم القسم",
    enterEquipmentName: "يرجى إدخال اسم الأصل",
    enterValidPrice: "يرجى إدخال سعر صحيح",
    selectEmployeeToAssign: "يرجى اختيار موظف للتعيين",
    selectNewEmployee: "يرجى اختيار موظف جديد للتعيين",
    documentIdMissing: "معرف المستند (publicId) غير موجود",
    selectFileToUpload: "يرجى اختيار ملف للرفع",
    enterToolName: "يرجى إدخال اسم الأداة",
    selectAtLeastOneEmployee: "يرجى اختيار موظف واحد على الأقل"
  },
  deductionsValidation: {
    ruleDelayMinutes: "القاعدة {n}: يجب تحديد دقائق التأخير",
    ruleCustomPenalty: "القاعدة {n}: يجب تحديد مبلغ الغرامة أو أيام الغرامة عند اختيار نوع مخصص"
  },
  taxInsurance: {
    enterDeductionNameInRow: "يرجى إدخال اسم الخصم في الصف {n}",
    amountErrorInRow: "{error} (الصف {n})",
    startBeforeEndInRow: "تاريخ البداية يجب أن يكون قبل تاريخ النهاية في الصف {n}",
    saveSuccess: "تم حفظ إعدادات الضرائب والتأمينات بنجاح",
    saveFailed: "فشل في حفظ البيانات",
    saveError: "حدث خطأ أثناء حفظ البيانات",
    title: "إعدادات الضرائب والتأمينات",
    description: "إدارة الخصومات الثابتة لجميع الموظفين",
    manageHint: "قم بإدارة الخصومات الثابتة مثل الضرائب والتأمينات الاجتماعية والتأمين الصحي",
    viewDetails: "عرض التفاصيل",
    hide: "إخفاء",
    addNewDeduction: "إضافة خصم جديد",
    addFirstDeduction: "إضافة أول خصم",
    deductionN: "خصم #{n}",
    deductionName: "اسم الخصم",
    deductionNamePlaceholder: "مثال: الضرائب، التأمينات الاجتماعية",
    amount: "المبلغ",
    startDate: "تاريخ البداية",
    endDateOptional: "تاريخ النهاية (اتركه فارغاً للخصم الدائم)",
    monthlyTotal: "إجمالي الخصومات الشهرية",
    deductionAmountField: "مبلغ الخصم"
  },
  setup: {
    title: "إعداد النظام",
    subtitle: "هذا الإعداد ضروري لضبط نظامك بشكل صحيح. ننصح بإكمال جميع الخطوات للحصول على أفضل تجربة.",
    skip: "تخطي",
    skipNow: "تخطي الآن",
    cancel: "إلغاء",
    stepLabel: "الخطوة",
    steps: "خطوات",
    next: "التالي",
    back: "السابق",
    finish: "إنهاء",
    saving: "جاري الحفظ...",
    yes: "نعم",
    no: "لا",
    companyInfo: "معلومات الشركة",
    workDaysTimezone: "أيام العمل والمنطقة الزمنية",
    shifts: "الشيفتات",
    shiftsHint: "أضف شيفت عمل واحد على الأقل (مثلاً صباحي) حتى يتمكن الموظفون من تسجيل الحضور بشكل صحيح. يمكنك إضافة المزيد لاحقاً من الإعدادات.",
    shiftsDescription: "عرّف مواعيد العمل في شركتك. شيفت واحد يكفي للبداية؛ أضف أكثر إن كان لديكم ورديات متعددة.",
    shiftsRequired: "يجب إضافة شيفت واحد على الأقل للمتابعة",
    location: "مواقع الشركة",
    branches: "فروع الشركة",
    holidays: "الإجازات الرسمية",
    delaySettings: "إعدادات التأخير",
    approvalsRouting: "مسار الموافقات",
    finishStep: "انتهى الإعداد",
    companyName: "اسم الشركة",
    companyNamePlaceholder: "أدخل اسم الشركة",
    description: "الوصف",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    website: "الموقع الإلكتروني",
    address: "العنوان",
    street: "الشارع",
    workDays: "أيام العمل",
    workDaysHint: "اختر أيام الأسبوع التي تعمل فيها الشركة",
    workDaysTimezoneHint: "أيام العمل والمنطقة الزمنية يؤثران على الحضور والرواتب. تأكد من اختيارهما بدقة.",
    timezone: "المنطقة الزمنية",
    selectTimezone: "اختر المنطقة الزمنية",
    timezoneHint: "اختر المنطقة الزمنية لموقع شركتك",
    locationName: "اسم الموقع",
    locationNamePlaceholder: "مثال: المكتب الرئيسي",
    latitude: "خط العرض",
    longitude: "خط الطول",
    radius: "نصف القطر (متر)",
    useMyLocation: "استخدام موقعي الحالي",
    mainOffice: "المكتب الرئيسي",
    hasBranches: "هل تمتلك شركتك فروعاً؟",
    companyBranches: "فروع الشركة",
    branchName: "اسم الفرع",
    addBranch: "إضافة فرع",
    wantHolidays: "هل تريد إضافة الإجازات الرسمية؟",
    officialHolidays: "الإجازات الرسمية",
    holidayName: "اسم الإجازة",
    date: "التاريخ",
    type: "النوع",
    selectType: "اختر النوع",
    national: "وطني",
    religious: "ديني",
    regional: "إقليمي",
    addHoliday: "إضافة إجازة",
    wantDelay: "هل تريد إضافة إعدادات التأخير؟",
    enableLatePenalties: "تفعيل غرامات التأخير",
    delayMinutes: "دقائق التأخير (من بداية الشيفت)",
    delayMinutesFromShiftStart: "ملاحظة: الدقائق تُحسب من بداية الشيفت — وليست بعد فترة السماح.",
    delayGraceHint: "فترة السماح الحالية في الشيفتات: {grace} دقيقة. أول قاعدة خصم مقترحة: بعد {suggested} دقيقة من بداية الشيفت.",
    delayMinutesHelp: "يجب أن تكون أكبر من فترة السماح ({grace}) — الحد الأدنى {min}.",
    delayMustExceedGrace: "القاعدة {n}: دقائق التأخير ({delay}) يجب أن تكون أكبر من فترة السماح ({grace}) — كلاهما من بداية الشيفت",
    delayMinutesRequired: "القاعدة {n}: أدخل دقائق تأخير صالحة (1 فأكثر)",
    penaltyType: "نوع الغرامة",
    selectPenaltyType: "اختر نوع الغرامة",
    quarterDay: "ربع يوم",
    halfDay: "نصف يوم",
    fullDay: "يوم كامل",
    setupComplete: "تم إعداد حسابك بنجاح",
    setupCompleteHint: "يمكنك العودة لإكمال أو تعديل الإعدادات لاحقاً من صفحة الإعدادات",
    geolocationNotSupported: "المتصفح لا يدعم تحديد الموقع",
    locationSet: "تم تحديد الموقع",
    getLocationFailed: "فشل الحصول على الموقع",
    saveSuccess: "تم الحفظ بنجاح",
    saveFailed: "فشل الحفظ",
    enterBranchName: "أدخل اسم الفرع",
    branchAdded: "تم إضافة الفرع",
    addBranchFailed: "فشل إضافة الفرع",
    enterNameAndDate: "أدخل الاسم والتاريخ",
    holidayAdded: "تم إضافة الإجازة",
    addHolidayFailed: "فشل إضافة الإجازة",
    delaySaved: "تم حفظ إعدادات التأخير",
    delaySaveFailed: "فشل حفظ إعدادات التأخير",
    approvalsRoutingQuestion: "إلى من تُرسل طلبات الإجازات والأذونات (مثل الانصراف المبكر)؟",
    approvalsRoutingHint: "إن لم تختر، الافتراضي هو قائد الفريق. المدير يمكنه لاحقاً سحب أي طلب من التيم ليدر عند الحاجة.",
    approvalsToTeamLeader: "قائد الفريق (موصى به)",
    approvalsToTeamLeaderDesc: "تُرسل الطلبات لتيم ليدر القسم للموافقة أو الرفض. المدير لا يتدخل إلا بعد سحب الصلاحية (Take Over).",
    approvalsToAdmin: "المدير فقط",
    approvalsToAdminDesc: "تُرسل كل طلبات الإجازات والأذونات مباشرة للمدير للموافقة أو الرفض.",
    sunday: "الأحد",
    monday: "الإثنين",
    tuesday: "الثلاثاء",
    wednesday: "الأربعاء",
    thursday: "الخميس",
    friday: "الجمعة",
    saturday: "السبت"
  },
  signup: {
    title: "إنشاء حساب جديد",
    subtitle: "انضم إلى نظام إدارة الموارد البشرية",
    formTitle: "إنشاء حساب جديد",
    formSubtitle: "أدخل بياناتك لإنشاء حساب في النظام",
    username: "اسم المستخدم",
    usernamePlaceholder: "أدخل اسم المستخدم",
    firstName: "الاسم الأول",
    firstNamePlaceholder: "إدخال الاسم الأول",
    lastName: "الاسم الأخير",
    lastNamePlaceholder: "أدخل الاسم الأخير",
    email: "البريد الإلكتروني",
    emailPlaceholder: "أدخل البريد الإلكتروني",
    phone: "رقم الهاتف",
    phonePlaceholder: "أدخل رقم الهاتف",
    department: "القسم",
    selectDepartment: "اختر القسم",
    loadingDepartments: "جاري تحميل الأقسام...",
    role: "المسمي الموظيفي",
    selectRole: "اختر المسمي الموظيفي",
    trainee: "متدرب",
    employee: "موظف",
    orgId: "رمز المؤسسة",
    orgIdHint: "أدخل كود الشركة (XX-0000) لتحميل الأقسام",
    enterOrgIdFirst: "أدخل كود الشركة أولاً",
    nationalId: "رقم الهوية الوطنية",
    nationalIdPlaceholder: "أدخل رقم الهوية الوطنية",
    gender: "الجنس",
    selectGender: "اختر الجنس",
    male: "ذكر",
    female: "أنثى",
    idFront: "صورة واجهة الهوية",
    idBack: "صورة ظهر الهوية",
    password: "كلمة المرور",
    passwordPlaceholder: "أدخل كلمة المرور",
    confirmPassword: "تأكيد كلمة المرور",
    confirmPasswordPlaceholder: "أعد إدخال كلمة المرور",
    createAccount: "إنشاء الحساب",
    creating: "جاري إنشاء الحساب...",
    alreadyHaveAccount: "لديك حساب بالفعل؟",
    login: "تسجيل الدخول",
    joinHr: "انضم إلى نظام إدارة الموارد البشرية",
    featureDataTitle: "إدارة البيانات",
    featureDataDesc: "تحديث وإدارة بياناتك الشخصية",
    featureSalaryTitle: "متابعة الراتب",
    featureSalaryDesc: "تتبع الراتب والبدلات والخصومات",
    featureLeaveTitle: "طلب الإجازات",
    featureLeaveDesc: "تقديم طلبات الإجازة ومتابعتها",
    featureReportsTitle: "التقارير",
    featureReportsDesc: "عرض التقارير والإحصائيات",
    validationUsername: "يرجى إدخال اسم المستخدم",
    validationEmail: "يرجى إدخال البريد الإلكتروني",
    validationEmailInvalid: "يرجى إدخال بريد إلكتروني صحيح",
    validationPasswordLength: "كلمة المرور مطلوبة",
    validationPasswordMax: "كلمة المرور يجب ألا تتجاوز 128 حرفاً",
    passwordTooCommon: "كلمة المرور شائعة جداً. اختر كلمة أقوى",
    validationOrgId: "يرجى إدخال كود مؤسسة صحيح (XX-0000)",
    validationPasswordMismatch: "كلمة المرور وتأكيدها غير متطابقتين",
    validationFirstName: "يرجى إدخال الاسم الأول",
    validationLastName: "يرجى إدخال الاسم الأخير",
    validationPhone: "يرجى إدخال رقم هاتف صحيح",
    validationDepartment: "يرجى اختيار القسم",
    validationRole: "يرجى اختيار المسمي الموظيفي",
    validationNationalId: "يرجى إدخال رقم الهوية الوطنية",
    validationGender: "يرجى اختيار الجنس",
    validationIdFront: "يرجى رفع صورة واجهة الهوية",
    validationIdBack: "يرجى رفع صورة ظهر الهوية",
    successFallback: "تم إنشاء الحساب بنجاح! في انتظار موافقة الإدارة.",
    errorFallback: "حدث خطأ أثناء إنشاء الحساب",
    identifierExists: "يوجد حساب بنفس البريد أو الهاتف أو اسم المستخدم أو الرقم القومي",
    departmentsLoadFailed: "فشل تحميل الأقسام",
    departmentsFetchError: "خطأ في جلب الأقسام. يرجى المحاولة لاحقاً."
  },
  payrollStats: {
    title: "إحصائيات كشوفات الرواتب",
    fetchTitle: "جلب إحصائيات الرواتب",
    monthOrYear: "الشهر أو السنة",
    datePlaceholder: "اختر سنة أو شهر وسنة",
    selectMonthYear: "اختر شهر وسنة",
    selectYearOnly: "اختر سنة فقط",
    dateHint: "اختر سنة (مثال: 2024) أو شهر وسنة (مثال: 2024-08). الشهر يظهر دائمًا بصيغة رقمين (01 إلى 12).",
    fetchStats: "جلب الإحصائيات",
    willFetchMonth: "سيتم جلب إحصائيات شهر {period}",
    willFetchYear: "سيتم جلب إحصائيات عام {period}",
    selectDateError: "يرجى اختيار سنة أو شهر وسنة",
    authError: "رمز المصادقة غير صالح. يرجى تسجيل الدخول مجددًا.",
    serverError: "خطأ في الاتصال بالخادم: {status}",
    fetchFailed: "فشل في جلب إحصائيات الرواتب",
    invalidResponse: "بيانات الاستجابة غير صالحة",
    fetchSuccess: "تم جلب إحصائيات الرواتب بنجاح",
    notAvailable: "غير متوفر",
    unspecified: "غير محدد",
    employeesInfo: "معلومات الموظفين",
    totalEmployees: "إجمالي الموظفين:",
    withPayroll: "مع كشوفات:",
    withoutPayroll: "بدون كشوفات:",
    financialInfo: "المعلومات المالية",
    totalSalaries: "إجمالي الرواتب:",
    totalPaid: "المبلغ المدفوع:",
    totalRemaining: "المبلغ المتبقي:",
    percentagePaid: "نسبة الدفع:",
    statusSummary: "ملخص الحالات",
    paid: "مدفوع:",
    partiallyPaid: "مدفوع جزئيًا:",
    pending: "معلق:",
    processing: "قيد المعالجة:",
    cancelled: "ملغى:",
    noStatusData: "لا توجد بيانات توزيع الحالات",
    payrollPeriod: "فترة الرواتب",
    selectedMonth: "الشهر المحدد",
    selectedYear: "السنة المحددة",
    unspecifiedPeriod: "فترة غير محددة",
    months: {
      "01": "يناير",
      "02": "فبراير",
      "03": "مارس",
      "04": "أبريل",
      "05": "مايو",
      "06": "يونيو",
      "07": "يوليو",
      "08": "أغسطس",
      "09": "سبتمبر",
      "10": "أكتوبر",
      "11": "نوفمبر",
      "12": "ديسمبر"
    }
  },
  leader: {
    employeeUpdateForm: {
      title: "تحديث بيانات الموظف",
      name: "الاسم",
      namePlaceholder: "أدخل الاسم",
      email: "البريد الإلكتروني",
      emailPlaceholder: "أدخل البريد الإلكتروني",
      phone: "رقم الهاتف",
      phonePlaceholder: "أدخل رقم الهاتف",
      department: "القسم",
      departmentPlaceholder: "أدخل القسم",
      position: "المنصب",
      positionPlaceholder: "أدخل المنصب",
      address: "العنوان",
      addressPlaceholder: "أدخل العنوان",
      nationalID: "رقم الهوية الوطنية",
      nationalIDPlaceholder: "أدخل رقم الهوية الوطنية",
      baseSalary: "الراتب الأساسي (ريال)",
      baseSalaryPlaceholder: "أدخل الراتب الأساسي",
      experience: "الخبرة",
      experiencePlaceholder: "أدخل تفاصيل الخبرة",
      education: "التعليم",
      educationPlaceholder: "أدخل تفاصيل التعليم",
      skills: "المهارات (مفصولة بفواصل)",
      skillsPlaceholder: "أدخل المهارات (مثال: js, python)",
      deductions: "الخصومات",
      socialInsurance: "التأمين الاجتماعي (ريال)",
      socialInsurancePlaceholder: "أدخل التأمين الاجتماعي",
      tax: "الضريبة (ريال)",
      taxPlaceholder: "أدخل الضريبة",
      fetchFailed: "فشل في جلب بيانات الموظف",
      updateSuccess: "تم تحديث بيانات الموظف بنجاح",
      updateFailed: "فشل في تحديث بيانات الموظف",
      updating: "جارٍ التحديث...",
      submit: "تحديث بيانات الموظف"
    }
  },
  phone3d: {
    title: "شاهد TeamIN في العمل",
    subtitle: "استكشف تطبيق الجوال على جهاز Samsung — الدردشة وتسجيل الحضور",
    loading: "جاري تحميل العرض...",
    dragHint: "اسحب لتدوير الجهاز"
  }
};
